/* tslint:disable */
/* eslint-disable */
/**
 * support
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface API
 */
export interface API {
    /**
     * 
     * @type {string}
     * @memberof API
     */
    '_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof API
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof API
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof API
     */
    'allowedIps': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof API
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'line1': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'line2': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country': string;
    /**
     * 
     * @type {GeoLocation}
     * @memberof Address
     */
    'geo'?: GeoLocation;
}
/**
 * A citation within the message that points to a specific quote from a specific File associated with the assistant or the message. Generated when the assistant uses the \"file_search\" tool to search files.
 * @export
 * @interface Annotation
 */
export interface Annotation {
    /**
     * 
     * @type {number}
     * @memberof Annotation
     */
    'end_index': number;
    /**
     * 
     * @type {FileCitationAnnotationFileCitation}
     * @memberof Annotation
     */
    'file_citation': FileCitationAnnotationFileCitation;
    /**
     * 
     * @type {number}
     * @memberof Annotation
     */
    'start_index': number;
    /**
     * The text in the message content that needs to be replaced.
     * @type {string}
     * @memberof Annotation
     */
    'text': string;
    /**
     * Always `file_citation`.
     * @type {string}
     * @memberof Annotation
     */
    'type': AnnotationTypeEnum;
    /**
     * 
     * @type {FilePathAnnotationFilePath}
     * @memberof Annotation
     */
    'file_path': FilePathAnnotationFilePath;
}

export const AnnotationTypeEnum = {
    Citation: 'file_citation',
    Path: 'file_path'
} as const;

export type AnnotationTypeEnum = typeof AnnotationTypeEnum[keyof typeof AnnotationTypeEnum];

/**
 * 
 * @export
 * @interface AppSettings
 */
export interface AppSettings {
    /**
     * 
     * @type {SMTPSettings}
     * @memberof AppSettings
     */
    'smtp': SMTPSettings;
    /**
     * 
     * @type {FirewallSettings}
     * @memberof AppSettings
     */
    'firewall': FirewallSettings;
    /**
     * 
     * @type {OpenAISettings}
     * @memberof AppSettings
     */
    'openai': OpenAISettings;
    /**
     * 
     * @type {FtpSettings}
     * @memberof AppSettings
     */
    'ftp': FtpSettings;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSettings
     */
    'cities': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSettings
     */
    'taskTypes': Array<string>;
    /**
     * Customer tickets only: create, response, status, close, and reminder.
     * @type {boolean}
     * @memberof AppSettings
     */
    'customerTicketEmails': boolean;
    /**
     * 
     * @type {AppSettingsForwardEmails}
     * @memberof AppSettings
     */
    'forwardEmails': AppSettingsForwardEmails;
    /**
     * 
     * @type {AppSettingsMessages}
     * @memberof AppSettings
     */
    'messages': AppSettingsMessages;
}
/**
 * 
 * @export
 * @interface AppSettingsForwardEmails
 */
export interface AppSettingsForwardEmails {
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSettingsForwardEmails
     */
    'vouchers': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSettingsForwardEmails
     */
    'subscriptions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSettingsForwardEmails
     */
    'ftp': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSettingsForwardEmails
     */
    'users': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSettingsForwardEmails
     */
    'firewall': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSettingsForwardEmails
     */
    'itemReminder': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSettingsForwardEmails
     */
    'items': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSettingsForwardEmails
     */
    'tasks': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSettingsForwardEmails
     */
    'customerTickets': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSettingsForwardEmails
     */
    'tickets': Array<string>;
}
/**
 * 
 * @export
 * @interface AppSettingsMessages
 */
export interface AppSettingsMessages {
    /**
     * 
     * @type {VoucherMessages}
     * @memberof AppSettingsMessages
     */
    'vouchers': VoucherMessages;
    /**
     * 
     * @type {SubscriptionMessages}
     * @memberof AppSettingsMessages
     */
    'subscriptions': SubscriptionMessages;
    /**
     * 
     * @type {FtpMessages}
     * @memberof AppSettingsMessages
     */
    'ftp': FtpMessages;
    /**
     * 
     * @type {UserMessages}
     * @memberof AppSettingsMessages
     */
    'users': UserMessages;
    /**
     * 
     * @type {PrintMessages}
     * @memberof AppSettingsMessages
     */
    'print': PrintMessages;
    /**
     * 
     * @type {ItemMessages}
     * @memberof AppSettingsMessages
     */
    'items': ItemMessages;
    /**
     * 
     * @type {FirewallMessages}
     * @memberof AppSettingsMessages
     */
    'firewall': FirewallMessages;
    /**
     * 
     * @type {TaskMessages}
     * @memberof AppSettingsMessages
     */
    'tasks': TaskMessages;
    /**
     * 
     * @type {TicketMessages}
     * @memberof AppSettingsMessages
     */
    'tickets': TicketMessages;
}
/**
 * 
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'name': string;
    /**
     * 
     * @type {AttachmentType}
     * @memberof Attachment
     */
    'type': AttachmentType;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'path': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AttachmentType = {
    Image: 'image',
    Pdf: 'pdf',
    Other: 'other'
} as const;

export type AttachmentType = typeof AttachmentType[keyof typeof AttachmentType];


/**
 * 
 * @export
 * @interface AuthorizationData
 */
export interface AuthorizationData {
    /**
     * 
     * @type {string}
     * @memberof AuthorizationData
     */
    'token': string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthorizationData
     */
    'mustActivate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AuthorizationData
     */
    'otpRequired': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AuthorizationData
     */
    'emailConfirmationRequired': boolean;
    /**
     * 
     * @type {User}
     * @memberof AuthorizationData
     */
    'user': User;
}
/**
 * 
 * @export
 * @interface Branding
 */
export interface Branding {
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    'domain': string;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    'shortname': string;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    'favicon': string;
    /**
     * 
     * @type {LogoObject}
     * @memberof Branding
     */
    'logo': LogoObject;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    'whatWeDo': string;
    /**
     * 
     * @type {BrandingLinks}
     * @memberof Branding
     */
    'links': BrandingLinks;
    /**
     * 
     * @type {BrandingContact}
     * @memberof Branding
     */
    'contact': BrandingContact;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    'themeColor': string;
}
/**
 * 
 * @export
 * @interface BrandingContact
 */
export interface BrandingContact {
    /**
     * 
     * @type {string}
     * @memberof BrandingContact
     */
    'mapEmbed': string;
    /**
     * 
     * @type {string}
     * @memberof BrandingContact
     */
    'whatsappLabel': string;
    /**
     * 
     * @type {string}
     * @memberof BrandingContact
     */
    'whatsapp': string;
    /**
     * 
     * @type {string}
     * @memberof BrandingContact
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof BrandingContact
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof BrandingContact
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface BrandingLinks
 */
export interface BrandingLinks {
    /**
     * 
     * @type {WebLink}
     * @memberof BrandingLinks
     */
    'youtube': WebLink;
    /**
     * 
     * @type {WebLink}
     * @memberof BrandingLinks
     */
    'x': WebLink;
    /**
     * 
     * @type {WebLink}
     * @memberof BrandingLinks
     */
    'linkedin': WebLink;
    /**
     * 
     * @type {WebLink}
     * @memberof BrandingLinks
     */
    'instagram': WebLink;
    /**
     * 
     * @type {WebLink}
     * @memberof BrandingLinks
     */
    'facebook': WebLink;
    /**
     * 
     * @type {WebLink}
     * @memberof BrandingLinks
     */
    'website': WebLink;
}
/**
 * 
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'name': string;
    /**
     * 
     * @type {Array<Address>}
     * @memberof Company
     */
    'addresses': Array<Address>;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'regNo': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Company
     */
    'emails': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Company
     */
    'phones': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'extRef': string;
}
/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'middleName': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Contact
     */
    'phones': Array<string>;
    /**
     * 
     * @type {Array<Address>}
     * @memberof Contact
     */
    'addresses': Array<Address>;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'position': string;
    /**
     * 
     * @type {Company}
     * @memberof Contact
     */
    'company'?: Company;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'extRef': string;
}
/**
 * 
 * @export
 * @interface CreateAPIBody
 */
export interface CreateAPIBody {
    /**
     * 
     * @type {boolean}
     * @memberof CreateAPIBody
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateAPIBody
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAPIBody
     */
    'allowedIps': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateAPIBody
     */
    'user': string;
}
/**
 * 
 * @export
 * @interface CreateAskAiBody
 */
export interface CreateAskAiBody {
    /**
     * 
     * @type {string}
     * @memberof CreateAskAiBody
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface CreateAssistantBody
 */
export interface CreateAssistantBody {
    /**
     * 
     * @type {string}
     * @memberof CreateAssistantBody
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssistantBody
     */
    'threadId': string;
}
/**
 * 
 * @export
 * @interface CreateCompanyBody
 */
export interface CreateCompanyBody {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyBody
     */
    'name': string;
    /**
     * 
     * @type {Array<Address>}
     * @memberof CreateCompanyBody
     */
    'addresses': Array<Address>;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyBody
     */
    'regNo': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCompanyBody
     */
    'emails': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCompanyBody
     */
    'phones': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyBody
     */
    'extRef': string;
}
/**
 * 
 * @export
 * @interface CreateContactBody
 */
export interface CreateContactBody {
    /**
     * 
     * @type {string}
     * @memberof CreateContactBody
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactBody
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactBody
     */
    'middleName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactBody
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateContactBody
     */
    'phones': Array<string>;
    /**
     * 
     * @type {Array<Address>}
     * @memberof CreateContactBody
     */
    'addresses': Array<Address>;
    /**
     * 
     * @type {string}
     * @memberof CreateContactBody
     */
    'position': string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactBody
     */
    'extRef': string;
}
/**
 * 
 * @export
 * @interface CreateDepartmentBody
 */
export interface CreateDepartmentBody {
    /**
     * 
     * @type {string}
     * @memberof CreateDepartmentBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDepartmentBody
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDepartmentBody
     */
    'users': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDepartmentBody
     */
    'administrative': boolean;
}
/**
 * 
 * @export
 * @interface CreateFilterViewBody
 */
export interface CreateFilterViewBody {
    /**
     * 
     * @type {string}
     * @memberof CreateFilterViewBody
     */
    'name': string;
    /**
     * 
     * @type {LogModel}
     * @memberof CreateFilterViewBody
     */
    'model': LogModel;
    /**
     * 
     * @type {string}
     * @memberof CreateFilterViewBody
     */
    'search': string;
    /**
     * 
     * @type {Array<Filter>}
     * @memberof CreateFilterViewBody
     */
    'filters': Array<Filter>;
}


/**
 * 
 * @export
 * @interface CreateItemBody
 */
export interface CreateItemBody {
    /**
     * 
     * @type {string}
     * @memberof CreateItemBody
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateItemBody
     */
    'type': CreateItemBodyTypeEnum;
    /**
     * 
     * @type {CreateItemBodyLocation}
     * @memberof CreateItemBody
     */
    'location'?: CreateItemBodyLocation;
    /**
     * 
     * @type {string}
     * @memberof CreateItemBody
     */
    'docRef': string;
    /**
     * 
     * @type {CreateItemBodyHandIn}
     * @memberof CreateItemBody
     */
    'handIn'?: CreateItemBodyHandIn;
}

export const CreateItemBodyTypeEnum = {
    Invoice: 'invoice',
    Delivery: 'delivery'
} as const;

export type CreateItemBodyTypeEnum = typeof CreateItemBodyTypeEnum[keyof typeof CreateItemBodyTypeEnum];

/**
 * 
 * @export
 * @interface CreateItemBodyHandIn
 */
export interface CreateItemBodyHandIn {
    /**
     * 
     * @type {string}
     * @memberof CreateItemBodyHandIn
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface CreateItemBodyLocation
 */
export interface CreateItemBodyLocation {
    /**
     * 
     * @type {string}
     * @memberof CreateItemBodyLocation
     */
    'city': string;
    /**
     * 
     * @type {number}
     * @memberof CreateItemBodyLocation
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof CreateItemBodyLocation
     */
    'longitude': number;
    /**
     * 
     * @type {string}
     * @memberof CreateItemBodyLocation
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface CreateMessageTestBody
 */
export interface CreateMessageTestBody {
    /**
     * 
     * @type {string}
     * @memberof CreateMessageTestBody
     */
    'testEmail': string;
    /**
     * Message key, for example `tickets.onCreate`.
     * @type {string}
     * @memberof CreateMessageTestBody
     */
    'template': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageTestBody
     */
    'audience': CreateMessageTestBodyAudienceEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageTestBody
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageTestBody
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageTestBody
     */
    'body': string;
}

export const CreateMessageTestBodyAudienceEnum = {
    Direct: 'direct',
    Forward: 'forward'
} as const;

export type CreateMessageTestBodyAudienceEnum = typeof CreateMessageTestBodyAudienceEnum[keyof typeof CreateMessageTestBodyAudienceEnum];

/**
 * 
 * @export
 * @interface CreateNotificationSubscriptionBody
 */
export interface CreateNotificationSubscriptionBody {
    /**
     * 
     * @type {string}
     * @memberof CreateNotificationSubscriptionBody
     */
    'browserId': string;
    /**
     * 
     * @type {CreateNotificationSubscriptionBodySubscription}
     * @memberof CreateNotificationSubscriptionBody
     */
    'subscription': CreateNotificationSubscriptionBodySubscription;
}
/**
 * 
 * @export
 * @interface CreateNotificationSubscriptionBodySubscription
 */
export interface CreateNotificationSubscriptionBodySubscription {
    /**
     * 
     * @type {CreateNotificationSubscriptionBodySubscriptionKeys}
     * @memberof CreateNotificationSubscriptionBodySubscription
     */
    'keys'?: CreateNotificationSubscriptionBodySubscriptionKeys;
    /**
     * 
     * @type {number}
     * @memberof CreateNotificationSubscriptionBodySubscription
     */
    'expirationTime'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateNotificationSubscriptionBodySubscription
     */
    'endpoint'?: string;
}
/**
 * 
 * @export
 * @interface CreateNotificationSubscriptionBodySubscriptionKeys
 */
export interface CreateNotificationSubscriptionBodySubscriptionKeys {
    /**
     * 
     * @type {string}
     * @memberof CreateNotificationSubscriptionBodySubscriptionKeys
     */
    'auth': string;
    /**
     * 
     * @type {string}
     * @memberof CreateNotificationSubscriptionBodySubscriptionKeys
     */
    'p256dh': string;
}
/**
 * 
 * @export
 * @interface CreateProductBody
 */
export interface CreateProductBody {
    /**
     * 
     * @type {string}
     * @memberof CreateProductBody
     */
    'itemCode': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBody
     */
    'group': string;
    /**
     * 
     * @type {number}
     * @memberof CreateProductBody
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBody
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductBody
     */
    'extRef': string;
}
/**
 * 
 * @export
 * @interface CreateRecordBody
 */
export interface CreateRecordBody {
    /**
     * 
     * @type {string}
     * @memberof CreateRecordBody
     */
    'type': CreateRecordBodyTypeEnum;
    /**
     * IPv4 or IPv6 address
     * @type {string}
     * @memberof CreateRecordBody
     */
    'ip': string;
    /**
     * CIDR prefix length: 0-32 for IPv4, 0-128 for IPv6
     * @type {number}
     * @memberof CreateRecordBody
     */
    'prefix': number;
}

export const CreateRecordBodyTypeEnum = {
    Blacklist: 'blacklist',
    Whitelist: 'whitelist'
} as const;

export type CreateRecordBodyTypeEnum = typeof CreateRecordBodyTypeEnum[keyof typeof CreateRecordBodyTypeEnum];

/**
 * 
 * @export
 * @interface CreateRegisteredUser200Response
 */
export interface CreateRegisteredUser200Response {
    /**
     * 
     * @type {any}
     * @memberof CreateRegisteredUser200Response
     */
    'message': any;
    /**
     * 
     * @type {User}
     * @memberof CreateRegisteredUser200Response
     */
    'data': User;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRegisteredUser200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CreateRegisteredUserBody
 */
export interface CreateRegisteredUserBody {
    /**
     * 
     * @type {string}
     * @memberof CreateRegisteredUserBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegisteredUserBody
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegisteredUserBody
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegisteredUserBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegisteredUserBody
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegisteredUserBody
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface CreateSetupBody
 */
export interface CreateSetupBody {
    /**
     * 
     * @type {CreateSetupBodySettings}
     * @memberof CreateSetupBody
     */
    'settings': CreateSetupBodySettings;
    /**
     * 
     * @type {CreateSetupBodyAdmin}
     * @memberof CreateSetupBody
     */
    'admin': CreateSetupBodyAdmin;
}
/**
 * 
 * @export
 * @interface CreateSetupBodyAdmin
 */
export interface CreateSetupBodyAdmin {
    /**
     * 
     * @type {string}
     * @memberof CreateSetupBodyAdmin
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSetupBodyAdmin
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSetupBodyAdmin
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSetupBodyAdmin
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface CreateSetupBodySettings
 */
export interface CreateSetupBodySettings {
    /**
     * 
     * @type {FtpSettings}
     * @memberof CreateSetupBodySettings
     */
    'ftp'?: FtpSettings;
    /**
     * 
     * @type {OpenAISettings}
     * @memberof CreateSetupBodySettings
     */
    'openAi'?: OpenAISettings;
    /**
     * 
     * @type {SMTPSettings}
     * @memberof CreateSetupBodySettings
     */
    'smtp'?: SMTPSettings;
}
/**
 * 
 * @export
 * @interface CreateSummarizeBody
 */
export interface CreateSummarizeBody {
    /**
     * 
     * @type {string}
     * @memberof CreateSummarizeBody
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface CreateTaskBody
 */
export interface CreateTaskBody {
    /**
     * 
     * @type {string}
     * @memberof CreateTaskBody
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTaskBody
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTaskBody
     */
    'taskType': string;
}
/**
 * 
 * @export
 * @interface CreateTaskProductBody
 */
export interface CreateTaskProductBody {
    /**
     * 
     * @type {Array<TaskProduct>}
     * @memberof CreateTaskProductBody
     */
    'products': Array<TaskProduct>;
}
/**
 * 
 * @export
 * @interface CreateTaskTimeLogBody
 */
export interface CreateTaskTimeLogBody {
    /**
     * 
     * @type {number}
     * @memberof CreateTaskTimeLogBody
     */
    'startDate': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTaskTimeLogBody
     */
    'endDate'?: number;
}
/**
 * 
 * @export
 * @interface CreateTaskUserBody
 */
export interface CreateTaskUserBody {
    /**
     * 
     * @type {string}
     * @memberof CreateTaskUserBody
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface CreateTicketAssigneeBody
 */
export interface CreateTicketAssigneeBody {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketAssigneeBody
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface CreateTicketBody
 */
export interface CreateTicketBody {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketBody
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketBody
     */
    'person'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketBody
     */
    'number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketBody
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketBody
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketBody
     */
    'details': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketBody
     */
    'city': string;
    /**
     * 
     * @type {TicketPriorityEnum}
     * @memberof CreateTicketBody
     */
    'priority': TicketPriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketBody
     */
    'departmentId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketBody
     */
    'voucherId'?: string;
}


/**
 * 
 * @export
 * @interface CreateTicketPrintBody
 */
export interface CreateTicketPrintBody {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketPrintBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketPrintBody
     */
    'language': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTicketPrintBody
     */
    'sendForward': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketPrintBody
     */
    'copyEmail': string;
    /**
     * 
     * @type {CreateTicketPrintPreviewBodySignatures}
     * @memberof CreateTicketPrintBody
     */
    'signatures': CreateTicketPrintPreviewBodySignatures;
}
/**
 * 
 * @export
 * @interface CreateTicketPrintPreview200Response
 */
export interface CreateTicketPrintPreview200Response {
    /**
     * 
     * @type {CreateTicketPrintPreview200ResponseData}
     * @memberof CreateTicketPrintPreview200Response
     */
    'data': CreateTicketPrintPreview200ResponseData;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTicketPrintPreview200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CreateTicketPrintPreview200ResponseData
 */
export interface CreateTicketPrintPreview200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketPrintPreview200ResponseData
     */
    'copy': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketPrintPreview200ResponseData
     */
    'original': string;
}
/**
 * 
 * @export
 * @interface CreateTicketPrintPreviewBody
 */
export interface CreateTicketPrintPreviewBody {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketPrintPreviewBody
     */
    'language': string;
    /**
     * 
     * @type {CreateTicketPrintPreviewBodySignatures}
     * @memberof CreateTicketPrintPreviewBody
     */
    'signatures': CreateTicketPrintPreviewBodySignatures;
}
/**
 * 
 * @export
 * @interface CreateTicketPrintPreviewBodySignatures
 */
export interface CreateTicketPrintPreviewBodySignatures {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketPrintPreviewBodySignatures
     */
    'receiver': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketPrintPreviewBodySignatures
     */
    'giver': string;
}
/**
 * 
 * @export
 * @interface CreateTicketPrintResponse
 */
export interface CreateTicketPrintResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketPrintResponse
     */
    'original': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketPrintResponse
     */
    'copy'?: string;
}
/**
 * 
 * @export
 * @interface CreateTicketResponseBody
 */
export interface CreateTicketResponseBody {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketResponseBody
     */
    'ticketId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketResponseBody
     */
    'content': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTicketResponseBody
     */
    'internalResponse': boolean;
}
/**
 * 
 * @export
 * @interface CreateTranslateBody
 */
export interface CreateTranslateBody {
    /**
     * 
     * @type {string}
     * @memberof CreateTranslateBody
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface CreateUser200Response
 */
export interface CreateUser200Response {
    /**
     * 
     * @type {User}
     * @memberof CreateUser200Response
     */
    'data': User;
    /**
     * 
     * @type {any}
     * @memberof CreateUser200Response
     */
    'message': any;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUser200Response
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CreateUserBody
 */
export interface CreateUserBody {
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    'extRef': string;
    /**
     * 
     * @type {UserRole}
     * @memberof CreateUserBody
     */
    'role': UserRole;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserBody
     */
    'otpEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserBody
     */
    'emailConfirmation': boolean;
}


/**
 * 
 * @export
 * @interface CreateVoucherBody
 */
export interface CreateVoucherBody {
    /**
     * 
     * @type {number}
     * @memberof CreateVoucherBody
     */
    'timeLimit': number;
}
/**
 * 
 * @export
 * @interface CreateWebhookBody
 */
export interface CreateWebhookBody {
    /**
     * 
     * @type {boolean}
     * @memberof CreateWebhookBody
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateWebhookBody
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateWebhookBody
     */
    'events': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateWebhookBody
     */
    'url': string;
    /**
     * 
     * @type {Array<HttpHeader>}
     * @memberof CreateWebhookBody
     */
    'headers': Array<HttpHeader>;
}
/**
 * 
 * @export
 * @interface DashboardData
 */
export interface DashboardData {
    /**
     * 
     * @type {Array<ItemCount>}
     * @memberof DashboardData
     */
    'ticketCount': Array<ItemCount>;
    /**
     * 
     * @type {number}
     * @memberof DashboardData
     */
    'unsolvedTickets': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardData
     */
    'pendingTickets': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardData
     */
    'solvedTickets': number;
    /**
     * 
     * @type {Array<ItemCount>}
     * @memberof DashboardData
     */
    'statusOverview': Array<ItemCount>;
    /**
     * 
     * @type {number}
     * @memberof DashboardData
     */
    'averageResolutionTime': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardData
     */
    'averageFirstResponseTime': number;
    /**
     * 
     * @type {Array<Task>}
     * @memberof DashboardData
     */
    'activeTasks': Array<Task>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DateIndicator = {
    This: 'this',
    Last: 'last'
} as const;

export type DateIndicator = typeof DateIndicator[keyof typeof DateIndicator];


/**
 * 
 * @export
 * @enum {string}
 */

export const DatePeriod = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Year: 'year'
} as const;

export type DatePeriod = typeof DatePeriod[keyof typeof DatePeriod];


/**
 * 
 * @export
 * @enum {string}
 */

export const DateRange = {
    Week: 'week',
    Month: 'month',
    Year: 'year',
    AllTime: 'all_time'
} as const;

export type DateRange = typeof DateRange[keyof typeof DateRange];


/**
 * 
 * @export
 * @interface Department
 */
export interface Department {
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'description': string;
    /**
     * 
     * @type {Array<LogUser>}
     * @memberof Department
     */
    'users': Array<LogUser>;
    /**
     * 
     * @type {boolean}
     * @memberof Department
     */
    'administrative': boolean;
    /**
     * 
     * @type {number}
     * @memberof Department
     */
    'date': number;
}
/**
 * 
 * @export
 * @interface EmailSetting
 */
export interface EmailSetting {
    /**
     * 
     * @type {boolean}
     * @memberof EmailSetting
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof EmailSetting
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof EmailSetting
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof EmailSetting
     */
    'direct': string;
    /**
     * 
     * @type {string}
     * @memberof EmailSetting
     */
    'forward': string;
}
/**
 * A citation within the message that points to a specific quote from a specific File associated with the assistant or the message. Generated when the assistant uses the \"file_search\" tool to search files.
 * @export
 * @interface FileCitationAnnotation
 */
export interface FileCitationAnnotation {
    /**
     * 
     * @type {number}
     * @memberof FileCitationAnnotation
     */
    'end_index': number;
    /**
     * 
     * @type {FileCitationAnnotationFileCitation}
     * @memberof FileCitationAnnotation
     */
    'file_citation': FileCitationAnnotationFileCitation;
    /**
     * 
     * @type {number}
     * @memberof FileCitationAnnotation
     */
    'start_index': number;
    /**
     * The text in the message content that needs to be replaced.
     * @type {string}
     * @memberof FileCitationAnnotation
     */
    'text': string;
    /**
     * Always `file_citation`.
     * @type {string}
     * @memberof FileCitationAnnotation
     */
    'type': FileCitationAnnotationTypeEnum;
}

export const FileCitationAnnotationTypeEnum = {
    FileCitation: 'file_citation'
} as const;

export type FileCitationAnnotationTypeEnum = typeof FileCitationAnnotationTypeEnum[keyof typeof FileCitationAnnotationTypeEnum];

/**
 * 
 * @export
 * @interface FileCitationAnnotationFileCitation
 */
export interface FileCitationAnnotationFileCitation {
    /**
     * The ID of the specific File the citation is from.
     * @type {string}
     * @memberof FileCitationAnnotationFileCitation
     */
    'file_id': string;
}
/**
 * Describes a file, directory or symbolic link.
 * @export
 * @interface FileInfo
 */
export interface FileInfo {
    /**
     * 
     * @type {string}
     * @memberof FileInfo
     */
    'name': string;
    /**
     * 
     * @type {FileType}
     * @memberof FileInfo
     */
    'type': FileType;
    /**
     * 
     * @type {number}
     * @memberof FileInfo
     */
    'size': number;
    /**
     * Unparsed, raw modification date as a string.  If `modifiedAt` is undefined, the FTP server you\'re connected to doesn\'t support the more modern MLSD command for machine-readable directory listings. The older command LIST is then used returning results that vary a lot between servers as the format hasn\'t been standardized. Here, directory listings and especially modification dates were meant to be human-readable first.  Be careful when still trying to parse this by yourself. Parsing dates from listings using LIST is unreliable. This library decides to offer parsed dates only when they\'re absolutely reliable and safe to use e.g. for comparisons.
     * @type {string}
     * @memberof FileInfo
     */
    'rawModifiedAt': string;
    /**
     * Parsed modification date.  Available if the FTP server supports the MLSD command. Only MLSD guarantees dates than can be reliably parsed with the correct timezone and a resolution down to seconds. See `rawModifiedAt` property for the unparsed date that is always available.
     * @type {string}
     * @memberof FileInfo
     */
    'modifiedAt'?: string;
    /**
     * 
     * @type {UnixPermissions}
     * @memberof FileInfo
     */
    'permissions'?: UnixPermissions;
    /**
     * Hard link count if available.
     * @type {number}
     * @memberof FileInfo
     */
    'hardLinkCount'?: number;
    /**
     * Link name for symbolic links if available.
     * @type {string}
     * @memberof FileInfo
     */
    'link'?: string;
    /**
     * Unix group if available.
     * @type {string}
     * @memberof FileInfo
     */
    'group'?: string;
    /**
     * Unix user if available.
     * @type {string}
     * @memberof FileInfo
     */
    'user'?: string;
    /**
     * Unique ID if available.
     * @type {string}
     * @memberof FileInfo
     */
    'uniqueID'?: string;
}


/**
 * A URL for the file that\'s generated when the assistant used the `code_interpreter` tool to generate a file.
 * @export
 * @interface FilePathAnnotation
 */
export interface FilePathAnnotation {
    /**
     * 
     * @type {number}
     * @memberof FilePathAnnotation
     */
    'end_index': number;
    /**
     * 
     * @type {FilePathAnnotationFilePath}
     * @memberof FilePathAnnotation
     */
    'file_path': FilePathAnnotationFilePath;
    /**
     * 
     * @type {number}
     * @memberof FilePathAnnotation
     */
    'start_index': number;
    /**
     * The text in the message content that needs to be replaced.
     * @type {string}
     * @memberof FilePathAnnotation
     */
    'text': string;
    /**
     * Always `file_path`.
     * @type {string}
     * @memberof FilePathAnnotation
     */
    'type': FilePathAnnotationTypeEnum;
}

export const FilePathAnnotationTypeEnum = {
    FilePath: 'file_path'
} as const;

export type FilePathAnnotationTypeEnum = typeof FilePathAnnotationTypeEnum[keyof typeof FilePathAnnotationTypeEnum];

/**
 * 
 * @export
 * @interface FilePathAnnotationFilePath
 */
export interface FilePathAnnotationFilePath {
    /**
     * The ID of the file that was generated.
     * @type {string}
     * @memberof FilePathAnnotationFilePath
     */
    'file_id': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FileType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type FileType = typeof FileType[keyof typeof FileType];


/**
 * 
 * @export
 * @interface Filter
 */
export interface Filter {
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    'field': string;
    /**
     * 
     * @type {FilterValueType}
     * @memberof Filter
     */
    'type': FilterValueType;
    /**
     * 
     * @type {Operator}
     * @memberof Filter
     */
    'operator': Operator;
    /**
     * 
     * @type {FilterDateOptions}
     * @memberof Filter
     */
    'dateOptions'?: FilterDateOptions;
    /**
     * 
     * @type {any}
     * @memberof Filter
     */
    'value': any;
}


/**
 * 
 * @export
 * @interface FilterDateOptions
 */
export interface FilterDateOptions {
    /**
     * 
     * @type {DatePeriod}
     * @memberof FilterDateOptions
     */
    'period': DatePeriod;
    /**
     * 
     * @type {DateIndicator}
     * @memberof FilterDateOptions
     */
    'indicator': DateIndicator;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FilterValueType = {
    Id: 'id',
    String: 'string',
    Number: 'number',
    Boolean: 'boolean',
    List: 'list',
    Date: 'date'
} as const;

export type FilterValueType = typeof FilterValueType[keyof typeof FilterValueType];


/**
 * 
 * @export
 * @interface FilterView
 */
export interface FilterView {
    /**
     * 
     * @type {string}
     * @memberof FilterView
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterView
     */
    'name': string;
    /**
     * 
     * @type {LogModel}
     * @memberof FilterView
     */
    'model': LogModel;
    /**
     * 
     * @type {string}
     * @memberof FilterView
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof FilterView
     */
    'search': string;
    /**
     * 
     * @type {Array<Filter>}
     * @memberof FilterView
     */
    'filters': Array<Filter>;
    /**
     * 
     * @type {string}
     * @memberof FilterView
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterView
     */
    'updatedAt'?: string;
}


/**
 * 
 * @export
 * @interface FirewallMessages
 */
export interface FirewallMessages {
    /**
     * 
     * @type {EmailSetting}
     * @memberof FirewallMessages
     */
    'onBlacklist': EmailSetting;
}
/**
 * 
 * @export
 * @interface FirewallRecord
 */
export interface FirewallRecord {
    /**
     * 
     * @type {string}
     * @memberof FirewallRecord
     */
    '_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof FirewallRecord
     */
    'date': number;
    /**
     * IPv4 or IPv6 address in canonical form
     * @type {string}
     * @memberof FirewallRecord
     */
    'ip': string;
    /**
     * CIDR prefix length: 0-32 for IPv4, 0-128 for IPv6
     * @type {number}
     * @memberof FirewallRecord
     */
    'prefix': number;
    /**
     * 
     * @type {string}
     * @memberof FirewallRecord
     */
    'type': FirewallRecordTypeEnum;
}

export const FirewallRecordTypeEnum = {
    Blacklist: 'blacklist',
    Whitelist: 'whitelist'
} as const;

export type FirewallRecordTypeEnum = typeof FirewallRecordTypeEnum[keyof typeof FirewallRecordTypeEnum];

/**
 * 
 * @export
 * @interface FirewallSettings
 */
export interface FirewallSettings {
    /**
     * 
     * @type {boolean}
     * @memberof FirewallSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof FirewallSettings
     */
    'maximumAttempts': number;
}
/**
 * 
 * @export
 * @interface FtpMessages
 */
export interface FtpMessages {
    /**
     * 
     * @type {EmailSetting}
     * @memberof FtpMessages
     */
    'onFileUpload': EmailSetting;
}
/**
 * 
 * @export
 * @interface FtpSettings
 */
export interface FtpSettings {
    /**
     * 
     * @type {boolean}
     * @memberof FtpSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof FtpSettings
     */
    'host': string;
    /**
     * 
     * @type {number}
     * @memberof FtpSettings
     */
    'port': number;
    /**
     * 
     * @type {string}
     * @memberof FtpSettings
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof FtpSettings
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof FtpSettings
     */
    'secure': boolean;
    /**
     * 
     * @type {string}
     * @memberof FtpSettings
     */
    'uploadPath': string;
}
/**
 * 
 * @export
 * @interface GeoLocation
 */
export interface GeoLocation {
    /**
     * 
     * @type {number}
     * @memberof GeoLocation
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof GeoLocation
     */
    'lng': number;
}
/**
 * 
 * @export
 * @interface GetFilterInterface200Response
 */
export interface GetFilterInterface200Response {
    /**
     * 
     * @type {string}
     * @memberof GetFilterInterface200Response
     */
    'field': string;
    /**
     * 
     * @type {FilterValueType}
     * @memberof GetFilterInterface200Response
     */
    'type': FilterValueType;
    /**
     * 
     * @type {Operator}
     * @memberof GetFilterInterface200Response
     */
    'operator': Operator;
    /**
     * 
     * @type {FilterDateOptions}
     * @memberof GetFilterInterface200Response
     */
    'dateOptions'?: FilterDateOptions;
    /**
     * 
     * @type {object}
     * @memberof GetFilterInterface200Response
     */
    'value': object;
    /**
     * 
     * @type {string}
     * @memberof GetFilterInterface200Response
     */
    'name': GetFilterInterface200ResponseNameEnum;
    /**
     * 
     * @type {FilterValueType}
     * @memberof GetFilterInterface200Response
     */
    'valueType': FilterValueType;
    /**
     * 
     * @type {boolean}
     * @memberof GetFilterInterface200Response
     */
    'sortable'?: boolean;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetFilterInterface200Response
     */
    'defaultSortDirection'?: SortDirection;
    /**
     * 
     * @type {Array<QueryFilterTemplateListOptionsInner>}
     * @memberof GetFilterInterface200Response
     */
    'listOptions'?: Array<QueryFilterTemplateListOptionsInner>;
}

export const GetFilterInterface200ResponseNameEnum = {
    CompanyName: 'Company.Name',
    CompanyRegNo: 'Company.RegNo',
    CompanyEmails: 'Company.Emails',
    CompanyPhones: 'Company.Phones',
    CompanyExtRef: 'Company.ExtRef',
    UsersName: 'Users.Name',
    UsersUsername: 'Users.Username',
    UsersEmail: 'Users.Email',
    UsersPhone: 'Users.Phone',
    UsersCompany: 'Users.Company',
    UsersRole: 'Users.Role',
    UsersExtRef: 'Users.ExtRef',
    LogsUsername: 'Logs.Username',
    LogsDate: 'Logs.Date',
    LogsUser: 'Logs.User',
    LogsModel: 'Logs.Model',
    ProductsName: 'Products.Name',
    ProductsExtRef: 'Products.ExtRef',
    ProductsGroup: 'Products.Group',
    ProductsPrice: 'Products.Price',
    ProductsCurrency: 'Products.Currency',
    ProductsItemCode: 'Products.ItemCode',
    ProductsQuantityInStock: 'Products.QuantityInStock',
    ProductsAmountUsed: 'Products.AmountUsed',
    ContactEmail: 'Contact.Email',
    ContactPhones: 'Contact.Phones',
    ContactExtRef: 'Contact.ExtRef',
    ContactTitle: 'Contact.Title',
    ContactPosition: 'Contact.Position',
    ContactFirstName: 'Contact.FirstName',
    ContactMiddleName: 'Contact.MiddleName',
    ContactLastName: 'Contact.LastName',
    ContactAddressCity: 'Contact.Address.City',
    ContactAddressPostalCode: 'Contact.Address.PostalCode',
    ContactAddressCountry: 'Contact.Address.Country',
    TicketCompany: 'Ticket.Company',
    TicketExtRef: 'Ticket.ExtRef',
    TicketCity: 'Ticket.City',
    TicketTitle: 'Ticket.Title',
    TicketId: 'Ticket.ID',
    TicketDepartment: 'Ticket.Department',
    TicketStatus: 'Ticket.Status',
    TicketDate: 'Ticket.Date',
    TicketPriority: 'Ticket.Priority',
    TicketLocation: 'Ticket.Location',
    TicketPerson: 'Ticket.Person',
    TicketAssignee: 'Ticket.Assignee',
    TicketCallId: 'Ticket.CallID',
    DepartmentName: 'Department.Name',
    DepartmentDescription: 'Department.Description',
    DepartmentDate: 'Department.Date',
    DepartmentAdministrative: 'Department.Administrative',
    FirewallDate: 'Firewall.Date',
    FirewallType: 'Firewall.Type',
    FirewallIp: 'Firewall.IP',
    FirewallPrefix: 'Firewall.Prefix',
    ItemsDescription: 'Items.Description',
    ItemsDate: 'Items.Date',
    ItemsType: 'Items.Type',
    ItemsLocationDescription: 'Items.LocationDescription',
    SubscriptionCode: 'Subscription.Code',
    SubscriptionDate: 'Subscription.Date',
    SubscriptionInvoice: 'Subscription.Invoice'
} as const;

export type GetFilterInterface200ResponseNameEnum = typeof GetFilterInterface200ResponseNameEnum[keyof typeof GetFilterInterface200ResponseNameEnum];

/**
 * 
 * @export
 * @interface HandIn
 */
export interface HandIn {
    /**
     * 
     * @type {string}
     * @memberof HandIn
     */
    '_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof HandIn
     */
    'date': number;
    /**
     * 
     * @type {LogUser}
     * @memberof HandIn
     */
    'user': LogUser;
    /**
     * 
     * @type {string}
     * @memberof HandIn
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface HttpHeader
 */
export interface HttpHeader {
    /**
     * 
     * @type {string}
     * @memberof HttpHeader
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof HttpHeader
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ImageFile
 */
export interface ImageFile {
    /**
     * The [File](https://platform.openai.com/docs/api-reference/files) ID of the image in the message content. Set `purpose=\"vision\"` when uploading the File if you need to later display the file content.
     * @type {string}
     * @memberof ImageFile
     */
    'file_id': string;
    /**
     * Specifies the detail level of the image if specified by the user. `low` uses fewer tokens, you can opt in to high resolution using `high`.
     * @type {string}
     * @memberof ImageFile
     */
    'detail'?: ImageFileDetailEnum;
}

export const ImageFileDetailEnum = {
    Auto: 'auto',
    Low: 'low',
    High: 'high'
} as const;

export type ImageFileDetailEnum = typeof ImageFileDetailEnum[keyof typeof ImageFileDetailEnum];

/**
 * References an image [File](https://platform.openai.com/docs/api-reference/files) in the content of a message.
 * @export
 * @interface ImageFileContentBlock
 */
export interface ImageFileContentBlock {
    /**
     * 
     * @type {ImageFile}
     * @memberof ImageFileContentBlock
     */
    'image_file': ImageFile;
    /**
     * Always `image_file`.
     * @type {string}
     * @memberof ImageFileContentBlock
     */
    'type': ImageFileContentBlockTypeEnum;
}

export const ImageFileContentBlockTypeEnum = {
    ImageFile: 'image_file'
} as const;

export type ImageFileContentBlockTypeEnum = typeof ImageFileContentBlockTypeEnum[keyof typeof ImageFileContentBlockTypeEnum];

/**
 * 
 * @export
 * @interface ImageURL
 */
export interface ImageURL {
    /**
     * The external URL of the image, must be a supported image types: jpeg, jpg, png, gif, webp.
     * @type {string}
     * @memberof ImageURL
     */
    'url': string;
    /**
     * Specifies the detail level of the image. `low` uses fewer tokens, you can opt in to high resolution using `high`. Default value is `auto`
     * @type {string}
     * @memberof ImageURL
     */
    'detail'?: ImageURLDetailEnum;
}

export const ImageURLDetailEnum = {
    Auto: 'auto',
    Low: 'low',
    High: 'high'
} as const;

export type ImageURLDetailEnum = typeof ImageURLDetailEnum[keyof typeof ImageURLDetailEnum];

/**
 * References an image URL in the content of a message.
 * @export
 * @interface ImageURLContentBlock
 */
export interface ImageURLContentBlock {
    /**
     * 
     * @type {ImageURL}
     * @memberof ImageURLContentBlock
     */
    'image_url': ImageURL;
    /**
     * The type of the content part.
     * @type {string}
     * @memberof ImageURLContentBlock
     */
    'type': ImageURLContentBlockTypeEnum;
}

export const ImageURLContentBlockTypeEnum = {
    ImageUrl: 'image_url'
} as const;

export type ImageURLContentBlockTypeEnum = typeof ImageURLContentBlockTypeEnum[keyof typeof ImageURLContentBlockTypeEnum];

/**
 * 
 * @export
 * @interface ImportConfig
 */
export interface ImportConfig {
    /**
     * 
     * @type {boolean}
     * @memberof ImportConfig
     */
    '_id'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportConfig
     */
    'autoSync': boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportConfig
     */
    'url': string;
    /**
     * 
     * @type {Array<HttpHeader>}
     * @memberof ImportConfig
     */
    'headers': Array<HttpHeader>;
    /**
     * 
     * @type {ImportableModel}
     * @memberof ImportConfig
     */
    'model': ImportableModel;
    /**
     * 
     * @type {Array<ImportMapping>}
     * @memberof ImportConfig
     */
    'mapping': Array<ImportMapping>;
}


/**
 * 
 * @export
 * @interface ImportMapping
 */
export interface ImportMapping {
    /**
     * 
     * @type {any}
     * @memberof ImportMapping
     */
    'defaultObject'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof ImportMapping
     */
    'optional': boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportMapping
     */
    'targetPath': string;
    /**
     * 
     * @type {string}
     * @memberof ImportMapping
     */
    'keyPath': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ImportableModel = {
    Product: 'product',
    Contact: 'contact',
    Company: 'company'
} as const;

export type ImportableModel = typeof ImportableModel[keyof typeof ImportableModel];


/**
 * 
 * @export
 * @interface Item
 */
export interface Item {
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'description': string;
    /**
     * 
     * @type {LogUser}
     * @memberof Item
     */
    'user': LogUser;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'type': ItemTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Item
     */
    'date': number;
    /**
     * 
     * @type {Location}
     * @memberof Item
     */
    'location': Location;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'docRef': string;
    /**
     * 
     * @type {HandIn}
     * @memberof Item
     */
    'handIn'?: HandIn;
    /**
     * 
     * @type {boolean}
     * @memberof Item
     */
    'warned': boolean;
}

export const ItemTypeEnum = {
    Invoice: 'invoice',
    Delivery: 'delivery'
} as const;

export type ItemTypeEnum = typeof ItemTypeEnum[keyof typeof ItemTypeEnum];

/**
 * 
 * @export
 * @interface ItemCount
 */
export interface ItemCount {
    /**
     * 
     * @type {string}
     * @memberof ItemCount
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof ItemCount
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ItemMessages
 */
export interface ItemMessages {
    /**
     * 
     * @type {EmailSetting}
     * @memberof ItemMessages
     */
    'onCreate': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof ItemMessages
     */
    'onHandIn': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof ItemMessages
     */
    'onReminder': EmailSetting;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'longitude': number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'latitude': number;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'city': string;
}
/**
 * 
 * @export
 * @interface Log
 */
export interface Log {
    /**
     * 
     * @type {string}
     * @memberof Log
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Log
     */
    'username'?: string;
    /**
     * 
     * @type {LogUser}
     * @memberof Log
     */
    'user'?: LogUser;
    /**
     * 
     * @type {LogModel}
     * @memberof Log
     */
    'model'?: LogModel;
    /**
     * 
     * @type {string}
     * @memberof Log
     */
    'object'?: string;
    /**
     * 
     * @type {string}
     * @memberof Log
     */
    'action': string;
    /**
     * 
     * @type {number}
     * @memberof Log
     */
    'date'?: number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const LogModel = {
    Ticket: 'ticket',
    User: 'user',
    Voucher: 'voucher',
    Item: 'item',
    Department: 'department',
    Product: 'product',
    Record: 'record',
    Api: 'api',
    Webhook: 'webhook',
    Company: 'company',
    Contact: 'contact'
} as const;

export type LogModel = typeof LogModel[keyof typeof LogModel];


/**
 * 
 * @export
 * @interface LogUser
 */
export interface LogUser {
    /**
     * 
     * @type {string}
     * @memberof LogUser
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogUser
     */
    'email': string;
    /**
     * 
     * @type {UserCompany}
     * @memberof LogUser
     */
    'company'?: UserCompany;
    /**
     * 
     * @type {string}
     * @memberof LogUser
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof LogUser
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof LogUser
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof LogUser
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof LogUser
     * @deprecated
     */
    'activationCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogUser
     */
    'activationCodeHash'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogUser
     */
    'activationCodeExpires'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogUser
     */
    'activationCodeSentAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof LogUser
     */
    'passwordChangeCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LogUser
     */
    'emailConfirmation': boolean;
    /**
     * 
     * @type {string}
     * @memberof LogUser
     */
    'emailConfirmationCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LogUser
     */
    'otpEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof LogUser
     */
    'extRef': string;
    /**
     * 
     * @type {string}
     * @memberof LogUser
     */
    'otpSecret'?: string;
    /**
     * 
     * @type {Array<UserPushSubscription>}
     * @memberof LogUser
     */
    'pushSubscriptions': Array<UserPushSubscription>;
    /**
     * 
     * @type {UserContact}
     * @memberof LogUser
     */
    'contact'?: UserContact;
    /**
     * 
     * @type {string}
     * @memberof LogUser
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogUser
     */
    'name': string;
    /**
     * 
     * @type {UserRole}
     * @memberof LogUser
     */
    'role': UserRole;
    /**
     * 
     * @type {boolean}
     * @memberof LogUser
     */
    'active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LogUser
     */
    'deleted': boolean;
}


/**
 * 
 * @export
 * @interface LoginBody
 */
export interface LoginBody {
    /**
     * 
     * @type {string}
     * @memberof LoginBody
     */
    'login': string;
    /**
     * 
     * @type {string}
     * @memberof LoginBody
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface LogoObject
 */
export interface LogoObject {
    /**
     * 
     * @type {string}
     * @memberof LogoObject
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof LogoObject
     */
    'link': string;
}
/**
 * 
 * @export
 * @interface MailAddress
 */
export interface MailAddress {
    /**
     * 
     * @type {string}
     * @memberof MailAddress
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MailAddress
     */
    'address': string;
}
/**
 * 
 * @export
 * @interface Manifest
 */
export interface Manifest {
    /**
     * 
     * @type {string}
     * @memberof Manifest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Manifest
     */
    'short_name': string;
    /**
     * 
     * @type {string}
     * @memberof Manifest
     */
    'start_url': string;
    /**
     * 
     * @type {string}
     * @memberof Manifest
     */
    'display': ManifestDisplayEnum;
    /**
     * 
     * @type {string}
     * @memberof Manifest
     */
    'background_color': string;
    /**
     * 
     * @type {string}
     * @memberof Manifest
     */
    'theme_color': string;
    /**
     * 
     * @type {Array<ManifestIconsInner>}
     * @memberof Manifest
     */
    'icons': Array<ManifestIconsInner>;
}

export const ManifestDisplayEnum = {
    Standalone: 'standalone'
} as const;

export type ManifestDisplayEnum = typeof ManifestDisplayEnum[keyof typeof ManifestDisplayEnum];

/**
 * 
 * @export
 * @interface ManifestIconsInner
 */
export interface ManifestIconsInner {
    /**
     * 
     * @type {string}
     * @memberof ManifestIconsInner
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ManifestIconsInner
     */
    'sizes': string;
    /**
     * 
     * @type {string}
     * @memberof ManifestIconsInner
     */
    'src': string;
}
/**
 * 
 * @export
 * @interface MimeNodeEnvelope
 */
export interface MimeNodeEnvelope {
    /**
     * 
     * @type {MimeNodeEnvelopeFrom}
     * @memberof MimeNodeEnvelope
     */
    'from': MimeNodeEnvelopeFrom;
    /**
     * includes an array of address objects
     * @type {Array<string>}
     * @memberof MimeNodeEnvelope
     */
    'to': Array<string>;
}
/**
 * includes an address object or is set to false
 * @export
 * @interface MimeNodeEnvelopeFrom
 */
export interface MimeNodeEnvelopeFrom {
}
/**
 * 
 * @export
 * @interface MiniCompany
 */
export interface MiniCompany {
    /**
     * 
     * @type {string}
     * @memberof MiniCompany
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof MiniCompany
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MiniCompany
     */
    'regNo': string;
    /**
     * 
     * @type {string}
     * @memberof MiniCompany
     */
    'extRef': string;
}
/**
 * 
 * @export
 * @interface NotificationInstance
 */
export interface NotificationInstance {
    /**
     * 
     * @type {string}
     * @memberof NotificationInstance
     */
    '_id'?: string;
    /**
     * 
     * @type {NotificationInstanceNotification}
     * @memberof NotificationInstance
     */
    'notification': NotificationInstanceNotification;
    /**
     * 
     * @type {Array<User>}
     * @memberof NotificationInstance
     */
    'users': Array<User>;
    /**
     * 
     * @type {number}
     * @memberof NotificationInstance
     */
    'date': number;
}
/**
 * 
 * @export
 * @interface NotificationInstanceNotification
 */
export interface NotificationInstanceNotification {
    /**
     * 
     * @type {string}
     * @memberof NotificationInstanceNotification
     */
    'targetId'?: string;
    /**
     * 
     * @type {NotificationObjModel}
     * @memberof NotificationInstanceNotification
     */
    'targetModel'?: NotificationObjModel;
    /**
     * 
     * @type {string}
     * @memberof NotificationInstanceNotification
     */
    'urlPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationInstanceNotification
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationInstanceNotification
     */
    'title': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationObjModel = {
    Ticket: 'ticket',
    User: 'user'
} as const;

export type NotificationObjModel = typeof NotificationObjModel[keyof typeof NotificationObjModel];


/**
 * References an image [File](https://platform.openai.com/docs/api-reference/files) in the content of a message.
 * @export
 * @interface OpenAIBetaThreadsMessagesMessageContent
 */
export interface OpenAIBetaThreadsMessagesMessageContent {
    /**
     * 
     * @type {ImageFile}
     * @memberof OpenAIBetaThreadsMessagesMessageContent
     */
    'image_file': ImageFile;
    /**
     * Always `image_file`.
     * @type {string}
     * @memberof OpenAIBetaThreadsMessagesMessageContent
     */
    'type': OpenAIBetaThreadsMessagesMessageContentTypeEnum;
    /**
     * 
     * @type {ImageURL}
     * @memberof OpenAIBetaThreadsMessagesMessageContent
     */
    'image_url': ImageURL;
    /**
     * 
     * @type {Text}
     * @memberof OpenAIBetaThreadsMessagesMessageContent
     */
    'text': Text;
    /**
     * 
     * @type {string}
     * @memberof OpenAIBetaThreadsMessagesMessageContent
     */
    'refusal': string;
}

export const OpenAIBetaThreadsMessagesMessageContentTypeEnum = {
    ImageFile: 'image_file',
    ImageUrl: 'image_url',
    Text: 'text',
    Refusal: 'refusal'
} as const;

export type OpenAIBetaThreadsMessagesMessageContentTypeEnum = typeof OpenAIBetaThreadsMessagesMessageContentTypeEnum[keyof typeof OpenAIBetaThreadsMessagesMessageContentTypeEnum];

/**
 * 
 * @export
 * @interface OpenAISettings
 */
export interface OpenAISettings {
    /**
     * 
     * @type {boolean}
     * @memberof OpenAISettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof OpenAISettings
     */
    'apiKey': string;
    /**
     * 
     * @type {string}
     * @memberof OpenAISettings
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof OpenAISettings
     */
    'assistantId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Operator = {
    Eq: 'eq',
    Ne: 'ne',
    Lt: 'lt',
    Lte: 'lte',
    Gt: 'gt',
    Gte: 'gte',
    Regex: 'regex'
} as const;

export type Operator = typeof Operator[keyof typeof Operator];


/**
 * 
 * @export
 * @interface OutputDTO
 */
export interface OutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTO
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTO
     */
    'message'?: string;
    /**
     * 
     * @type {any}
     * @memberof OutputDTO
     */
    'data'?: any;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTO
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOAPI
 */
export interface OutputDTOAPI {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOAPI
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOAPI
     */
    'message'?: string;
    /**
     * 
     * @type {API}
     * @memberof OutputDTOAPI
     */
    'data'?: API;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOAPI
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOAppSettings
 */
export interface OutputDTOAppSettings {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOAppSettings
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOAppSettings
     */
    'message'?: string;
    /**
     * 
     * @type {AppSettings}
     * @memberof OutputDTOAppSettings
     */
    'data'?: AppSettings;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOAppSettings
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOAuthorizationData
 */
export interface OutputDTOAuthorizationData {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOAuthorizationData
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOAuthorizationData
     */
    'message'?: string;
    /**
     * 
     * @type {AuthorizationData}
     * @memberof OutputDTOAuthorizationData
     */
    'data'?: AuthorizationData;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOAuthorizationData
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOBoolean
 */
export interface OutputDTOBoolean {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOBoolean
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOBoolean
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOBoolean
     */
    'data'?: boolean;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOBoolean
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOBranding
 */
export interface OutputDTOBranding {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOBranding
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOBranding
     */
    'message'?: string;
    /**
     * 
     * @type {Branding}
     * @memberof OutputDTOBranding
     */
    'data'?: Branding;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOBranding
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOBrandingOrNull
 */
export interface OutputDTOBrandingOrNull {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOBrandingOrNull
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOBrandingOrNull
     */
    'message'?: string;
    /**
     * 
     * @type {Branding}
     * @memberof OutputDTOBrandingOrNull
     */
    'data'?: Branding | null;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOBrandingOrNull
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOCompany
 */
export interface OutputDTOCompany {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOCompany
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOCompany
     */
    'message'?: string;
    /**
     * 
     * @type {Company}
     * @memberof OutputDTOCompany
     */
    'data'?: Company;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOCompany
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOContact
 */
export interface OutputDTOContact {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOContact
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOContact
     */
    'message'?: string;
    /**
     * 
     * @type {Contact}
     * @memberof OutputDTOContact
     */
    'data'?: Contact;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOContact
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOContactArray
 */
export interface OutputDTOContactArray {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOContactArray
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOContactArray
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Contact>}
     * @memberof OutputDTOContactArray
     */
    'data'?: Array<Contact>;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOContactArray
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOCreateTicketPrintResponse
 */
export interface OutputDTOCreateTicketPrintResponse {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOCreateTicketPrintResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOCreateTicketPrintResponse
     */
    'message'?: string;
    /**
     * 
     * @type {CreateTicketPrintResponse}
     * @memberof OutputDTOCreateTicketPrintResponse
     */
    'data'?: CreateTicketPrintResponse;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOCreateTicketPrintResponse
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTODashboardData
 */
export interface OutputDTODashboardData {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTODashboardData
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTODashboardData
     */
    'message'?: string;
    /**
     * 
     * @type {DashboardData}
     * @memberof OutputDTODashboardData
     */
    'data'?: DashboardData;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTODashboardData
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTODepartment
 */
export interface OutputDTODepartment {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTODepartment
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTODepartment
     */
    'message'?: string;
    /**
     * 
     * @type {Department}
     * @memberof OutputDTODepartment
     */
    'data'?: Department;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTODepartment
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTODepartmentArray
 */
export interface OutputDTODepartmentArray {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTODepartmentArray
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTODepartmentArray
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Department>}
     * @memberof OutputDTODepartmentArray
     */
    'data'?: Array<Department>;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTODepartmentArray
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOFileInfoArray
 */
export interface OutputDTOFileInfoArray {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOFileInfoArray
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOFileInfoArray
     */
    'message'?: string;
    /**
     * 
     * @type {Array<FileInfo>}
     * @memberof OutputDTOFileInfoArray
     */
    'data'?: Array<FileInfo>;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOFileInfoArray
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOFilterView
 */
export interface OutputDTOFilterView {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOFilterView
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOFilterView
     */
    'message'?: string;
    /**
     * 
     * @type {FilterView}
     * @memberof OutputDTOFilterView
     */
    'data'?: FilterView;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOFilterView
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOFilterViewArray
 */
export interface OutputDTOFilterViewArray {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOFilterViewArray
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOFilterViewArray
     */
    'message'?: string;
    /**
     * 
     * @type {Array<FilterView>}
     * @memberof OutputDTOFilterViewArray
     */
    'data'?: Array<FilterView>;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOFilterViewArray
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOFirewallRecord
 */
export interface OutputDTOFirewallRecord {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOFirewallRecord
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOFirewallRecord
     */
    'message'?: string;
    /**
     * 
     * @type {FirewallRecord}
     * @memberof OutputDTOFirewallRecord
     */
    'data'?: FirewallRecord;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOFirewallRecord
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOImportConfig
 */
export interface OutputDTOImportConfig {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOImportConfig
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOImportConfig
     */
    'message'?: string;
    /**
     * 
     * @type {ImportConfig}
     * @memberof OutputDTOImportConfig
     */
    'data'?: ImportConfig;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOImportConfig
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOImportConfigOrNull
 */
export interface OutputDTOImportConfigOrNull {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOImportConfigOrNull
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOImportConfigOrNull
     */
    'message'?: string;
    /**
     * 
     * @type {ImportConfig}
     * @memberof OutputDTOImportConfigOrNull
     */
    'data'?: ImportConfig | null;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOImportConfigOrNull
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOItem
 */
export interface OutputDTOItem {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOItem
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOItem
     */
    'message'?: string;
    /**
     * 
     * @type {Item}
     * @memberof OutputDTOItem
     */
    'data'?: Item;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOItem
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOMiniCompanyArray
 */
export interface OutputDTOMiniCompanyArray {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOMiniCompanyArray
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOMiniCompanyArray
     */
    'message'?: string;
    /**
     * 
     * @type {Array<MiniCompany>}
     * @memberof OutputDTOMiniCompanyArray
     */
    'data'?: Array<MiniCompany>;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOMiniCompanyArray
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTONotificationInstance
 */
export interface OutputDTONotificationInstance {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTONotificationInstance
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTONotificationInstance
     */
    'message'?: string;
    /**
     * 
     * @type {NotificationInstance}
     * @memberof OutputDTONotificationInstance
     */
    'data'?: NotificationInstance;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTONotificationInstance
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOOpenAIBetaThreadsMessagesMessageContentArray
 */
export interface OutputDTOOpenAIBetaThreadsMessagesMessageContentArray {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOOpenAIBetaThreadsMessagesMessageContentArray
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOOpenAIBetaThreadsMessagesMessageContentArray
     */
    'message'?: string;
    /**
     * 
     * @type {Array<OpenAIBetaThreadsMessagesMessageContent>}
     * @memberof OutputDTOOpenAIBetaThreadsMessagesMessageContentArray
     */
    'data'?: Array<OpenAIBetaThreadsMessagesMessageContent>;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOOpenAIBetaThreadsMessagesMessageContentArray
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListCompany
 */
export interface OutputDTOPaginatedListCompany {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListCompany
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListCompany
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListCompany}
     * @memberof OutputDTOPaginatedListCompany
     */
    'data'?: PaginatedListCompany;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListCompany
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListContact
 */
export interface OutputDTOPaginatedListContact {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListContact
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListContact
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListContact}
     * @memberof OutputDTOPaginatedListContact
     */
    'data'?: PaginatedListContact;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListContact
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListDepartment
 */
export interface OutputDTOPaginatedListDepartment {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListDepartment
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListDepartment
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListDepartment}
     * @memberof OutputDTOPaginatedListDepartment
     */
    'data'?: PaginatedListDepartment;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListDepartment
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListFirewallRecord
 */
export interface OutputDTOPaginatedListFirewallRecord {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListFirewallRecord
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListFirewallRecord
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListFirewallRecord}
     * @memberof OutputDTOPaginatedListFirewallRecord
     */
    'data'?: PaginatedListFirewallRecord;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListFirewallRecord
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListItem
 */
export interface OutputDTOPaginatedListItem {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListItem
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListItem
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListItem}
     * @memberof OutputDTOPaginatedListItem
     */
    'data'?: PaginatedListItem;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListItem
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListLog
 */
export interface OutputDTOPaginatedListLog {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListLog
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListLog
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListLog}
     * @memberof OutputDTOPaginatedListLog
     */
    'data'?: PaginatedListLog;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListLog
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListNotificationInstance
 */
export interface OutputDTOPaginatedListNotificationInstance {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListNotificationInstance
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListNotificationInstance
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListNotificationInstance}
     * @memberof OutputDTOPaginatedListNotificationInstance
     */
    'data'?: PaginatedListNotificationInstance;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListNotificationInstance
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListPopulatedAPI
 */
export interface OutputDTOPaginatedListPopulatedAPI {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListPopulatedAPI
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListPopulatedAPI
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListPopulatedAPI}
     * @memberof OutputDTOPaginatedListPopulatedAPI
     */
    'data'?: PaginatedListPopulatedAPI;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListPopulatedAPI
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListProduct
 */
export interface OutputDTOPaginatedListProduct {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListProduct
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListProduct
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListProduct}
     * @memberof OutputDTOPaginatedListProduct
     */
    'data'?: PaginatedListProduct;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListProduct
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListSubscription
 */
export interface OutputDTOPaginatedListSubscription {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListSubscription
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListSubscription
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListSubscription}
     * @memberof OutputDTOPaginatedListSubscription
     */
    'data'?: PaginatedListSubscription;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListSubscription
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListTicket
 */
export interface OutputDTOPaginatedListTicket {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListTicket
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListTicket
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListTicket}
     * @memberof OutputDTOPaginatedListTicket
     */
    'data'?: PaginatedListTicket;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListTicket
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListUser
 */
export interface OutputDTOPaginatedListUser {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListUser
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListUser
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListUser}
     * @memberof OutputDTOPaginatedListUser
     */
    'data'?: PaginatedListUser;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListUser
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListVoucher
 */
export interface OutputDTOPaginatedListVoucher {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListVoucher
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListVoucher
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListVoucher}
     * @memberof OutputDTOPaginatedListVoucher
     */
    'data'?: PaginatedListVoucher;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListVoucher
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListWebhook
 */
export interface OutputDTOPaginatedListWebhook {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListWebhook
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListWebhook
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListWebhook}
     * @memberof OutputDTOPaginatedListWebhook
     */
    'data'?: PaginatedListWebhook;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListWebhook
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPaginatedListWebhookLog
 */
export interface OutputDTOPaginatedListWebhookLog {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPaginatedListWebhookLog
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPaginatedListWebhookLog
     */
    'message'?: string;
    /**
     * 
     * @type {PaginatedListWebhookLog}
     * @memberof OutputDTOPaginatedListWebhookLog
     */
    'data'?: PaginatedListWebhookLog;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPaginatedListWebhookLog
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOPopulatedAPI
 */
export interface OutputDTOPopulatedAPI {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOPopulatedAPI
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOPopulatedAPI
     */
    'message'?: string;
    /**
     * 
     * @type {PopulatedAPI}
     * @memberof OutputDTOPopulatedAPI
     */
    'data'?: PopulatedAPI;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOPopulatedAPI
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOProduct
 */
export interface OutputDTOProduct {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOProduct
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOProduct
     */
    'message'?: string;
    /**
     * 
     * @type {Product}
     * @memberof OutputDTOProduct
     */
    'data'?: Product;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOProduct
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOQueryFilterTemplateArray
 */
export interface OutputDTOQueryFilterTemplateArray {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOQueryFilterTemplateArray
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOQueryFilterTemplateArray
     */
    'message'?: string;
    /**
     * 
     * @type {Array<QueryFilterTemplate>}
     * @memberof OutputDTOQueryFilterTemplateArray
     */
    'data'?: Array<QueryFilterTemplate>;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOQueryFilterTemplateArray
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOQueryFilterTemplateArrayError
 */
export interface OutputDTOQueryFilterTemplateArrayError {
    /**
     * 
     * @type {string}
     * @memberof OutputDTOQueryFilterTemplateArrayError
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof OutputDTOQueryFilterTemplateArrayError
     */
    'code': number;
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOQueryFilterTemplateArrayError
     */
    'ignore'?: boolean;
}
/**
 * 
 * @export
 * @interface OutputDTOSMTPTransportSentMessageInfo
 */
export interface OutputDTOSMTPTransportSentMessageInfo {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOSMTPTransportSentMessageInfo
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOSMTPTransportSentMessageInfo
     */
    'message'?: string;
    /**
     * 
     * @type {SMTPTransportSentMessageInfo}
     * @memberof OutputDTOSMTPTransportSentMessageInfo
     */
    'data'?: SMTPTransportSentMessageInfo;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOSMTPTransportSentMessageInfo
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOSessionRenewal
 */
export interface OutputDTOSessionRenewal {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOSessionRenewal
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOSessionRenewal
     */
    'message'?: string;
    /**
     * 
     * @type {SessionRenewal}
     * @memberof OutputDTOSessionRenewal
     */
    'data'?: SessionRenewal;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOSessionRenewal
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOSetupOutputDTO
 */
export interface OutputDTOSetupOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOSetupOutputDTO
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOSetupOutputDTO
     */
    'message'?: string;
    /**
     * 
     * @type {SetupOutputDTO}
     * @memberof OutputDTOSetupOutputDTO
     */
    'data'?: SetupOutputDTO;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOSetupOutputDTO
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOString
 */
export interface OutputDTOString {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOString
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOString
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOString
     */
    'data'?: string;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOString
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOStringArray
 */
export interface OutputDTOStringArray {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOStringArray
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOStringArray
     */
    'message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OutputDTOStringArray
     */
    'data'?: Array<string>;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOStringArray
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOSubscription
 */
export interface OutputDTOSubscription {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOSubscription
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOSubscription
     */
    'message'?: string;
    /**
     * 
     * @type {Subscription}
     * @memberof OutputDTOSubscription
     */
    'data'?: Subscription;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOSubscription
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOTask
 */
export interface OutputDTOTask {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOTask
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOTask
     */
    'message'?: string;
    /**
     * 
     * @type {Task}
     * @memberof OutputDTOTask
     */
    'data'?: Task;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOTask
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOTicket
 */
export interface OutputDTOTicket {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOTicket
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOTicket
     */
    'message'?: string;
    /**
     * 
     * @type {Ticket}
     * @memberof OutputDTOTicket
     */
    'data'?: Ticket;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOTicket
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOTicketPrintTemplate
 */
export interface OutputDTOTicketPrintTemplate {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOTicketPrintTemplate
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOTicketPrintTemplate
     */
    'message'?: string;
    /**
     * 
     * @type {TicketPrintTemplate}
     * @memberof OutputDTOTicketPrintTemplate
     */
    'data'?: TicketPrintTemplate;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOTicketPrintTemplate
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOTicketPrintTemplateArray
 */
export interface OutputDTOTicketPrintTemplateArray {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOTicketPrintTemplateArray
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOTicketPrintTemplateArray
     */
    'message'?: string;
    /**
     * 
     * @type {Array<TicketPrintTemplate>}
     * @memberof OutputDTOTicketPrintTemplateArray
     */
    'data'?: Array<TicketPrintTemplate>;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOTicketPrintTemplateArray
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOUser
 */
export interface OutputDTOUser {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOUser
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOUser
     */
    'message'?: string;
    /**
     * 
     * @type {User}
     * @memberof OutputDTOUser
     */
    'data'?: User;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOUser
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOUserArray
 */
export interface OutputDTOUserArray {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOUserArray
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOUserArray
     */
    'message'?: string;
    /**
     * 
     * @type {Array<User>}
     * @memberof OutputDTOUserArray
     */
    'data'?: Array<User>;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOUserArray
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOVoucher
 */
export interface OutputDTOVoucher {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOVoucher
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOVoucher
     */
    'message'?: string;
    /**
     * 
     * @type {Voucher}
     * @memberof OutputDTOVoucher
     */
    'data'?: Voucher;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOVoucher
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface OutputDTOWebhook
 */
export interface OutputDTOWebhook {
    /**
     * 
     * @type {boolean}
     * @memberof OutputDTOWebhook
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputDTOWebhook
     */
    'message'?: string;
    /**
     * 
     * @type {Webhook}
     * @memberof OutputDTOWebhook
     */
    'data'?: Webhook;
    /**
     * 
     * @type {OutputDTOQueryFilterTemplateArrayError}
     * @memberof OutputDTOWebhook
     */
    'error'?: OutputDTOQueryFilterTemplateArrayError;
}
/**
 * 
 * @export
 * @interface PaginatedListAny
 */
export interface PaginatedListAny {
    /**
     * 
     * @type {Array<any>}
     * @memberof PaginatedListAny
     */
    'docs': Array<any>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListAny
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListCompany
 */
export interface PaginatedListCompany {
    /**
     * 
     * @type {Array<Company>}
     * @memberof PaginatedListCompany
     */
    'docs': Array<Company>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListCompany
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListContact
 */
export interface PaginatedListContact {
    /**
     * 
     * @type {Array<Contact>}
     * @memberof PaginatedListContact
     */
    'docs': Array<Contact>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListContact
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListDepartment
 */
export interface PaginatedListDepartment {
    /**
     * 
     * @type {Array<Department>}
     * @memberof PaginatedListDepartment
     */
    'docs': Array<Department>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListDepartment
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListFirewallRecord
 */
export interface PaginatedListFirewallRecord {
    /**
     * 
     * @type {Array<FirewallRecord>}
     * @memberof PaginatedListFirewallRecord
     */
    'docs': Array<FirewallRecord>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListFirewallRecord
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListItem
 */
export interface PaginatedListItem {
    /**
     * 
     * @type {Array<Item>}
     * @memberof PaginatedListItem
     */
    'docs': Array<Item>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListItem
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListLog
 */
export interface PaginatedListLog {
    /**
     * 
     * @type {Array<Log>}
     * @memberof PaginatedListLog
     */
    'docs': Array<Log>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListLog
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListNotificationInstance
 */
export interface PaginatedListNotificationInstance {
    /**
     * 
     * @type {Array<NotificationInstance>}
     * @memberof PaginatedListNotificationInstance
     */
    'docs': Array<NotificationInstance>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListNotificationInstance
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListPopulatedAPI
 */
export interface PaginatedListPopulatedAPI {
    /**
     * 
     * @type {Array<PopulatedAPI>}
     * @memberof PaginatedListPopulatedAPI
     */
    'docs': Array<PopulatedAPI>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListPopulatedAPI
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListProduct
 */
export interface PaginatedListProduct {
    /**
     * 
     * @type {Array<Product>}
     * @memberof PaginatedListProduct
     */
    'docs': Array<Product>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListProduct
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListSubscription
 */
export interface PaginatedListSubscription {
    /**
     * 
     * @type {Array<Subscription>}
     * @memberof PaginatedListSubscription
     */
    'docs': Array<Subscription>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListSubscription
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListTicket
 */
export interface PaginatedListTicket {
    /**
     * 
     * @type {Array<Ticket>}
     * @memberof PaginatedListTicket
     */
    'docs': Array<Ticket>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListTicket
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListUser
 */
export interface PaginatedListUser {
    /**
     * 
     * @type {Array<User>}
     * @memberof PaginatedListUser
     */
    'docs': Array<User>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListUser
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListVoucher
 */
export interface PaginatedListVoucher {
    /**
     * 
     * @type {Array<Voucher>}
     * @memberof PaginatedListVoucher
     */
    'docs': Array<Voucher>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListVoucher
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListWebhook
 */
export interface PaginatedListWebhook {
    /**
     * 
     * @type {Array<Webhook>}
     * @memberof PaginatedListWebhook
     */
    'docs': Array<Webhook>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListWebhook
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedListWebhookLog
 */
export interface PaginatedListWebhookLog {
    /**
     * 
     * @type {Array<WebhookLog>}
     * @memberof PaginatedListWebhookLog
     */
    'docs': Array<WebhookLog>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedListWebhookLog
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PaginatedQuery
 */
export interface PaginatedQuery {
    /**
     * 
     * @type {string}
     * @memberof PaginatedQuery
     */
    'sortField'?: string;
    /**
     * 
     * @type {SortDirection}
     * @memberof PaginatedQuery
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {string}
     * @memberof PaginatedQuery
     */
    'search': string;
    /**
     * 
     * @type {string}
     * @memberof PaginatedQuery
     */
    'filters'?: string;
    /**
     * 
     * @type {number}
     * @memberof PaginatedQuery
     */
    'skip': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedQuery
     */
    'limit': number;
}


/**
 * Make all properties in T optional
 * @export
 * @interface PartialImportConfig
 */
export interface PartialImportConfig {
    /**
     * 
     * @type {boolean}
     * @memberof PartialImportConfig
     */
    '_id'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartialImportConfig
     */
    'autoSync'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartialImportConfig
     */
    'url'?: string;
    /**
     * 
     * @type {Array<HttpHeader>}
     * @memberof PartialImportConfig
     */
    'headers'?: Array<HttpHeader>;
    /**
     * 
     * @type {ImportableModel}
     * @memberof PartialImportConfig
     */
    'model'?: ImportableModel;
    /**
     * 
     * @type {Array<ImportMapping>}
     * @memberof PartialImportConfig
     */
    'mapping'?: Array<ImportMapping>;
}


/**
 * 
 * @export
 * @interface PopulatedAPI
 */
export interface PopulatedAPI {
    /**
     * 
     * @type {string}
     * @memberof PopulatedAPI
     */
    '_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopulatedAPI
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof PopulatedAPI
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PopulatedAPI
     */
    'allowedIps': Array<string>;
    /**
     * 
     * @type {PopulatedAPIUser}
     * @memberof PopulatedAPI
     */
    'user'?: PopulatedAPIUser;
    /**
     * 
     * @type {string}
     * @memberof PopulatedAPI
     */
    'key': string;
}
/**
 * 
 * @export
 * @interface PopulatedAPIUser
 */
export interface PopulatedAPIUser {
    /**
     * 
     * @type {string}
     * @memberof PopulatedAPIUser
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedAPIUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedAPIUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedAPIUser
     */
    '_id': string;
}
/**
 * 
 * @export
 * @interface PrintMessages
 */
export interface PrintMessages {
    /**
     * 
     * @type {EmailSetting}
     * @memberof PrintMessages
     */
    'onTicketPrint': EmailSetting;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    '_id'?: string;
    /**
     * 
     * @type {ProductSource}
     * @memberof Product
     */
    'source': ProductSource;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'itemCode': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'group': string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'currency': string;
    /**
     * 
     * @type {Array<ProductWarehouseInfo>}
     * @memberof Product
     */
    'sapWarehouseInfo': Array<ProductWarehouseInfo>;
    /**
     * 
     * @type {Array<ProductWarehouseInfo>}
     * @memberof Product
     */
    'warehouseInfo': Array<ProductWarehouseInfo>;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'totalQuantityInStock'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'totalAmountUsed': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'extRef': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProductSource = {
    Sap: 'SAP',
    Import: 'import',
    Manual: 'manual'
} as const;

export type ProductSource = typeof ProductSource[keyof typeof ProductSource];


/**
 * 
 * @export
 * @interface ProductWarehouseInfo
 */
export interface ProductWarehouseInfo {
    /**
     * 
     * @type {Warehouse}
     * @memberof ProductWarehouseInfo
     */
    'warehouse': Warehouse;
    /**
     * 
     * @type {number}
     * @memberof ProductWarehouseInfo
     */
    'quantityInStock': number;
    /**
     * 
     * @type {number}
     * @memberof ProductWarehouseInfo
     */
    'amountUsed': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductWarehouseInfo
     */
    'serials': Array<string>;
}
/**
 * 
 * @export
 * @interface PushSubscriptionJSON
 */
export interface PushSubscriptionJSON {
    /**
     * 
     * @type {string}
     * @memberof PushSubscriptionJSON
     */
    'endpoint'?: string;
    /**
     * 
     * @type {number}
     * @memberof PushSubscriptionJSON
     */
    'expirationTime'?: number | null;
    /**
     * Construct a type with a set of properties K of type T
     * @type {object}
     * @memberof PushSubscriptionJSON
     */
    'keys'?: object;
}
/**
 * 
 * @export
 * @interface QueryFilterTemplate
 */
export interface QueryFilterTemplate {
    /**
     * 
     * @type {string}
     * @memberof QueryFilterTemplate
     */
    'name': QueryFilterTemplateNameEnum;
    /**
     * 
     * @type {string}
     * @memberof QueryFilterTemplate
     */
    'field': string;
    /**
     * 
     * @type {FilterValueType}
     * @memberof QueryFilterTemplate
     */
    'valueType': FilterValueType;
    /**
     * 
     * @type {boolean}
     * @memberof QueryFilterTemplate
     */
    'sortable'?: boolean;
    /**
     * 
     * @type {SortDirection}
     * @memberof QueryFilterTemplate
     */
    'defaultSortDirection'?: SortDirection;
    /**
     * 
     * @type {Array<QueryFilterTemplateListOptionsInner>}
     * @memberof QueryFilterTemplate
     */
    'listOptions'?: Array<QueryFilterTemplateListOptionsInner>;
}

export const QueryFilterTemplateNameEnum = {
    CompanyName: 'Company.Name',
    CompanyRegNo: 'Company.RegNo',
    CompanyEmails: 'Company.Emails',
    CompanyPhones: 'Company.Phones',
    CompanyExtRef: 'Company.ExtRef',
    UsersName: 'Users.Name',
    UsersUsername: 'Users.Username',
    UsersEmail: 'Users.Email',
    UsersPhone: 'Users.Phone',
    UsersCompany: 'Users.Company',
    UsersRole: 'Users.Role',
    UsersExtRef: 'Users.ExtRef',
    LogsUsername: 'Logs.Username',
    LogsDate: 'Logs.Date',
    LogsUser: 'Logs.User',
    LogsModel: 'Logs.Model',
    ProductsName: 'Products.Name',
    ProductsExtRef: 'Products.ExtRef',
    ProductsGroup: 'Products.Group',
    ProductsPrice: 'Products.Price',
    ProductsCurrency: 'Products.Currency',
    ProductsItemCode: 'Products.ItemCode',
    ProductsQuantityInStock: 'Products.QuantityInStock',
    ProductsAmountUsed: 'Products.AmountUsed',
    ContactEmail: 'Contact.Email',
    ContactPhones: 'Contact.Phones',
    ContactExtRef: 'Contact.ExtRef',
    ContactTitle: 'Contact.Title',
    ContactPosition: 'Contact.Position',
    ContactFirstName: 'Contact.FirstName',
    ContactMiddleName: 'Contact.MiddleName',
    ContactLastName: 'Contact.LastName',
    ContactAddressCity: 'Contact.Address.City',
    ContactAddressPostalCode: 'Contact.Address.PostalCode',
    ContactAddressCountry: 'Contact.Address.Country',
    TicketCompany: 'Ticket.Company',
    TicketExtRef: 'Ticket.ExtRef',
    TicketCity: 'Ticket.City',
    TicketTitle: 'Ticket.Title',
    TicketId: 'Ticket.ID',
    TicketDepartment: 'Ticket.Department',
    TicketStatus: 'Ticket.Status',
    TicketDate: 'Ticket.Date',
    TicketPriority: 'Ticket.Priority',
    TicketLocation: 'Ticket.Location',
    TicketPerson: 'Ticket.Person',
    TicketAssignee: 'Ticket.Assignee',
    TicketCallId: 'Ticket.CallID',
    DepartmentName: 'Department.Name',
    DepartmentDescription: 'Department.Description',
    DepartmentDate: 'Department.Date',
    DepartmentAdministrative: 'Department.Administrative',
    FirewallDate: 'Firewall.Date',
    FirewallType: 'Firewall.Type',
    FirewallIp: 'Firewall.IP',
    FirewallPrefix: 'Firewall.Prefix',
    ItemsDescription: 'Items.Description',
    ItemsDate: 'Items.Date',
    ItemsType: 'Items.Type',
    ItemsLocationDescription: 'Items.LocationDescription',
    SubscriptionCode: 'Subscription.Code',
    SubscriptionDate: 'Subscription.Date',
    SubscriptionInvoice: 'Subscription.Invoice'
} as const;

export type QueryFilterTemplateNameEnum = typeof QueryFilterTemplateNameEnum[keyof typeof QueryFilterTemplateNameEnum];

/**
 * 
 * @export
 * @interface QueryFilterTemplateListOptionsInner
 */
export interface QueryFilterTemplateListOptionsInner {
    /**
     * 
     * @type {string}
     * @memberof QueryFilterTemplateListOptionsInner
     */
    'translatableEnum'?: QueryFilterTemplateListOptionsInnerTranslatableEnumEnum;
    /**
     * 
     * @type {string}
     * @memberof QueryFilterTemplateListOptionsInner
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof QueryFilterTemplateListOptionsInner
     */
    'name': string;
}

export const QueryFilterTemplateListOptionsInnerTranslatableEnumEnum = {
    Unassigned: 'Unassigned',
    RolesUser: 'Roles.User',
    RolesAgent: 'Roles.Agent',
    RolesAdmin: 'Roles.Admin',
    RecordTypesWhitelist: 'RecordTypes.Whitelist',
    RecordTypesBlacklist: 'RecordTypes.Blacklist',
    PrioritiesLow: 'Priorities.Low',
    PrioritiesMedium: 'Priorities.Medium',
    PrioritiesHigh: 'Priorities.High',
    StatusesNotReviewed: 'Statuses.Not reviewed',
    StatusesIncomplete: 'Statuses.Incomplete',
    StatusesPendingConfirmation: 'Statuses.Pending confirmation',
    StatusesComplete: 'Statuses.Complete',
    ItemTypeInvoice: 'ItemType.Invoice',
    ItemTypeDelivery: 'ItemType.Delivery',
    DatePeriodWeek: 'DatePeriod.Week',
    DatePeriodMonth: 'DatePeriod.Month',
    DatePeriodYear: 'DatePeriod.Year',
    DatePeriodDay: 'DatePeriod.Day',
    DateIndicatorCustom: 'DateIndicator.Custom',
    DateIndicatorLast: 'DateIndicator.Last',
    DateIndicatorThis: 'DateIndicator.This'
} as const;

export type QueryFilterTemplateListOptionsInnerTranslatableEnumEnum = typeof QueryFilterTemplateListOptionsInnerTranslatableEnumEnum[keyof typeof QueryFilterTemplateListOptionsInnerTranslatableEnumEnum];

/**
 * The refusal content generated by the assistant.
 * @export
 * @interface RefusalContentBlock
 */
export interface RefusalContentBlock {
    /**
     * 
     * @type {string}
     * @memberof RefusalContentBlock
     */
    'refusal': string;
    /**
     * Always `refusal`.
     * @type {string}
     * @memberof RefusalContentBlock
     */
    'type': RefusalContentBlockTypeEnum;
}

export const RefusalContentBlockTypeEnum = {
    Refusal: 'refusal'
} as const;

export type RefusalContentBlockTypeEnum = typeof RefusalContentBlockTypeEnum[keyof typeof RefusalContentBlockTypeEnum];

/**
 * 
 * @export
 * @interface SMTPSettings
 */
export interface SMTPSettings {
    /**
     * 
     * @type {boolean}
     * @memberof SMTPSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof SMTPSettings
     */
    'server': string;
    /**
     * 
     * @type {number}
     * @memberof SMTPSettings
     */
    'port': number;
    /**
     * 
     * @type {boolean}
     * @memberof SMTPSettings
     */
    'secure': boolean;
    /**
     * 
     * @type {string}
     * @memberof SMTPSettings
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof SMTPSettings
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof SMTPSettings
     */
    'from': string;
}
/**
 * 
 * @export
 * @interface SMTPTransportSentMessageInfo
 */
export interface SMTPTransportSentMessageInfo {
    /**
     * 
     * @type {MimeNodeEnvelope}
     * @memberof SMTPTransportSentMessageInfo
     */
    'envelope': MimeNodeEnvelope;
    /**
     * most transports should return the final Message-Id value used with this property
     * @type {string}
     * @memberof SMTPTransportSentMessageInfo
     */
    'messageId': string;
    /**
     * 
     * @type {Array<SMTPTransportSentMessageInfoAcceptedInner>}
     * @memberof SMTPTransportSentMessageInfo
     */
    'accepted': Array<SMTPTransportSentMessageInfoAcceptedInner>;
    /**
     * 
     * @type {Array<SMTPTransportSentMessageInfoAcceptedInner>}
     * @memberof SMTPTransportSentMessageInfo
     */
    'rejected': Array<SMTPTransportSentMessageInfoAcceptedInner>;
    /**
     * 
     * @type {Array<SMTPTransportSentMessageInfoAcceptedInner>}
     * @memberof SMTPTransportSentMessageInfo
     */
    'pending': Array<SMTPTransportSentMessageInfoAcceptedInner>;
    /**
     * 
     * @type {string}
     * @memberof SMTPTransportSentMessageInfo
     */
    'response': string;
}
/**
 * 
 * @export
 * @interface SMTPTransportSentMessageInfoAcceptedInner
 */
export interface SMTPTransportSentMessageInfoAcceptedInner {
    /**
     * 
     * @type {string}
     * @memberof SMTPTransportSentMessageInfoAcceptedInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SMTPTransportSentMessageInfoAcceptedInner
     */
    'address': string;
}
/**
 * 
 * @export
 * @interface ServiceCall
 */
export interface ServiceCall {
    /**
     * 
     * @type {string}
     * @memberof ServiceCall
     */
    '_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServiceCall
     */
    'date'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceCall
     */
    'customer_no': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCall
     */
    'contact_no': string;
    /**
     * 
     * @type {number}
     * @memberof ServiceCall
     */
    'file_no': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceCall
     */
    'call_id': number;
    /**
     * 
     * @type {Array<ServiceExpense>}
     * @memberof ServiceCall
     */
    'expenses': Array<ServiceExpense>;
    /**
     * 
     * @type {Array<ServiceTime>}
     * @memberof ServiceCall
     */
    'times': Array<ServiceTime>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ServiceCall
     */
    'workers': Array<number>;
}
/**
 * 
 * @export
 * @interface ServiceExpense
 */
export interface ServiceExpense {
    /**
     * 
     * @type {string}
     * @memberof ServiceExpense
     */
    '_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServiceExpense
     */
    'date': number;
    /**
     * 
     * @type {string}
     * @memberof ServiceExpense
     */
    'item_no': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceExpense
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof ServiceExpense
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof ServiceExpense
     */
    'serial_no': string;
}
/**
 * 
 * @export
 * @interface ServiceTime
 */
export interface ServiceTime {
    /**
     * 
     * @type {string}
     * @memberof ServiceTime
     */
    '_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServiceTime
     */
    'date': number;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceTime
     */
    'work': boolean;
    /**
     * 
     * @type {string}
     * @memberof ServiceTime
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceTime
     */
    'end': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceTime
     */
    'remarks': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ServiceTime
     */
    'workers': Array<number>;
}
/**
 * 
 * @export
 * @interface SessionRenewal
 */
export interface SessionRenewal {
    /**
     * 
     * @type {User}
     * @memberof SessionRenewal
     */
    'user': User;
    /**
     * 
     * @type {string}
     * @memberof SessionRenewal
     */
    'newToken': string;
}
/**
 * 
 * @export
 * @interface SetupOutputDTO
 */
export interface SetupOutputDTO {
    /**
     * 
     * @type {AppSettings}
     * @memberof SetupOutputDTO
     */
    'settings': AppSettings;
    /**
     * 
     * @type {string}
     * @memberof SetupOutputDTO
     */
    'qr'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirection = {
    Asc: 'asc',
    Desc: 'desc',
    None: 'none'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];


/**
 * 
 * @export
 * @interface Subscription
 */
export interface Subscription {
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    '_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'orcp': number;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'invoice': number;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'customer': number;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    'endDate': number;
    /**
     * 
     * @type {boolean}
     * @memberof Subscription
     */
    'executed': boolean;
    /**
     * 
     * @type {Array<SubscriptionWarningsInner>}
     * @memberof Subscription
     */
    'warnings': Array<SubscriptionWarningsInner>;
    /**
     * 
     * @type {Array<UserUpdate>}
     * @memberof Subscription
     */
    'usersUpdated': Array<UserUpdate>;
}
/**
 * 
 * @export
 * @interface SubscriptionMessages
 */
export interface SubscriptionMessages {
    /**
     * 
     * @type {EmailSetting}
     * @memberof SubscriptionMessages
     */
    'onSubscriptionReminder': EmailSetting;
}
/**
 * 
 * @export
 * @interface SubscriptionWarningsInner
 */
export interface SubscriptionWarningsInner {
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionWarningsInner
     */
    'done': boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionWarningsInner
     */
    'time': number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionWarningsInner
     */
    '_id'?: string;
}
/**
 * 
 * @export
 * @interface Task
 */
export interface Task {
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    '_id': string;
    /**
     * 
     * @type {TaskTicket}
     * @memberof Task
     */
    'ticket': TaskTicket;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'taskType'?: string;
    /**
     * 
     * @type {Array<LogUser>}
     * @memberof Task
     */
    'users': Array<LogUser>;
    /**
     * 
     * @type {Array<TaskAssignment>}
     * @memberof Task
     */
    'assignments': Array<TaskAssignment>;
    /**
     * 
     * @type {Array<TaskProduct>}
     * @memberof Task
     */
    'products': Array<TaskProduct>;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    'cancelled': boolean;
    /**
     * 
     * @type {number}
     * @memberof Task
     */
    'cancelDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof Task
     */
    'startDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof Task
     */
    'endDate'?: number;
    /**
     * 
     * @type {Array<Timelog>}
     * @memberof Task
     */
    'timelog': Array<Timelog>;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'comment': string;
    /**
     * 
     * @type {number}
     * @memberof Task
     */
    'date'?: number;
}
/**
 * 
 * @export
 * @interface TaskAssignment
 */
export interface TaskAssignment {
    /**
     * 
     * @type {string}
     * @memberof TaskAssignment
     */
    '_id'?: string;
    /**
     * 
     * @type {TicketAssigneesInner}
     * @memberof TaskAssignment
     */
    'user': TicketAssigneesInner;
    /**
     * 
     * @type {string}
     * @memberof TaskAssignment
     */
    'type': TaskAssignmentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof TaskAssignment
     */
    'date': number;
}

export const TaskAssignmentTypeEnum = {
    Assigned: 'assigned',
    Unassigned: 'unassigned'
} as const;

export type TaskAssignmentTypeEnum = typeof TaskAssignmentTypeEnum[keyof typeof TaskAssignmentTypeEnum];

/**
 * 
 * @export
 * @interface TaskMessages
 */
export interface TaskMessages {
    /**
     * 
     * @type {EmailSetting}
     * @memberof TaskMessages
     */
    'onCreate': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof TaskMessages
     */
    'onUpdate': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof TaskMessages
     */
    'onDelete': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof TaskMessages
     */
    'onAssignment': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof TaskMessages
     */
    'onUnassignment': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof TaskMessages
     */
    'onCancellation': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof TaskMessages
     */
    'onStart': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof TaskMessages
     */
    'onEnd': EmailSetting;
}
/**
 * 
 * @export
 * @interface TaskProduct
 */
export interface TaskProduct {
    /**
     * 
     * @type {string}
     * @memberof TaskProduct
     */
    'productRef': string;
    /**
     * 
     * @type {string}
     * @memberof TaskProduct
     */
    'itemCode': string;
    /**
     * 
     * @type {string}
     * @memberof TaskProduct
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskProduct
     */
    'serialList': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TaskProduct
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface TaskTicket
 */
export interface TaskTicket {
    /**
     * 
     * @type {string}
     * @memberof TaskTicket
     */
    '_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskTicket
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof TaskTicket
     */
    'date': number;
    /**
     * 
     * @type {string}
     * @memberof TaskTicket
     */
    'person': string;
    /**
     * 
     * @type {string}
     * @memberof TaskTicket
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TaskTicket
     */
    'number': string;
    /**
     * 
     * @type {UserCompany}
     * @memberof TaskTicket
     */
    'company'?: UserCompany;
    /**
     * 
     * @type {string}
     * @memberof TaskTicket
     */
    'companyName': string;
    /**
     * 
     * @type {Array<TicketAssigneesInner>}
     * @memberof TaskTicket
     */
    'assignees': Array<TicketAssigneesInner>;
    /**
     * 
     * @type {TicketDepartment}
     * @memberof TaskTicket
     */
    'department': TicketDepartment;
    /**
     * 
     * @type {TicketStatusEnum}
     * @memberof TaskTicket
     */
    'status': TicketStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TaskTicket
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof TaskTicket
     */
    'city': string;
    /**
     * 
     * @type {TicketPriorityEnum}
     * @memberof TaskTicket
     */
    'priority': TicketPriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof TaskTicket
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof TaskTicket
     */
    'details': string;
    /**
     * 
     * @type {Array<TicketResponse>}
     * @memberof TaskTicket
     */
    'responses': Array<TicketResponse>;
    /**
     * 
     * @type {string}
     * @memberof TaskTicket
     */
    'messageId': string;
    /**
     * 
     * @type {ServiceCall}
     * @memberof TaskTicket
     */
    'service_call'?: ServiceCall;
    /**
     * 
     * @type {Array<TicketTasksInner>}
     * @memberof TaskTicket
     */
    'tasks': Array<TicketTasksInner>;
    /**
     * 
     * @type {string}
     * @memberof TaskTicket
     */
    'event'?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskTicket
     */
    'closeDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof TaskTicket
     */
    'lastUpdate': number;
    /**
     * 
     * @type {Array<UserUpdate>}
     * @memberof TaskTicket
     */
    'usersUpdated': Array<UserUpdate>;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof TaskTicket
     */
    'attachments': Array<Attachment>;
    /**
     * 
     * @type {string}
     * @memberof TaskTicket
     */
    'voucherId'?: string;
    /**
     * 
     * @type {TicketAssigneesInner}
     * @memberof TaskTicket
     */
    'user'?: TicketAssigneesInner;
    /**
     * 
     * @type {boolean}
     * @memberof TaskTicket
     */
    'customer': boolean;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof TaskTicket
     */
    'printLogs': Array<Attachment>;
    /**
     * 
     * @type {string}
     * @memberof TaskTicket
     */
    'extRef': string;
}


/**
 * 
 * @export
 * @interface Text
 */
export interface Text {
    /**
     * 
     * @type {Array<Annotation>}
     * @memberof Text
     */
    'annotations': Array<Annotation>;
    /**
     * The data that makes up the text.
     * @type {string}
     * @memberof Text
     */
    'value': string;
}
/**
 * The text content that is part of a message.
 * @export
 * @interface TextContentBlock
 */
export interface TextContentBlock {
    /**
     * 
     * @type {Text}
     * @memberof TextContentBlock
     */
    'text': Text;
    /**
     * Always `text`.
     * @type {string}
     * @memberof TextContentBlock
     */
    'type': TextContentBlockTypeEnum;
}

export const TextContentBlockTypeEnum = {
    Text: 'text'
} as const;

export type TextContentBlockTypeEnum = typeof TextContentBlockTypeEnum[keyof typeof TextContentBlockTypeEnum];

/**
 * 
 * @export
 * @interface Ticket
 */
export interface Ticket {
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    '_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Ticket
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof Ticket
     */
    'date': number;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'person': string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'number': string;
    /**
     * 
     * @type {UserCompany}
     * @memberof Ticket
     */
    'company'?: UserCompany;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'companyName': string;
    /**
     * 
     * @type {Array<TicketAssigneesInner>}
     * @memberof Ticket
     */
    'assignees': Array<TicketAssigneesInner>;
    /**
     * 
     * @type {TicketDepartment}
     * @memberof Ticket
     */
    'department': TicketDepartment;
    /**
     * 
     * @type {TicketStatusEnum}
     * @memberof Ticket
     */
    'status': TicketStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'city': string;
    /**
     * 
     * @type {TicketPriorityEnum}
     * @memberof Ticket
     */
    'priority': TicketPriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'details': string;
    /**
     * 
     * @type {Array<TicketResponse>}
     * @memberof Ticket
     */
    'responses': Array<TicketResponse>;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'messageId': string;
    /**
     * 
     * @type {ServiceCall}
     * @memberof Ticket
     */
    'service_call'?: ServiceCall;
    /**
     * 
     * @type {Array<TicketTasksInner>}
     * @memberof Ticket
     */
    'tasks': Array<TicketTasksInner>;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'event'?: string;
    /**
     * 
     * @type {number}
     * @memberof Ticket
     */
    'closeDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof Ticket
     */
    'lastUpdate': number;
    /**
     * 
     * @type {Array<UserUpdate>}
     * @memberof Ticket
     */
    'usersUpdated': Array<UserUpdate>;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof Ticket
     */
    'attachments': Array<Attachment>;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'voucherId'?: string;
    /**
     * 
     * @type {TicketAssigneesInner}
     * @memberof Ticket
     */
    'user'?: TicketAssigneesInner;
    /**
     * 
     * @type {boolean}
     * @memberof Ticket
     */
    'customer': boolean;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof Ticket
     */
    'printLogs': Array<Attachment>;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'extRef': string;
}


/**
 * 
 * @export
 * @interface TicketAssigneesInner
 */
export interface TicketAssigneesInner {
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     */
    'email': string;
    /**
     * 
     * @type {UserCompany}
     * @memberof TicketAssigneesInner
     */
    'company'?: UserCompany;
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     * @deprecated
     */
    'activationCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     */
    'activationCodeHash'?: string;
    /**
     * 
     * @type {number}
     * @memberof TicketAssigneesInner
     */
    'activationCodeExpires'?: number;
    /**
     * 
     * @type {number}
     * @memberof TicketAssigneesInner
     */
    'activationCodeSentAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     */
    'passwordChangeCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TicketAssigneesInner
     */
    'emailConfirmation': boolean;
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     */
    'emailConfirmationCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TicketAssigneesInner
     */
    'otpEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     */
    'extRef': string;
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     */
    'otpSecret'?: string;
    /**
     * 
     * @type {Array<UserPushSubscription>}
     * @memberof TicketAssigneesInner
     */
    'pushSubscriptions': Array<UserPushSubscription>;
    /**
     * 
     * @type {UserContact}
     * @memberof TicketAssigneesInner
     */
    'contact'?: UserContact;
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketAssigneesInner
     */
    'name': string;
    /**
     * 
     * @type {UserRole}
     * @memberof TicketAssigneesInner
     */
    'role': UserRole;
    /**
     * 
     * @type {boolean}
     * @memberof TicketAssigneesInner
     */
    'active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketAssigneesInner
     */
    'deleted': boolean;
}


/**
 * 
 * @export
 * @interface TicketDepartment
 */
export interface TicketDepartment {
    /**
     * 
     * @type {string}
     * @memberof TicketDepartment
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketDepartment
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TicketDepartment
     */
    'description': string;
    /**
     * 
     * @type {Array<LogUser>}
     * @memberof TicketDepartment
     */
    'users': Array<LogUser>;
    /**
     * 
     * @type {boolean}
     * @memberof TicketDepartment
     */
    'administrative': boolean;
    /**
     * 
     * @type {number}
     * @memberof TicketDepartment
     */
    'date': number;
}
/**
 * 
 * @export
 * @interface TicketMessages
 */
export interface TicketMessages {
    /**
     * 
     * @type {EmailSetting}
     * @memberof TicketMessages
     */
    'onClose': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof TicketMessages
     */
    'onCreate': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof TicketMessages
     */
    'onStatusChange': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof TicketMessages
     */
    'onResponse': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof TicketMessages
     */
    'onTicketReminder': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof TicketMessages
     */
    'onAssignment': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof TicketMessages
     */
    'onUnassignment': EmailSetting;
}
/**
 * 
 * @export
 * @interface TicketPrintTemplate
 */
export interface TicketPrintTemplate {
    /**
     * 
     * @type {string}
     * @memberof TicketPrintTemplate
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketPrintTemplate
     */
    'name': string;
    /**
     * 
     * @type {TicketPrintTemplateFields}
     * @memberof TicketPrintTemplate
     */
    'fields': TicketPrintTemplateFields;
    /**
     * 
     * @type {TicketPrintTemplateOptions}
     * @memberof TicketPrintTemplate
     */
    'options': TicketPrintTemplateOptions;
}
/**
 * 
 * @export
 * @interface TicketPrintTemplateFields
 */
export interface TicketPrintTemplateFields {
    /**
     * 
     * @type {TicketPrintTemplateFieldsResponses}
     * @memberof TicketPrintTemplateFields
     */
    'responses': TicketPrintTemplateFieldsResponses;
    /**
     * 
     * @type {TicketPrintTemplateFieldsServiceCall}
     * @memberof TicketPrintTemplateFields
     */
    'serviceCall': TicketPrintTemplateFieldsServiceCall;
    /**
     * 
     * @type {TicketPrintTemplateFieldsTasks}
     * @memberof TicketPrintTemplateFields
     */
    'tasks': TicketPrintTemplateFieldsTasks;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFields
     */
    'assignees': boolean;
    /**
     * 
     * @type {TicketPrintTemplateFieldsContactInfo}
     * @memberof TicketPrintTemplateFields
     */
    'contactInfo': TicketPrintTemplateFieldsContactInfo;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFields
     */
    'department': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFields
     */
    'priority': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFields
     */
    'body': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFields
     */
    'title': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFields
     */
    'id': boolean;
    /**
     * 
     * @type {string}
     * @memberof TicketPrintTemplateFields
     */
    'banner': string;
}
/**
 * 
 * @export
 * @interface TicketPrintTemplateFieldsContactInfo
 */
export interface TicketPrintTemplateFieldsContactInfo {
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsContactInfo
     */
    'location': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsContactInfo
     */
    'phone': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsContactInfo
     */
    'person': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsContactInfo
     */
    'company': boolean;
}
/**
 * 
 * @export
 * @interface TicketPrintTemplateFieldsResponses
 */
export interface TicketPrintTemplateFieldsResponses {
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsResponses
     */
    'privateResponse': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsResponses
     */
    'attachments': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsResponses
     */
    'content': boolean;
}
/**
 * 
 * @export
 * @interface TicketPrintTemplateFieldsServiceCall
 */
export interface TicketPrintTemplateFieldsServiceCall {
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsServiceCall
     */
    'contactInfo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsServiceCall
     */
    'contactName': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsServiceCall
     */
    'companyName': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsServiceCall
     */
    'id': boolean;
}
/**
 * 
 * @export
 * @interface TicketPrintTemplateFieldsTasks
 */
export interface TicketPrintTemplateFieldsTasks {
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsTasks
     */
    'taskType': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsTasks
     */
    'items': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsTasks
     */
    'times': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsTasks
     */
    'comment': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsTasks
     */
    'users': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsTasks
     */
    'description': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateFieldsTasks
     */
    'title': boolean;
}
/**
 * 
 * @export
 * @interface TicketPrintTemplateOptions
 */
export interface TicketPrintTemplateOptions {
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateOptions
     */
    'displayResponder': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateOptions
     */
    'displayTicketUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPrintTemplateOptions
     */
    'signatureRequired': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TicketPrintTemplateOptions
     */
    'forwardEmails': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TicketPrintTemplateOptions
     */
    'copyTemplate': string;
    /**
     * 
     * @type {string}
     * @memberof TicketPrintTemplateOptions
     */
    'sectionTitleColor': string;
    /**
     * 
     * @type {string}
     * @memberof TicketPrintTemplateOptions
     */
    'textColor': string;
    /**
     * 
     * @type {string}
     * @memberof TicketPrintTemplateOptions
     */
    'backgroundColor': string;
    /**
     * 
     * @type {number}
     * @memberof TicketPrintTemplateOptions
     */
    'maxTasks': number;
    /**
     * 
     * @type {number}
     * @memberof TicketPrintTemplateOptions
     */
    'maxResponses': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TicketPriorityEnum = {
    High: 'high',
    Medium: 'medium',
    Low: 'low'
} as const;

export type TicketPriorityEnum = typeof TicketPriorityEnum[keyof typeof TicketPriorityEnum];


/**
 * 
 * @export
 * @interface TicketResponse
 */
export interface TicketResponse {
    /**
     * 
     * @type {string}
     * @memberof TicketResponse
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketResponse
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof TicketResponse
     */
    'date'?: number;
    /**
     * 
     * @type {User}
     * @memberof TicketResponse
     */
    'user'?: User;
    /**
     * 
     * @type {string}
     * @memberof TicketResponse
     */
    'content'?: string;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof TicketResponse
     */
    'attachments': Array<Attachment>;
    /**
     * 
     * @type {boolean}
     * @memberof TicketResponse
     */
    'isInternal'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TicketStatusEnum = {
    NotReviewed: 'Not reviewed',
    Incomplete: 'Incomplete',
    PendingConfirmation: 'Pending confirmation',
    Complete: 'Complete'
} as const;

export type TicketStatusEnum = typeof TicketStatusEnum[keyof typeof TicketStatusEnum];


/**
 * 
 * @export
 * @interface TicketTasksInner
 */
export interface TicketTasksInner {
    /**
     * 
     * @type {string}
     * @memberof TicketTasksInner
     */
    '_id': string;
    /**
     * 
     * @type {TaskTicket}
     * @memberof TicketTasksInner
     */
    'ticket': TaskTicket;
    /**
     * 
     * @type {string}
     * @memberof TicketTasksInner
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof TicketTasksInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof TicketTasksInner
     */
    'taskType'?: string;
    /**
     * 
     * @type {Array<LogUser>}
     * @memberof TicketTasksInner
     */
    'users': Array<LogUser>;
    /**
     * 
     * @type {Array<TaskAssignment>}
     * @memberof TicketTasksInner
     */
    'assignments': Array<TaskAssignment>;
    /**
     * 
     * @type {Array<TaskProduct>}
     * @memberof TicketTasksInner
     */
    'products': Array<TaskProduct>;
    /**
     * 
     * @type {boolean}
     * @memberof TicketTasksInner
     */
    'cancelled': boolean;
    /**
     * 
     * @type {number}
     * @memberof TicketTasksInner
     */
    'cancelDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof TicketTasksInner
     */
    'startDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof TicketTasksInner
     */
    'endDate'?: number;
    /**
     * 
     * @type {Array<Timelog>}
     * @memberof TicketTasksInner
     */
    'timelog': Array<Timelog>;
    /**
     * 
     * @type {string}
     * @memberof TicketTasksInner
     */
    'comment': string;
    /**
     * 
     * @type {number}
     * @memberof TicketTasksInner
     */
    'date'?: number;
}
/**
 * 
 * @export
 * @interface Timelog
 */
export interface Timelog {
    /**
     * 
     * @type {string}
     * @memberof Timelog
     */
    '_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Timelog
     */
    'startDate': number;
    /**
     * 
     * @type {number}
     * @memberof Timelog
     */
    'endDate'?: number;
}
/**
 * 
 * @export
 * @interface UnixPermissions
 */
export interface UnixPermissions {
    /**
     * 
     * @type {number}
     * @memberof UnixPermissions
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof UnixPermissions
     */
    'group': number;
    /**
     * 
     * @type {number}
     * @memberof UnixPermissions
     */
    'world': number;
}
/**
 * 
 * @export
 * @interface UpdateAPIBody
 */
export interface UpdateAPIBody {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAPIBody
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAPIBody
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAPIBody
     */
    'allowedIps': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateAPIBody
     */
    'user': string;
}
/**
 * 
 * @export
 * @interface UpdateCompanyBody
 */
export interface UpdateCompanyBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyBody
     */
    'name': string;
    /**
     * 
     * @type {Array<Address>}
     * @memberof UpdateCompanyBody
     */
    'addresses': Array<Address>;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyBody
     */
    'regNo': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCompanyBody
     */
    'emails': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCompanyBody
     */
    'phones': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyBody
     */
    'extRef': string;
}
/**
 * 
 * @export
 * @interface UpdateContactBody
 */
export interface UpdateContactBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateContactBody
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactBody
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactBody
     */
    'middleName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactBody
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateContactBody
     */
    'phones': Array<string>;
    /**
     * 
     * @type {Array<Address>}
     * @memberof UpdateContactBody
     */
    'addresses': Array<Address>;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactBody
     */
    'position': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactBody
     */
    'extRef': string;
}
/**
 * 
 * @export
 * @interface UpdateDepartmentBody
 */
export interface UpdateDepartmentBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateDepartmentBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDepartmentBody
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDepartmentBody
     */
    'users': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDepartmentBody
     */
    'administrative': boolean;
}
/**
 * 
 * @export
 * @interface UpdateFilterViewBody
 */
export interface UpdateFilterViewBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateFilterViewBody
     */
    'name': string;
    /**
     * 
     * @type {LogModel}
     * @memberof UpdateFilterViewBody
     */
    'model': LogModel;
    /**
     * 
     * @type {string}
     * @memberof UpdateFilterViewBody
     */
    'search': string;
    /**
     * 
     * @type {Array<Filter>}
     * @memberof UpdateFilterViewBody
     */
    'filters': Array<Filter>;
}


/**
 * 
 * @export
 * @interface UpdateItemBody
 */
export interface UpdateItemBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateItemBody
     */
    'description': string;
    /**
     * 
     * @type {CreateItemBodyLocation}
     * @memberof UpdateItemBody
     */
    'location'?: CreateItemBodyLocation;
    /**
     * 
     * @type {string}
     * @memberof UpdateItemBody
     */
    'docRef': string;
}
/**
 * 
 * @export
 * @interface UpdateItemHandInBody
 */
export interface UpdateItemHandInBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateItemHandInBody
     */
    'comment': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateItemHandInBody
     */
    'undo': boolean;
}
/**
 * 
 * @export
 * @interface UpdateMyUserBody
 */
export interface UpdateMyUserBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateMyUserBody
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyUserBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyUserBody
     */
    'companyName': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMyUserBody
     */
    'otpEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMyUserBody
     */
    'emailConfirmation': boolean;
}
/**
 * 
 * @export
 * @interface UpdateProductBody
 */
export interface UpdateProductBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBody
     */
    'itemCode': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBody
     */
    'group': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductBody
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBody
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBody
     */
    'extRef': string;
}
/**
 * 
 * @export
 * @interface UpdateRecordBody
 */
export interface UpdateRecordBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateRecordBody
     */
    'type': UpdateRecordBodyTypeEnum;
    /**
     * IPv4 or IPv6 address
     * @type {string}
     * @memberof UpdateRecordBody
     */
    'ip': string;
    /**
     * CIDR prefix length: 0-32 for IPv4, 0-128 for IPv6
     * @type {number}
     * @memberof UpdateRecordBody
     */
    'prefix': number;
}

export const UpdateRecordBodyTypeEnum = {
    Blacklist: 'blacklist',
    Whitelist: 'whitelist'
} as const;

export type UpdateRecordBodyTypeEnum = typeof UpdateRecordBodyTypeEnum[keyof typeof UpdateRecordBodyTypeEnum];

/**
 * 
 * @export
 * @interface UpdateTaskBody
 */
export interface UpdateTaskBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskBody
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskBody
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTaskBody
     */
    'cancelled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskBody
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskBody
     */
    'taskType'?: string;
    /**
     * 
     * @type {Array<TaskProduct>}
     * @memberof UpdateTaskBody
     */
    'products': Array<TaskProduct>;
}
/**
 * 
 * @export
 * @interface UpdateTaskProductSerialsBody
 */
export interface UpdateTaskProductSerialsBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskProductSerialsBody
     */
    'itemCode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTaskProductSerialsBody
     */
    'serials': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateTaskStatusBody
 */
export interface UpdateTaskStatusBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskStatusBody
     */
    'status': UpdateTaskStatusBodyStatusEnum;
}

export const UpdateTaskStatusBodyStatusEnum = {
    Start: 'start',
    End: 'end'
} as const;

export type UpdateTaskStatusBodyStatusEnum = typeof UpdateTaskStatusBodyStatusEnum[keyof typeof UpdateTaskStatusBodyStatusEnum];

/**
 * 
 * @export
 * @interface UpdateTaskTimeLogBody
 */
export interface UpdateTaskTimeLogBody {
    /**
     * 
     * @type {number}
     * @memberof UpdateTaskTimeLogBody
     */
    'startDate': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTaskTimeLogBody
     */
    'endDate'?: number;
}
/**
 * 
 * @export
 * @interface UpdateTicketBody
 */
export interface UpdateTicketBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketBody
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketBody
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketBody
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketBody
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketBody
     */
    'departmentId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketBody
     */
    'person'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketBody
     */
    'number'?: string;
    /**
     * 
     * @type {TicketPriorityEnum}
     * @memberof UpdateTicketBody
     */
    'priority': TicketPriorityEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTicketBody
     */
    'assignees': Array<string>;
    /**
     * 
     * @type {TicketStatusEnum}
     * @memberof UpdateTicketBody
     */
    'status': TicketStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketBody
     */
    'extRef': string;
}


/**
 * 
 * @export
 * @interface UpdateTicketDetailsBody
 */
export interface UpdateTicketDetailsBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketDetailsBody
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketDetailsBody
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface UpdateTicketResponseBody
 */
export interface UpdateTicketResponseBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketResponseBody
     */
    'content': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTicketResponseBody
     */
    'internalResponse': boolean;
}
/**
 * 
 * @export
 * @interface UpdateUserBody
 */
export interface UpdateUserBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserBody
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserBody
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserBody
     */
    'phone': string;
    /**
     * 
     * @type {UserRole}
     * @memberof UpdateUserBody
     */
    'role': UserRole;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserBody
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserBody
     */
    'otpEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserBody
     */
    'emailConfirmation': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserBody
     */
    'extRef': string;
}


/**
 * 
 * @export
 * @interface UpdateUserPasswordBody
 */
export interface UpdateUserPasswordBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPasswordBody
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPasswordBody
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface UpdateVoucherLimitBody
 */
export interface UpdateVoucherLimitBody {
    /**
     * 
     * @type {number}
     * @memberof UpdateVoucherLimitBody
     */
    'minutes': number;
}
/**
 * 
 * @export
 * @interface UpdateVoucherUsageBody
 */
export interface UpdateVoucherUsageBody {
    /**
     * 
     * @type {number}
     * @memberof UpdateVoucherUsageBody
     */
    'timeToUse': number;
}
/**
 * 
 * @export
 * @interface UpdateWebhookBody
 */
export interface UpdateWebhookBody {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWebhookBody
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateWebhookBody
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateWebhookBody
     */
    'events': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateWebhookBody
     */
    'url': string;
    /**
     * 
     * @type {Array<HttpHeader>}
     * @memberof UpdateWebhookBody
     */
    'headers': Array<HttpHeader>;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {UserCompany}
     * @memberof User
     */
    'company'?: UserCompany;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof User
     * @deprecated
     */
    'activationCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'activationCodeHash'?: string;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'activationCodeExpires'?: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'activationCodeSentAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'passwordChangeCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'emailConfirmation': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'emailConfirmationCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'otpEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'extRef': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'otpSecret'?: string;
    /**
     * 
     * @type {Array<UserPushSubscription>}
     * @memberof User
     */
    'pushSubscriptions': Array<UserPushSubscription>;
    /**
     * 
     * @type {UserContact}
     * @memberof User
     */
    'contact'?: UserContact;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'name': string;
    /**
     * 
     * @type {UserRole}
     * @memberof User
     */
    'role': UserRole;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'deleted': boolean;
}


/**
 * 
 * @export
 * @interface UserCompany
 */
export interface UserCompany {
    /**
     * 
     * @type {string}
     * @memberof UserCompany
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCompany
     */
    'name': string;
    /**
     * 
     * @type {Array<Address>}
     * @memberof UserCompany
     */
    'addresses': Array<Address>;
    /**
     * 
     * @type {string}
     * @memberof UserCompany
     */
    'regNo': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserCompany
     */
    'emails': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserCompany
     */
    'phones': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UserCompany
     */
    'extRef': string;
}
/**
 * 
 * @export
 * @interface UserContact
 */
export interface UserContact {
    /**
     * 
     * @type {string}
     * @memberof UserContact
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserContact
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof UserContact
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserContact
     */
    'middleName': string;
    /**
     * 
     * @type {string}
     * @memberof UserContact
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof UserContact
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserContact
     */
    'phones': Array<string>;
    /**
     * 
     * @type {Array<Address>}
     * @memberof UserContact
     */
    'addresses': Array<Address>;
    /**
     * 
     * @type {string}
     * @memberof UserContact
     */
    'position': string;
    /**
     * 
     * @type {Company}
     * @memberof UserContact
     */
    'company'?: Company;
    /**
     * 
     * @type {string}
     * @memberof UserContact
     */
    'extRef': string;
}
/**
 * 
 * @export
 * @interface UserMessages
 */
export interface UserMessages {
    /**
     * 
     * @type {EmailSetting}
     * @memberof UserMessages
     */
    'onCreate': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof UserMessages
     */
    'onRegister': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof UserMessages
     */
    'onUpdate': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof UserMessages
     */
    'onEmailConfirmation': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof UserMessages
     */
    'onPasswordChangeRequest': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof UserMessages
     */
    'onPasswordChanged': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof UserMessages
     */
    'onDelete': EmailSetting;
}
/**
 * 
 * @export
 * @interface UserPushSubscription
 */
export interface UserPushSubscription {
    /**
     * 
     * @type {string}
     * @memberof UserPushSubscription
     */
    'endpoint'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserPushSubscription
     */
    'expirationTime'?: number | null;
    /**
     * Construct a type with a set of properties K of type T
     * @type {object}
     * @memberof UserPushSubscription
     */
    'keys'?: object;
    /**
     * 
     * @type {number}
     * @memberof UserPushSubscription
     */
    'lastActivity': number;
    /**
     * 
     * @type {string}
     * @memberof UserPushSubscription
     */
    'browserId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UserRole = {
    User: 'user',
    Agent: 'agent',
    Admin: 'admin'
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];


/**
 * 
 * @export
 * @interface UserUpdate
 */
export interface UserUpdate {
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    '_id'?: string;
    /**
     * 
     * @type {LogUser}
     * @memberof UserUpdate
     */
    'user': LogUser;
    /**
     * 
     * @type {number}
     * @memberof UserUpdate
     */
    'lastUpdate': number;
}
/**
 * 
 * @export
 * @interface Voucher
 */
export interface Voucher {
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    '_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    'id': string;
    /**
     * 
     * @type {TaskTicket}
     * @memberof Voucher
     */
    'ticket': TaskTicket;
    /**
     * 
     * @type {number}
     * @memberof Voucher
     */
    'timeLimit': number;
    /**
     * 
     * @type {number}
     * @memberof Voucher
     */
    'timeUsed': number;
    /**
     * 
     * @type {number}
     * @memberof Voucher
     */
    'dateCreated': number;
    /**
     * 
     * @type {number}
     * @memberof Voucher
     */
    'dateEnd': number;
    /**
     * 
     * @type {VoucherEmails}
     * @memberof Voucher
     */
    'emails': VoucherEmails;
}
/**
 * 
 * @export
 * @interface VoucherEmails
 */
export interface VoucherEmails {
    /**
     * 
     * @type {VoucherEmailsDateEnd}
     * @memberof VoucherEmails
     */
    'dateEnd': VoucherEmailsDateEnd;
    /**
     * 
     * @type {VoucherEmailsBeforeOneWeek}
     * @memberof VoucherEmails
     */
    'beforeOneWeek': VoucherEmailsBeforeOneWeek;
    /**
     * 
     * @type {VoucherEmailsBeforeOneWeek}
     * @memberof VoucherEmails
     */
    'beforeOneMonth': VoucherEmailsBeforeOneWeek;
    /**
     * 
     * @type {VoucherEmailsBeforeOneWeek}
     * @memberof VoucherEmails
     */
    'beforeTwoMonths': VoucherEmailsBeforeOneWeek;
}
/**
 * 
 * @export
 * @interface VoucherEmailsBeforeOneWeek
 */
export interface VoucherEmailsBeforeOneWeek {
    /**
     * 
     * @type {number}
     * @memberof VoucherEmailsBeforeOneWeek
     */
    'date': number;
    /**
     * 
     * @type {boolean}
     * @memberof VoucherEmailsBeforeOneWeek
     */
    'done': boolean;
}
/**
 * 
 * @export
 * @interface VoucherEmailsDateEnd
 */
export interface VoucherEmailsDateEnd {
    /**
     * 
     * @type {boolean}
     * @memberof VoucherEmailsDateEnd
     */
    'done': boolean;
}
/**
 * 
 * @export
 * @interface VoucherMessages
 */
export interface VoucherMessages {
    /**
     * 
     * @type {EmailSetting}
     * @memberof VoucherMessages
     */
    'onCreate': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof VoucherMessages
     */
    'onDelete': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof VoucherMessages
     */
    'onPartialUse': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof VoucherMessages
     */
    'onFullUse': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof VoucherMessages
     */
    'onTicketAssign': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof VoucherMessages
     */
    'onApproachingExpiry': EmailSetting;
    /**
     * 
     * @type {EmailSetting}
     * @memberof VoucherMessages
     */
    'onExpiry': EmailSetting;
}
/**
 * 
 * @export
 * @interface Warehouse
 */
export interface Warehouse {
    /**
     * 
     * @type {string}
     * @memberof Warehouse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof Warehouse
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface WebLink
 */
export interface WebLink {
    /**
     * 
     * @type {string}
     * @memberof WebLink
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof WebLink
     */
    'link': string;
}
/**
 * 
 * @export
 * @interface Webhook
 */
export interface Webhook {
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    '_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof Webhook
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    'description': string;
    /**
     * 
     * @type {Array<WebhookEvent>}
     * @memberof Webhook
     */
    'events': Array<WebhookEvent>;
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    'url': string;
    /**
     * 
     * @type {Array<HttpHeader>}
     * @memberof Webhook
     */
    'headers': Array<HttpHeader>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WebhookEvent = {
    TicketCreated: 'ticket.created',
    TicketUpdated: 'ticket.updated',
    TicketDeleted: 'ticket.deleted',
    TicketResponseCreated: 'ticket.response.created',
    TicketResponseUpdated: 'ticket.response.updated',
    TicketResponseDeleted: 'ticket.response.deleted',
    TicketAssigneeAdded: 'ticket.assignee.added',
    TicketAssigneeRemoved: 'ticket.assignee.removed',
    TicketDetailsUpdated: 'ticket.details.updated',
    UserCreated: 'user.created',
    UserRegistered: 'user.registered',
    UserUpdated: 'user.updated',
    UserDeleted: 'user.deleted',
    FileUploaded: 'file.uploaded',
    FileDeleted: 'file.deleted',
    FileDirectoryCreated: 'file.directory.created',
    FileDirectoryDeleted: 'file.directory.deleted',
    TaskCreated: 'task.created',
    TaskUpdated: 'task.updated',
    TaskDeleted: 'task.deleted',
    TaskTimelogCreated: 'task.timelog.created',
    TaskTimelogUpdated: 'task.timelog.updated',
    TaskTimelogDeleted: 'task.timelog.deleted',
    TaskUserAssigned: 'task.user.assigned',
    TaskUserUnassigned: 'task.user.unassigned',
    TaskProductsAdded: 'task.products.added',
    TaskProductsDeleted: 'task.products.deleted',
    TaskProductsSerialsUpdated: 'task.products.serials.updated',
    TaskStatusUpdated: 'task.status.updated',
    FirewallRecordCreated: 'firewall.record.created',
    FirewallRecordUpdated: 'firewall.record.updated',
    FirewallRecordDeleted: 'firewall.record.deleted',
    DepartmentCreated: 'department.created',
    DepartmentUpdated: 'department.updated',
    DepartmentDeleted: 'department.deleted'
} as const;

export type WebhookEvent = typeof WebhookEvent[keyof typeof WebhookEvent];


/**
 * 
 * @export
 * @interface WebhookLog
 */
export interface WebhookLog {
    /**
     * 
     * @type {string}
     * @memberof WebhookLog
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof WebhookLog
     */
    'url': string;
    /**
     * 
     * @type {WebhookLogRef}
     * @memberof WebhookLog
     */
    'ref': WebhookLogRef;
    /**
     * 
     * @type {number}
     * @memberof WebhookLog
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof WebhookLog
     */
    'statusText': string;
    /**
     * 
     * @type {string}
     * @memberof WebhookLog
     */
    'response': string;
    /**
     * 
     * @type {number}
     * @memberof WebhookLog
     */
    'date': number;
}
/**
 * 
 * @export
 * @interface WebhookLogRef
 */
export interface WebhookLogRef {
    /**
     * 
     * @type {string}
     * @memberof WebhookLogRef
     */
    '_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof WebhookLogRef
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof WebhookLogRef
     */
    'description': string;
    /**
     * 
     * @type {Array<WebhookEvent>}
     * @memberof WebhookLogRef
     */
    'events': Array<WebhookEvent>;
    /**
     * 
     * @type {string}
     * @memberof WebhookLogRef
     */
    'url': string;
    /**
     * 
     * @type {Array<HttpHeader>}
     * @memberof WebhookLogRef
     */
    'headers': Array<HttpHeader>;
}

/**
 * APIApi - axios parameter creator
 * @export
 */
export const APIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateAPIBody} createAPIBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAPI: async (createAPIBody: CreateAPIBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAPIBody' is not null or undefined
            assertParamExists('createAPI', 'createAPIBody', createAPIBody)
            const localVarPath = `/api/api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAPIBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAPI: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAPI', 'id', id)
            const localVarPath = `/api/api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAPI: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAPI', 'id', id)
            const localVarPath = `/api/api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAPIList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getAPIList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getAPIList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAPIList', 'limit', limit)
            const localVarPath = `/api/api/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateAPIBody} updateAPIBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAPI: async (id: string, updateAPIBody: UpdateAPIBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAPI', 'id', id)
            // verify required parameter 'updateAPIBody' is not null or undefined
            assertParamExists('updateAPI', 'updateAPIBody', updateAPIBody)
            const localVarPath = `/api/api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAPIBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * APIApi - functional programming interface
 * @export
 */
export const APIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = APIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateAPIBody} createAPIBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAPI(createAPIBody: CreateAPIBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOAPI>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAPI(createAPIBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['APIApi.createAPI']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAPI(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOAPI>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAPI(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['APIApi.deleteAPI']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAPI(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPopulatedAPI>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAPI(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['APIApi.getAPI']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAPIList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListPopulatedAPI>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAPIList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['APIApi.getAPIList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateAPIBody} updateAPIBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAPI(id: string, updateAPIBody: UpdateAPIBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOAPI>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAPI(id, updateAPIBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['APIApi.updateAPI']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * APIApi - factory interface
 * @export
 */
export const APIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = APIApiFp(configuration)
    return {
        /**
         * 
         * @param {APIApiCreateAPIRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAPI(requestParameters: APIApiCreateAPIRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOAPI> {
            return localVarFp.createAPI(requestParameters.createAPIBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {APIApiDeleteAPIRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAPI(requestParameters: APIApiDeleteAPIRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOAPI> {
            return localVarFp.deleteAPI(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {APIApiGetAPIRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAPI(requestParameters: APIApiGetAPIRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPopulatedAPI> {
            return localVarFp.getAPI(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {APIApiGetAPIListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAPIList(requestParameters: APIApiGetAPIListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListPopulatedAPI> {
            return localVarFp.getAPIList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {APIApiUpdateAPIRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAPI(requestParameters: APIApiUpdateAPIRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOAPI> {
            return localVarFp.updateAPI(requestParameters.id, requestParameters.updateAPIBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createAPI operation in APIApi.
 * @export
 * @interface APIApiCreateAPIRequest
 */
export interface APIApiCreateAPIRequest {
    /**
     * 
     * @type {CreateAPIBody}
     * @memberof APIApiCreateAPI
     */
    readonly createAPIBody: CreateAPIBody
}

/**
 * Request parameters for deleteAPI operation in APIApi.
 * @export
 * @interface APIApiDeleteAPIRequest
 */
export interface APIApiDeleteAPIRequest {
    /**
     * 
     * @type {string}
     * @memberof APIApiDeleteAPI
     */
    readonly id: string
}

/**
 * Request parameters for getAPI operation in APIApi.
 * @export
 * @interface APIApiGetAPIRequest
 */
export interface APIApiGetAPIRequest {
    /**
     * 
     * @type {string}
     * @memberof APIApiGetAPI
     */
    readonly id: string
}

/**
 * Request parameters for getAPIList operation in APIApi.
 * @export
 * @interface APIApiGetAPIListRequest
 */
export interface APIApiGetAPIListRequest {
    /**
     * 
     * @type {string}
     * @memberof APIApiGetAPIList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof APIApiGetAPIList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof APIApiGetAPIList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof APIApiGetAPIList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof APIApiGetAPIList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof APIApiGetAPIList
     */
    readonly filters?: string
}

/**
 * Request parameters for updateAPI operation in APIApi.
 * @export
 * @interface APIApiUpdateAPIRequest
 */
export interface APIApiUpdateAPIRequest {
    /**
     * 
     * @type {string}
     * @memberof APIApiUpdateAPI
     */
    readonly id: string

    /**
     * 
     * @type {UpdateAPIBody}
     * @memberof APIApiUpdateAPI
     */
    readonly updateAPIBody: UpdateAPIBody
}

/**
 * APIApi - object-oriented interface
 * @export
 * @class APIApi
 * @extends {BaseAPI}
 */
export class APIApi extends BaseAPI {
    /**
     * 
     * @param {APIApiCreateAPIRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public createAPI(requestParameters: APIApiCreateAPIRequest, options?: AxiosRequestConfig) {
        return APIApiFp(this.configuration).createAPI(requestParameters.createAPIBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {APIApiDeleteAPIRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public deleteAPI(requestParameters: APIApiDeleteAPIRequest, options?: AxiosRequestConfig) {
        return APIApiFp(this.configuration).deleteAPI(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {APIApiGetAPIRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public getAPI(requestParameters: APIApiGetAPIRequest, options?: AxiosRequestConfig) {
        return APIApiFp(this.configuration).getAPI(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {APIApiGetAPIListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public getAPIList(requestParameters: APIApiGetAPIListRequest, options?: AxiosRequestConfig) {
        return APIApiFp(this.configuration).getAPIList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {APIApiUpdateAPIRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIApi
     */
    public updateAPI(requestParameters: APIApiUpdateAPIRequest, options?: AxiosRequestConfig) {
        return APIApiFp(this.configuration).updateAPI(requestParameters.id, requestParameters.updateAPIBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginBody} loginBody 
         * @param {string} [emailCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginBody: LoginBody, emailCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginBody' is not null or undefined
            assertParamExists('login', 'loginBody', loginBody)
            const localVarPath = `/api/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (emailCode !== undefined) {
                localVarQueryParameter['emailCode'] = emailCode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {string} otp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpLogin: async (token: string, otp: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('otpLogin', 'token', token)
            // verify required parameter 'otp' is not null or undefined
            assertParamExists('otpLogin', 'otp', otp)
            const localVarPath = `/api/auth/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (otp !== undefined) {
                localVarQueryParameter['otp'] = otp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSession(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOSessionRenewal>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSession(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthenticationApi.getSession']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {LoginBody} loginBody 
         * @param {string} [emailCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginBody: LoginBody, emailCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOAuthorizationData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginBody, emailCode, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthenticationApi.login']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {string} otp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async otpLogin(token: string, otp: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOAuthorizationData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.otpLogin(token, otp, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthenticationApi.otpLogin']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession(options?: AxiosRequestConfig): AxiosPromise<OutputDTOSessionRenewal> {
            return localVarFp.getSession(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthenticationApiLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(requestParameters: AuthenticationApiLoginRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOAuthorizationData> {
            return localVarFp.login(requestParameters.loginBody, requestParameters.emailCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthenticationApiOtpLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpLogin(requestParameters: AuthenticationApiOtpLoginRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOAuthorizationData> {
            return localVarFp.otpLogin(requestParameters.token, requestParameters.otp, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for login operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiLoginRequest
 */
export interface AuthenticationApiLoginRequest {
    /**
     * 
     * @type {LoginBody}
     * @memberof AuthenticationApiLogin
     */
    readonly loginBody: LoginBody

    /**
     * 
     * @type {string}
     * @memberof AuthenticationApiLogin
     */
    readonly emailCode?: string
}

/**
 * Request parameters for otpLogin operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiOtpLoginRequest
 */
export interface AuthenticationApiOtpLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationApiOtpLogin
     */
    readonly token: string

    /**
     * 
     * @type {string}
     * @memberof AuthenticationApiOtpLogin
     */
    readonly otp: string
}

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getSession(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthenticationApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public login(requestParameters: AuthenticationApiLoginRequest, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).login(requestParameters.loginBody, requestParameters.emailCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthenticationApiOtpLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public otpLogin(requestParameters: AuthenticationApiOtpLoginRequest, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).otpLogin(requestParameters.token, requestParameters.otp, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BrandingApi - axios parameter creator
 * @export
 */
export const BrandingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranding: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/branding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavicon: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/favicon.ico`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogo192: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/logo192.png`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManifest: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/manifest.json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Branding} branding 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBranding: async (branding: Branding, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'branding' is not null or undefined
            assertParamExists('setBranding', 'branding', branding)
            const localVarPath = `/api/branding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(branding, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandingApi - functional programming interface
 * @export
 */
export const BrandingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBranding(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOBrandingOrNull>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBranding(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BrandingApi.getBranding']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavicon(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavicon(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BrandingApi.getFavicon']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogo192(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogo192(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BrandingApi.getLogo192']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManifest(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Manifest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManifest(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BrandingApi.getManifest']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {Branding} branding 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setBranding(branding: Branding, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOBranding>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setBranding(branding, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['BrandingApi.setBranding']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * BrandingApi - factory interface
 * @export
 */
export const BrandingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandingApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranding(options?: AxiosRequestConfig): AxiosPromise<OutputDTOBrandingOrNull> {
            return localVarFp.getBranding(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavicon(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getFavicon(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogo192(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getLogo192(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManifest(options?: AxiosRequestConfig): AxiosPromise<Manifest> {
            return localVarFp.getManifest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BrandingApiSetBrandingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBranding(requestParameters: BrandingApiSetBrandingRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOBranding> {
            return localVarFp.setBranding(requestParameters.branding, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for setBranding operation in BrandingApi.
 * @export
 * @interface BrandingApiSetBrandingRequest
 */
export interface BrandingApiSetBrandingRequest {
    /**
     * 
     * @type {Branding}
     * @memberof BrandingApiSetBranding
     */
    readonly branding: Branding
}

/**
 * BrandingApi - object-oriented interface
 * @export
 * @class BrandingApi
 * @extends {BaseAPI}
 */
export class BrandingApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public getBranding(options?: AxiosRequestConfig) {
        return BrandingApiFp(this.configuration).getBranding(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public getFavicon(options?: AxiosRequestConfig) {
        return BrandingApiFp(this.configuration).getFavicon(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public getLogo192(options?: AxiosRequestConfig) {
        return BrandingApiFp(this.configuration).getLogo192(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public getManifest(options?: AxiosRequestConfig) {
        return BrandingApiFp(this.configuration).getManifest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BrandingApiSetBrandingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public setBranding(requestParameters: BrandingApiSetBrandingRequest, options?: AxiosRequestConfig) {
        return BrandingApiFp(this.configuration).setBranding(requestParameters.branding, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCompanyBody} createCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany: async (createCompanyBody: CreateCompanyBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCompanyBody' is not null or undefined
            assertParamExists('createCompany', 'createCompanyBody', createCompanyBody)
            const localVarPath = `/api/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCompany', 'id', id)
            const localVarPath = `/api/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompany', 'id', id)
            const localVarPath = `/api/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getCompanyList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getCompanyList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getCompanyList', 'limit', limit)
            const localVarPath = `/api/company/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyListQuery: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/company/list/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyMiniList: async (search: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getCompanyMiniList', 'search', search)
            const localVarPath = `/api/company/mini/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCompanyBody} updateCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany: async (id: string, updateCompanyBody: UpdateCompanyBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCompany', 'id', id)
            // verify required parameter 'updateCompanyBody' is not null or undefined
            assertParamExists('updateCompany', 'updateCompanyBody', updateCompanyBody)
            const localVarPath = `/api/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCompanyBody} createCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCompany(createCompanyBody: CreateCompanyBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOCompany>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCompany(createCompanyBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyApi.createCompany']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCompany(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOCompany>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCompany(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyApi.deleteCompany']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompany(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOCompany>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompany(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyApi.getCompany']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListCompany>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyApi.getCompanyList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyListQuery(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOQueryFilterTemplateArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyListQuery(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyApi.getCompanyListQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyMiniList(search: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOMiniCompanyArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyMiniList(search, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyApi.getCompanyMiniList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCompanyBody} updateCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompany(id: string, updateCompanyBody: UpdateCompanyBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOCompany>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompany(id, updateCompanyBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CompanyApi.updateCompany']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyApiFp(configuration)
    return {
        /**
         * 
         * @param {CompanyApiCreateCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany(requestParameters: CompanyApiCreateCompanyRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOCompany> {
            return localVarFp.createCompany(requestParameters.createCompanyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyApiDeleteCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany(requestParameters: CompanyApiDeleteCompanyRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOCompany> {
            return localVarFp.deleteCompany(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyApiGetCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(requestParameters: CompanyApiGetCompanyRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOCompany> {
            return localVarFp.getCompany(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyApiGetCompanyListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyList(requestParameters: CompanyApiGetCompanyListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListCompany> {
            return localVarFp.getCompanyList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyListQuery(options?: AxiosRequestConfig): AxiosPromise<OutputDTOQueryFilterTemplateArray> {
            return localVarFp.getCompanyListQuery(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyApiGetCompanyMiniListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyMiniList(requestParameters: CompanyApiGetCompanyMiniListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOMiniCompanyArray> {
            return localVarFp.getCompanyMiniList(requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyApiUpdateCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany(requestParameters: CompanyApiUpdateCompanyRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOCompany> {
            return localVarFp.updateCompany(requestParameters.id, requestParameters.updateCompanyBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createCompany operation in CompanyApi.
 * @export
 * @interface CompanyApiCreateCompanyRequest
 */
export interface CompanyApiCreateCompanyRequest {
    /**
     * 
     * @type {CreateCompanyBody}
     * @memberof CompanyApiCreateCompany
     */
    readonly createCompanyBody: CreateCompanyBody
}

/**
 * Request parameters for deleteCompany operation in CompanyApi.
 * @export
 * @interface CompanyApiDeleteCompanyRequest
 */
export interface CompanyApiDeleteCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyApiDeleteCompany
     */
    readonly id: string
}

/**
 * Request parameters for getCompany operation in CompanyApi.
 * @export
 * @interface CompanyApiGetCompanyRequest
 */
export interface CompanyApiGetCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyApiGetCompany
     */
    readonly id: string
}

/**
 * Request parameters for getCompanyList operation in CompanyApi.
 * @export
 * @interface CompanyApiGetCompanyListRequest
 */
export interface CompanyApiGetCompanyListRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyApiGetCompanyList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof CompanyApiGetCompanyList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof CompanyApiGetCompanyList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof CompanyApiGetCompanyList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof CompanyApiGetCompanyList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof CompanyApiGetCompanyList
     */
    readonly filters?: string
}

/**
 * Request parameters for getCompanyMiniList operation in CompanyApi.
 * @export
 * @interface CompanyApiGetCompanyMiniListRequest
 */
export interface CompanyApiGetCompanyMiniListRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyApiGetCompanyMiniList
     */
    readonly search: string
}

/**
 * Request parameters for updateCompany operation in CompanyApi.
 * @export
 * @interface CompanyApiUpdateCompanyRequest
 */
export interface CompanyApiUpdateCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyApiUpdateCompany
     */
    readonly id: string

    /**
     * 
     * @type {UpdateCompanyBody}
     * @memberof CompanyApiUpdateCompany
     */
    readonly updateCompanyBody: UpdateCompanyBody
}

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
    /**
     * 
     * @param {CompanyApiCreateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public createCompany(requestParameters: CompanyApiCreateCompanyRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).createCompany(requestParameters.createCompanyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyApiDeleteCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public deleteCompany(requestParameters: CompanyApiDeleteCompanyRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).deleteCompany(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyApiGetCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public getCompany(requestParameters: CompanyApiGetCompanyRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).getCompany(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyApiGetCompanyListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public getCompanyList(requestParameters: CompanyApiGetCompanyListRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).getCompanyList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public getCompanyListQuery(options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).getCompanyListQuery(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyApiGetCompanyMiniListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public getCompanyMiniList(requestParameters: CompanyApiGetCompanyMiniListRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).getCompanyMiniList(requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyApiUpdateCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public updateCompany(requestParameters: CompanyApiUpdateCompanyRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).updateCompany(requestParameters.id, requestParameters.updateCompanyBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContactApi - axios parameter creator
 * @export
 */
export const ContactApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateContactBody} createContactBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact: async (createContactBody: CreateContactBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createContactBody' is not null or undefined
            assertParamExists('createContact', 'createContactBody', createContactBody)
            const localVarPath = `/api/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContactBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteContact', 'id', id)
            const localVarPath = `/api/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getContact', 'id', id)
            const localVarPath = `/api/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getContactList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getContactList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getContactList', 'limit', limit)
            const localVarPath = `/api/contact/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} company 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactListByCompany: async (company: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'company' is not null or undefined
            assertParamExists('getContactListByCompany', 'company', company)
            const localVarPath = `/api/contact/list/by-company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactListQuery: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/contact/list/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateContactBody} updateContactBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact: async (id: string, updateContactBody: UpdateContactBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateContact', 'id', id)
            // verify required parameter 'updateContactBody' is not null or undefined
            assertParamExists('updateContact', 'updateContactBody', updateContactBody)
            const localVarPath = `/api/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContactBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactApi - functional programming interface
 * @export
 */
export const ContactApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateContactBody} createContactBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContact(createContactBody: CreateContactBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContact(createContactBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ContactApi.createContact']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContact(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContact(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ContactApi.deleteContact']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContact(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContact(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ContactApi.getContact']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ContactApi.getContactList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} company 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactListByCompany(company: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOContactArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactListByCompany(company, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ContactApi.getContactListByCompany']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactListQuery(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOQueryFilterTemplateArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactListQuery(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ContactApi.getContactListQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateContactBody} updateContactBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContact(id: string, updateContactBody: UpdateContactBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContact(id, updateContactBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ContactApi.updateContact']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ContactApi - factory interface
 * @export
 */
export const ContactApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactApiFp(configuration)
    return {
        /**
         * 
         * @param {ContactApiCreateContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact(requestParameters: ContactApiCreateContactRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOContact> {
            return localVarFp.createContact(requestParameters.createContactBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContactApiDeleteContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact(requestParameters: ContactApiDeleteContactRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOContact> {
            return localVarFp.deleteContact(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContactApiGetContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact(requestParameters: ContactApiGetContactRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOContact> {
            return localVarFp.getContact(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContactApiGetContactListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactList(requestParameters: ContactApiGetContactListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListContact> {
            return localVarFp.getContactList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContactApiGetContactListByCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactListByCompany(requestParameters: ContactApiGetContactListByCompanyRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOContactArray> {
            return localVarFp.getContactListByCompany(requestParameters.company, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactListQuery(options?: AxiosRequestConfig): AxiosPromise<OutputDTOQueryFilterTemplateArray> {
            return localVarFp.getContactListQuery(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContactApiUpdateContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact(requestParameters: ContactApiUpdateContactRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOContact> {
            return localVarFp.updateContact(requestParameters.id, requestParameters.updateContactBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createContact operation in ContactApi.
 * @export
 * @interface ContactApiCreateContactRequest
 */
export interface ContactApiCreateContactRequest {
    /**
     * 
     * @type {CreateContactBody}
     * @memberof ContactApiCreateContact
     */
    readonly createContactBody: CreateContactBody
}

/**
 * Request parameters for deleteContact operation in ContactApi.
 * @export
 * @interface ContactApiDeleteContactRequest
 */
export interface ContactApiDeleteContactRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactApiDeleteContact
     */
    readonly id: string
}

/**
 * Request parameters for getContact operation in ContactApi.
 * @export
 * @interface ContactApiGetContactRequest
 */
export interface ContactApiGetContactRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactApiGetContact
     */
    readonly id: string
}

/**
 * Request parameters for getContactList operation in ContactApi.
 * @export
 * @interface ContactApiGetContactListRequest
 */
export interface ContactApiGetContactListRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactApiGetContactList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof ContactApiGetContactList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof ContactApiGetContactList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof ContactApiGetContactList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof ContactApiGetContactList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof ContactApiGetContactList
     */
    readonly filters?: string
}

/**
 * Request parameters for getContactListByCompany operation in ContactApi.
 * @export
 * @interface ContactApiGetContactListByCompanyRequest
 */
export interface ContactApiGetContactListByCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactApiGetContactListByCompany
     */
    readonly company: string
}

/**
 * Request parameters for updateContact operation in ContactApi.
 * @export
 * @interface ContactApiUpdateContactRequest
 */
export interface ContactApiUpdateContactRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactApiUpdateContact
     */
    readonly id: string

    /**
     * 
     * @type {UpdateContactBody}
     * @memberof ContactApiUpdateContact
     */
    readonly updateContactBody: UpdateContactBody
}

/**
 * ContactApi - object-oriented interface
 * @export
 * @class ContactApi
 * @extends {BaseAPI}
 */
export class ContactApi extends BaseAPI {
    /**
     * 
     * @param {ContactApiCreateContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public createContact(requestParameters: ContactApiCreateContactRequest, options?: AxiosRequestConfig) {
        return ContactApiFp(this.configuration).createContact(requestParameters.createContactBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContactApiDeleteContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public deleteContact(requestParameters: ContactApiDeleteContactRequest, options?: AxiosRequestConfig) {
        return ContactApiFp(this.configuration).deleteContact(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContactApiGetContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public getContact(requestParameters: ContactApiGetContactRequest, options?: AxiosRequestConfig) {
        return ContactApiFp(this.configuration).getContact(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContactApiGetContactListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public getContactList(requestParameters: ContactApiGetContactListRequest, options?: AxiosRequestConfig) {
        return ContactApiFp(this.configuration).getContactList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContactApiGetContactListByCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public getContactListByCompany(requestParameters: ContactApiGetContactListByCompanyRequest, options?: AxiosRequestConfig) {
        return ContactApiFp(this.configuration).getContactListByCompany(requestParameters.company, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public getContactListQuery(options?: AxiosRequestConfig) {
        return ContactApiFp(this.configuration).getContactListQuery(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContactApiUpdateContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public updateContact(requestParameters: ContactApiUpdateContactRequest, options?: AxiosRequestConfig) {
        return ContactApiFp(this.configuration).updateContact(requestParameters.id, requestParameters.updateContactBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DateRange} dateRange 
         * @param {number} rangeDisplacement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard: async (dateRange: DateRange, rangeDisplacement: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateRange' is not null or undefined
            assertParamExists('getDashboard', 'dateRange', dateRange)
            // verify required parameter 'rangeDisplacement' is not null or undefined
            assertParamExists('getDashboard', 'rangeDisplacement', rangeDisplacement)
            const localVarPath = `/api/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateRange !== undefined) {
                localVarQueryParameter['dateRange'] = dateRange;
            }

            if (rangeDisplacement !== undefined) {
                localVarQueryParameter['rangeDisplacement'] = rangeDisplacement;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DateRange} dateRange 
         * @param {number} rangeDisplacement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboard(dateRange: DateRange, rangeDisplacement: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTODashboardData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboard(dateRange, rangeDisplacement, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DashboardApi.getDashboard']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {DashboardApiGetDashboardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard(requestParameters: DashboardApiGetDashboardRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTODashboardData> {
            return localVarFp.getDashboard(requestParameters.dateRange, requestParameters.rangeDisplacement, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getDashboard operation in DashboardApi.
 * @export
 * @interface DashboardApiGetDashboardRequest
 */
export interface DashboardApiGetDashboardRequest {
    /**
     * 
     * @type {DateRange}
     * @memberof DashboardApiGetDashboard
     */
    readonly dateRange: DateRange

    /**
     * 
     * @type {number}
     * @memberof DashboardApiGetDashboard
     */
    readonly rangeDisplacement: number
}

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * 
     * @param {DashboardApiGetDashboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getDashboard(requestParameters: DashboardApiGetDashboardRequest, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getDashboard(requestParameters.dateRange, requestParameters.rangeDisplacement, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DepartmentsApi - axios parameter creator
 * @export
 */
export const DepartmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateDepartmentBody} createDepartmentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepartment: async (createDepartmentBody: CreateDepartmentBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDepartmentBody' is not null or undefined
            assertParamExists('createDepartment', 'createDepartmentBody', createDepartmentBody)
            const localVarPath = `/api/departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDepartmentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDepartment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDepartment', 'id', id)
            const localVarPath = `/api/departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDepartment', 'id', id)
            const localVarPath = `/api/departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getDepartmentList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getDepartmentList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getDepartmentList', 'limit', limit)
            const localVarPath = `/api/departments/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentListQuery: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/departments/list/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentMiniList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/departments/list/mini`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDepartmentBody} updateDepartmentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepartment: async (id: string, updateDepartmentBody: UpdateDepartmentBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDepartment', 'id', id)
            // verify required parameter 'updateDepartmentBody' is not null or undefined
            assertParamExists('updateDepartment', 'updateDepartmentBody', updateDepartmentBody)
            const localVarPath = `/api/departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDepartmentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentsApi - functional programming interface
 * @export
 */
export const DepartmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateDepartmentBody} createDepartmentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDepartment(createDepartmentBody: CreateDepartmentBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDepartment(createDepartmentBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DepartmentsApi.createDepartment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDepartment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDepartment(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DepartmentsApi.deleteDepartment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepartment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTODepartment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepartment(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DepartmentsApi.getDepartment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepartmentList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListDepartment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepartmentList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DepartmentsApi.getDepartmentList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepartmentListQuery(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOQueryFilterTemplateArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepartmentListQuery(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DepartmentsApi.getDepartmentListQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepartmentMiniList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTODepartmentArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepartmentMiniList(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DepartmentsApi.getDepartmentMiniList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDepartmentBody} updateDepartmentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDepartment(id: string, updateDepartmentBody: UpdateDepartmentBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDepartment(id, updateDepartmentBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DepartmentsApi.updateDepartment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DepartmentsApi - factory interface
 * @export
 */
export const DepartmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentsApiFp(configuration)
    return {
        /**
         * 
         * @param {DepartmentsApiCreateDepartmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepartment(requestParameters: DepartmentsApiCreateDepartmentRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.createDepartment(requestParameters.createDepartmentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiDeleteDepartmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDepartment(requestParameters: DepartmentsApiDeleteDepartmentRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.deleteDepartment(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiGetDepartmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartment(requestParameters: DepartmentsApiGetDepartmentRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTODepartment> {
            return localVarFp.getDepartment(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiGetDepartmentListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentList(requestParameters: DepartmentsApiGetDepartmentListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListDepartment> {
            return localVarFp.getDepartmentList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentListQuery(options?: AxiosRequestConfig): AxiosPromise<OutputDTOQueryFilterTemplateArray> {
            return localVarFp.getDepartmentListQuery(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentMiniList(options?: AxiosRequestConfig): AxiosPromise<OutputDTODepartmentArray> {
            return localVarFp.getDepartmentMiniList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiUpdateDepartmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepartment(requestParameters: DepartmentsApiUpdateDepartmentRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.updateDepartment(requestParameters.id, requestParameters.updateDepartmentBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createDepartment operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiCreateDepartmentRequest
 */
export interface DepartmentsApiCreateDepartmentRequest {
    /**
     * 
     * @type {CreateDepartmentBody}
     * @memberof DepartmentsApiCreateDepartment
     */
    readonly createDepartmentBody: CreateDepartmentBody
}

/**
 * Request parameters for deleteDepartment operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiDeleteDepartmentRequest
 */
export interface DepartmentsApiDeleteDepartmentRequest {
    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiDeleteDepartment
     */
    readonly id: string
}

/**
 * Request parameters for getDepartment operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiGetDepartmentRequest
 */
export interface DepartmentsApiGetDepartmentRequest {
    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiGetDepartment
     */
    readonly id: string
}

/**
 * Request parameters for getDepartmentList operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiGetDepartmentListRequest
 */
export interface DepartmentsApiGetDepartmentListRequest {
    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiGetDepartmentList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof DepartmentsApiGetDepartmentList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof DepartmentsApiGetDepartmentList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiGetDepartmentList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof DepartmentsApiGetDepartmentList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiGetDepartmentList
     */
    readonly filters?: string
}

/**
 * Request parameters for updateDepartment operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiUpdateDepartmentRequest
 */
export interface DepartmentsApiUpdateDepartmentRequest {
    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiUpdateDepartment
     */
    readonly id: string

    /**
     * 
     * @type {UpdateDepartmentBody}
     * @memberof DepartmentsApiUpdateDepartment
     */
    readonly updateDepartmentBody: UpdateDepartmentBody
}

/**
 * DepartmentsApi - object-oriented interface
 * @export
 * @class DepartmentsApi
 * @extends {BaseAPI}
 */
export class DepartmentsApi extends BaseAPI {
    /**
     * 
     * @param {DepartmentsApiCreateDepartmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public createDepartment(requestParameters: DepartmentsApiCreateDepartmentRequest, options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).createDepartment(requestParameters.createDepartmentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiDeleteDepartmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public deleteDepartment(requestParameters: DepartmentsApiDeleteDepartmentRequest, options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).deleteDepartment(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiGetDepartmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public getDepartment(requestParameters: DepartmentsApiGetDepartmentRequest, options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).getDepartment(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiGetDepartmentListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public getDepartmentList(requestParameters: DepartmentsApiGetDepartmentListRequest, options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).getDepartmentList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public getDepartmentListQuery(options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).getDepartmentListQuery(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public getDepartmentMiniList(options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).getDepartmentMiniList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiUpdateDepartmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public updateDepartment(requestParameters: DepartmentsApiUpdateDepartmentRequest, options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).updateDepartment(requestParameters.id, requestParameters.updateDepartmentBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FTPApi - axios parameter creator
 * @export
 */
export const FTPApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDirectory: async (path: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('createDirectory', 'path', path)
            const localVarPath = `/api/ftp/directory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileUpload: async (path: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('createFileUpload', 'path', path)
            const localVarPath = `/api/ftp/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectory: async (path: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('deleteDirectory', 'path', path)
            const localVarPath = `/api/ftp/directory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: async (path: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('deleteFile', 'path', path)
            const localVarPath = `/api/ftp/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} path 
         * @param {string} ticketId 
         * @param {boolean} [disableForceDownload] 
         * @param {string} [mimeType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileDownload: async (path: string, ticketId: string, disableForceDownload?: boolean, mimeType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('getFileDownload', 'path', path)
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('getFileDownload', 'ticketId', ticketId)
            const localVarPath = `/api/ftp/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }

            if (disableForceDownload !== undefined) {
                localVarQueryParameter['disableForceDownload'] = disableForceDownload;
            }

            if (mimeType !== undefined) {
                localVarQueryParameter['mimeType'] = mimeType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileList: async (path: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('getFileList', 'path', path)
            const localVarPath = `/api/ftp/file/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} oldPath 
         * @param {string} newPath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFilename: async (oldPath: string, newPath: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'oldPath' is not null or undefined
            assertParamExists('updateFilename', 'oldPath', oldPath)
            // verify required parameter 'newPath' is not null or undefined
            assertParamExists('updateFilename', 'newPath', newPath)
            const localVarPath = `/api/ftp/file/name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (oldPath !== undefined) {
                localVarQueryParameter['oldPath'] = oldPath;
            }

            if (newPath !== undefined) {
                localVarQueryParameter['newPath'] = newPath;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FTPApi - functional programming interface
 * @export
 */
export const FTPApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FTPApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDirectory(path: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDirectory(path, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FTPApi.createDirectory']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFileUpload(path: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFileUpload(path, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FTPApi.createFileUpload']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDirectory(path: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDirectory(path, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FTPApi.deleteDirectory']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFile(path: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFile(path, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FTPApi.deleteFile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} path 
         * @param {string} ticketId 
         * @param {boolean} [disableForceDownload] 
         * @param {string} [mimeType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileDownload(path: string, ticketId: string, disableForceDownload?: boolean, mimeType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileDownload(path, ticketId, disableForceDownload, mimeType, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FTPApi.getFileDownload']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileList(path: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOFileInfoArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileList(path, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FTPApi.getFileList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} oldPath 
         * @param {string} newPath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFilename(oldPath: string, newPath: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFilename(oldPath, newPath, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FTPApi.updateFilename']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FTPApi - factory interface
 * @export
 */
export const FTPApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FTPApiFp(configuration)
    return {
        /**
         * 
         * @param {FTPApiCreateDirectoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDirectory(requestParameters: FTPApiCreateDirectoryRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.createDirectory(requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FTPApiCreateFileUploadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileUpload(requestParameters: FTPApiCreateFileUploadRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.createFileUpload(requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FTPApiDeleteDirectoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectory(requestParameters: FTPApiDeleteDirectoryRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.deleteDirectory(requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FTPApiDeleteFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(requestParameters: FTPApiDeleteFileRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.deleteFile(requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FTPApiGetFileDownloadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileDownload(requestParameters: FTPApiGetFileDownloadRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getFileDownload(requestParameters.path, requestParameters.ticketId, requestParameters.disableForceDownload, requestParameters.mimeType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FTPApiGetFileListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileList(requestParameters: FTPApiGetFileListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOFileInfoArray> {
            return localVarFp.getFileList(requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FTPApiUpdateFilenameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFilename(requestParameters: FTPApiUpdateFilenameRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.updateFilename(requestParameters.oldPath, requestParameters.newPath, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createDirectory operation in FTPApi.
 * @export
 * @interface FTPApiCreateDirectoryRequest
 */
export interface FTPApiCreateDirectoryRequest {
    /**
     * 
     * @type {string}
     * @memberof FTPApiCreateDirectory
     */
    readonly path: string
}

/**
 * Request parameters for createFileUpload operation in FTPApi.
 * @export
 * @interface FTPApiCreateFileUploadRequest
 */
export interface FTPApiCreateFileUploadRequest {
    /**
     * 
     * @type {string}
     * @memberof FTPApiCreateFileUpload
     */
    readonly path: string
}

/**
 * Request parameters for deleteDirectory operation in FTPApi.
 * @export
 * @interface FTPApiDeleteDirectoryRequest
 */
export interface FTPApiDeleteDirectoryRequest {
    /**
     * 
     * @type {string}
     * @memberof FTPApiDeleteDirectory
     */
    readonly path: string
}

/**
 * Request parameters for deleteFile operation in FTPApi.
 * @export
 * @interface FTPApiDeleteFileRequest
 */
export interface FTPApiDeleteFileRequest {
    /**
     * 
     * @type {string}
     * @memberof FTPApiDeleteFile
     */
    readonly path: string
}

/**
 * Request parameters for getFileDownload operation in FTPApi.
 * @export
 * @interface FTPApiGetFileDownloadRequest
 */
export interface FTPApiGetFileDownloadRequest {
    /**
     * 
     * @type {string}
     * @memberof FTPApiGetFileDownload
     */
    readonly path: string

    /**
     * 
     * @type {string}
     * @memberof FTPApiGetFileDownload
     */
    readonly ticketId: string

    /**
     * 
     * @type {boolean}
     * @memberof FTPApiGetFileDownload
     */
    readonly disableForceDownload?: boolean

    /**
     * 
     * @type {string}
     * @memberof FTPApiGetFileDownload
     */
    readonly mimeType?: string
}

/**
 * Request parameters for getFileList operation in FTPApi.
 * @export
 * @interface FTPApiGetFileListRequest
 */
export interface FTPApiGetFileListRequest {
    /**
     * 
     * @type {string}
     * @memberof FTPApiGetFileList
     */
    readonly path: string
}

/**
 * Request parameters for updateFilename operation in FTPApi.
 * @export
 * @interface FTPApiUpdateFilenameRequest
 */
export interface FTPApiUpdateFilenameRequest {
    /**
     * 
     * @type {string}
     * @memberof FTPApiUpdateFilename
     */
    readonly oldPath: string

    /**
     * 
     * @type {string}
     * @memberof FTPApiUpdateFilename
     */
    readonly newPath: string
}

/**
 * FTPApi - object-oriented interface
 * @export
 * @class FTPApi
 * @extends {BaseAPI}
 */
export class FTPApi extends BaseAPI {
    /**
     * 
     * @param {FTPApiCreateDirectoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public createDirectory(requestParameters: FTPApiCreateDirectoryRequest, options?: AxiosRequestConfig) {
        return FTPApiFp(this.configuration).createDirectory(requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FTPApiCreateFileUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public createFileUpload(requestParameters: FTPApiCreateFileUploadRequest, options?: AxiosRequestConfig) {
        return FTPApiFp(this.configuration).createFileUpload(requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FTPApiDeleteDirectoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public deleteDirectory(requestParameters: FTPApiDeleteDirectoryRequest, options?: AxiosRequestConfig) {
        return FTPApiFp(this.configuration).deleteDirectory(requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FTPApiDeleteFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public deleteFile(requestParameters: FTPApiDeleteFileRequest, options?: AxiosRequestConfig) {
        return FTPApiFp(this.configuration).deleteFile(requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FTPApiGetFileDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public getFileDownload(requestParameters: FTPApiGetFileDownloadRequest, options?: AxiosRequestConfig) {
        return FTPApiFp(this.configuration).getFileDownload(requestParameters.path, requestParameters.ticketId, requestParameters.disableForceDownload, requestParameters.mimeType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FTPApiGetFileListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public getFileList(requestParameters: FTPApiGetFileListRequest, options?: AxiosRequestConfig) {
        return FTPApiFp(this.configuration).getFileList(requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FTPApiUpdateFilenameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FTPApi
     */
    public updateFilename(requestParameters: FTPApiUpdateFilenameRequest, options?: AxiosRequestConfig) {
        return FTPApiFp(this.configuration).updateFilename(requestParameters.oldPath, requestParameters.newPath, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FilterViewApi - axios parameter creator
 * @export
 */
export const FilterViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateFilterViewBody} createFilterViewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFilterView: async (createFilterViewBody: CreateFilterViewBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFilterViewBody' is not null or undefined
            assertParamExists('createFilterView', 'createFilterViewBody', createFilterViewBody)
            const localVarPath = `/api/filter-view`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFilterViewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilterView: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFilterView', 'id', id)
            const localVarPath = `/api/filter-view`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LogModel} model 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyFilterViewList: async (model: LogModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'model' is not null or undefined
            assertParamExists('getMyFilterViewList', 'model', model)
            const localVarPath = `/api/filter-view/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateFilterViewBody} updateFilterViewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFilterView: async (id: string, updateFilterViewBody: UpdateFilterViewBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFilterView', 'id', id)
            // verify required parameter 'updateFilterViewBody' is not null or undefined
            assertParamExists('updateFilterView', 'updateFilterViewBody', updateFilterViewBody)
            const localVarPath = `/api/filter-view`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFilterViewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilterViewApi - functional programming interface
 * @export
 */
export const FilterViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilterViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateFilterViewBody} createFilterViewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFilterView(createFilterViewBody: CreateFilterViewBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOFilterView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFilterView(createFilterViewBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FilterViewApi.createFilterView']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFilterView(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOFilterView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFilterView(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FilterViewApi.deleteFilterView']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {LogModel} model 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyFilterViewList(model: LogModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOFilterViewArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyFilterViewList(model, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FilterViewApi.getMyFilterViewList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateFilterViewBody} updateFilterViewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFilterView(id: string, updateFilterViewBody: UpdateFilterViewBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOFilterView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFilterView(id, updateFilterViewBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FilterViewApi.updateFilterView']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FilterViewApi - factory interface
 * @export
 */
export const FilterViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilterViewApiFp(configuration)
    return {
        /**
         * 
         * @param {FilterViewApiCreateFilterViewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFilterView(requestParameters: FilterViewApiCreateFilterViewRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOFilterView> {
            return localVarFp.createFilterView(requestParameters.createFilterViewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilterViewApiDeleteFilterViewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilterView(requestParameters: FilterViewApiDeleteFilterViewRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOFilterView> {
            return localVarFp.deleteFilterView(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilterViewApiGetMyFilterViewListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyFilterViewList(requestParameters: FilterViewApiGetMyFilterViewListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOFilterViewArray> {
            return localVarFp.getMyFilterViewList(requestParameters.model, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilterViewApiUpdateFilterViewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFilterView(requestParameters: FilterViewApiUpdateFilterViewRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOFilterView> {
            return localVarFp.updateFilterView(requestParameters.id, requestParameters.updateFilterViewBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createFilterView operation in FilterViewApi.
 * @export
 * @interface FilterViewApiCreateFilterViewRequest
 */
export interface FilterViewApiCreateFilterViewRequest {
    /**
     * 
     * @type {CreateFilterViewBody}
     * @memberof FilterViewApiCreateFilterView
     */
    readonly createFilterViewBody: CreateFilterViewBody
}

/**
 * Request parameters for deleteFilterView operation in FilterViewApi.
 * @export
 * @interface FilterViewApiDeleteFilterViewRequest
 */
export interface FilterViewApiDeleteFilterViewRequest {
    /**
     * 
     * @type {string}
     * @memberof FilterViewApiDeleteFilterView
     */
    readonly id: string
}

/**
 * Request parameters for getMyFilterViewList operation in FilterViewApi.
 * @export
 * @interface FilterViewApiGetMyFilterViewListRequest
 */
export interface FilterViewApiGetMyFilterViewListRequest {
    /**
     * 
     * @type {LogModel}
     * @memberof FilterViewApiGetMyFilterViewList
     */
    readonly model: LogModel
}

/**
 * Request parameters for updateFilterView operation in FilterViewApi.
 * @export
 * @interface FilterViewApiUpdateFilterViewRequest
 */
export interface FilterViewApiUpdateFilterViewRequest {
    /**
     * 
     * @type {string}
     * @memberof FilterViewApiUpdateFilterView
     */
    readonly id: string

    /**
     * 
     * @type {UpdateFilterViewBody}
     * @memberof FilterViewApiUpdateFilterView
     */
    readonly updateFilterViewBody: UpdateFilterViewBody
}

/**
 * FilterViewApi - object-oriented interface
 * @export
 * @class FilterViewApi
 * @extends {BaseAPI}
 */
export class FilterViewApi extends BaseAPI {
    /**
     * 
     * @param {FilterViewApiCreateFilterViewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterViewApi
     */
    public createFilterView(requestParameters: FilterViewApiCreateFilterViewRequest, options?: AxiosRequestConfig) {
        return FilterViewApiFp(this.configuration).createFilterView(requestParameters.createFilterViewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilterViewApiDeleteFilterViewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterViewApi
     */
    public deleteFilterView(requestParameters: FilterViewApiDeleteFilterViewRequest, options?: AxiosRequestConfig) {
        return FilterViewApiFp(this.configuration).deleteFilterView(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilterViewApiGetMyFilterViewListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterViewApi
     */
    public getMyFilterViewList(requestParameters: FilterViewApiGetMyFilterViewListRequest, options?: AxiosRequestConfig) {
        return FilterViewApiFp(this.configuration).getMyFilterViewList(requestParameters.model, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilterViewApiUpdateFilterViewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterViewApi
     */
    public updateFilterView(requestParameters: FilterViewApiUpdateFilterViewRequest, options?: AxiosRequestConfig) {
        return FilterViewApiFp(this.configuration).updateFilterView(requestParameters.id, requestParameters.updateFilterViewBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FirewallApi - axios parameter creator
 * @export
 */
export const FirewallApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateRecordBody} createRecordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecord: async (createRecordBody: CreateRecordBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRecordBody' is not null or undefined
            assertParamExists('createRecord', 'createRecordBody', createRecordBody)
            const localVarPath = `/api/firewall`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRecordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRecord: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRecord', 'id', id)
            const localVarPath = `/api/firewall`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecord: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRecord', 'id', id)
            const localVarPath = `/api/firewall`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecordList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getRecordList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getRecordList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getRecordList', 'limit', limit)
            const localVarPath = `/api/firewall/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecordListQuery: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/firewall/list/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateRecordBody} updateRecordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecord: async (id: string, updateRecordBody: UpdateRecordBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRecord', 'id', id)
            // verify required parameter 'updateRecordBody' is not null or undefined
            assertParamExists('updateRecord', 'updateRecordBody', updateRecordBody)
            const localVarPath = `/api/firewall`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRecordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FirewallApi - functional programming interface
 * @export
 */
export const FirewallApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FirewallApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateRecordBody} createRecordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRecord(createRecordBody: CreateRecordBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOFirewallRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRecord(createRecordBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FirewallApi.createRecord']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRecord(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRecord(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FirewallApi.deleteRecord']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecord(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOFirewallRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecord(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FirewallApi.getRecord']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecordList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListFirewallRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecordList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FirewallApi.getRecordList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecordListQuery(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOQueryFilterTemplateArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecordListQuery(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FirewallApi.getRecordListQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateRecordBody} updateRecordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRecord(id: string, updateRecordBody: UpdateRecordBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOFirewallRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRecord(id, updateRecordBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FirewallApi.updateRecord']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FirewallApi - factory interface
 * @export
 */
export const FirewallApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FirewallApiFp(configuration)
    return {
        /**
         * 
         * @param {FirewallApiCreateRecordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecord(requestParameters: FirewallApiCreateRecordRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOFirewallRecord> {
            return localVarFp.createRecord(requestParameters.createRecordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FirewallApiDeleteRecordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRecord(requestParameters: FirewallApiDeleteRecordRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.deleteRecord(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FirewallApiGetRecordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecord(requestParameters: FirewallApiGetRecordRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOFirewallRecord> {
            return localVarFp.getRecord(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FirewallApiGetRecordListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecordList(requestParameters: FirewallApiGetRecordListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListFirewallRecord> {
            return localVarFp.getRecordList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecordListQuery(options?: AxiosRequestConfig): AxiosPromise<OutputDTOQueryFilterTemplateArray> {
            return localVarFp.getRecordListQuery(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FirewallApiUpdateRecordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecord(requestParameters: FirewallApiUpdateRecordRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOFirewallRecord> {
            return localVarFp.updateRecord(requestParameters.id, requestParameters.updateRecordBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createRecord operation in FirewallApi.
 * @export
 * @interface FirewallApiCreateRecordRequest
 */
export interface FirewallApiCreateRecordRequest {
    /**
     * 
     * @type {CreateRecordBody}
     * @memberof FirewallApiCreateRecord
     */
    readonly createRecordBody: CreateRecordBody
}

/**
 * Request parameters for deleteRecord operation in FirewallApi.
 * @export
 * @interface FirewallApiDeleteRecordRequest
 */
export interface FirewallApiDeleteRecordRequest {
    /**
     * 
     * @type {string}
     * @memberof FirewallApiDeleteRecord
     */
    readonly id: string
}

/**
 * Request parameters for getRecord operation in FirewallApi.
 * @export
 * @interface FirewallApiGetRecordRequest
 */
export interface FirewallApiGetRecordRequest {
    /**
     * 
     * @type {string}
     * @memberof FirewallApiGetRecord
     */
    readonly id: string
}

/**
 * Request parameters for getRecordList operation in FirewallApi.
 * @export
 * @interface FirewallApiGetRecordListRequest
 */
export interface FirewallApiGetRecordListRequest {
    /**
     * 
     * @type {string}
     * @memberof FirewallApiGetRecordList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof FirewallApiGetRecordList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof FirewallApiGetRecordList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof FirewallApiGetRecordList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof FirewallApiGetRecordList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof FirewallApiGetRecordList
     */
    readonly filters?: string
}

/**
 * Request parameters for updateRecord operation in FirewallApi.
 * @export
 * @interface FirewallApiUpdateRecordRequest
 */
export interface FirewallApiUpdateRecordRequest {
    /**
     * 
     * @type {string}
     * @memberof FirewallApiUpdateRecord
     */
    readonly id: string

    /**
     * 
     * @type {UpdateRecordBody}
     * @memberof FirewallApiUpdateRecord
     */
    readonly updateRecordBody: UpdateRecordBody
}

/**
 * FirewallApi - object-oriented interface
 * @export
 * @class FirewallApi
 * @extends {BaseAPI}
 */
export class FirewallApi extends BaseAPI {
    /**
     * 
     * @param {FirewallApiCreateRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirewallApi
     */
    public createRecord(requestParameters: FirewallApiCreateRecordRequest, options?: AxiosRequestConfig) {
        return FirewallApiFp(this.configuration).createRecord(requestParameters.createRecordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FirewallApiDeleteRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirewallApi
     */
    public deleteRecord(requestParameters: FirewallApiDeleteRecordRequest, options?: AxiosRequestConfig) {
        return FirewallApiFp(this.configuration).deleteRecord(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FirewallApiGetRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirewallApi
     */
    public getRecord(requestParameters: FirewallApiGetRecordRequest, options?: AxiosRequestConfig) {
        return FirewallApiFp(this.configuration).getRecord(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FirewallApiGetRecordListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirewallApi
     */
    public getRecordList(requestParameters: FirewallApiGetRecordListRequest, options?: AxiosRequestConfig) {
        return FirewallApiFp(this.configuration).getRecordList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirewallApi
     */
    public getRecordListQuery(options?: AxiosRequestConfig) {
        return FirewallApiFp(this.configuration).getRecordListQuery(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FirewallApiUpdateRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirewallApi
     */
    public updateRecord(requestParameters: FirewallApiUpdateRecordRequest, options?: AxiosRequestConfig) {
        return FirewallApiFp(this.configuration).updateRecord(requestParameters.id, requestParameters.updateRecordBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImportApi - axios parameter creator
 * @export
 */
export const ImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ImportableModel} model 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createImportSynchronization: async (model: ImportableModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'model' is not null or undefined
            assertParamExists('createImportSynchronization', 'model', model)
            const localVarPath = `/api/import/synchronize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportableModel} model 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportConfig: async (model: ImportableModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'model' is not null or undefined
            assertParamExists('getImportConfig', 'model', model)
            const localVarPath = `/api/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportableModel} model 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetImportConfig: async (model: ImportableModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'model' is not null or undefined
            assertParamExists('resetImportConfig', 'model', model)
            const localVarPath = `/api/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportableModel} model 
         * @param {PartialImportConfig} partialImportConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateImportConfig: async (model: ImportableModel, partialImportConfig: PartialImportConfig, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'model' is not null or undefined
            assertParamExists('updateImportConfig', 'model', model)
            // verify required parameter 'partialImportConfig' is not null or undefined
            assertParamExists('updateImportConfig', 'partialImportConfig', partialImportConfig)
            const localVarPath = `/api/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialImportConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportApi - functional programming interface
 * @export
 */
export const ImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ImportableModel} model 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createImportSynchronization(model: ImportableModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createImportSynchronization(model, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ImportApi.createImportSynchronization']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {ImportableModel} model 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImportConfig(model: ImportableModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOImportConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImportConfig(model, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ImportApi.getImportConfig']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {ImportableModel} model 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetImportConfig(model: ImportableModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetImportConfig(model, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ImportApi.resetImportConfig']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {ImportableModel} model 
         * @param {PartialImportConfig} partialImportConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateImportConfig(model: ImportableModel, partialImportConfig: PartialImportConfig, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOImportConfigOrNull>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateImportConfig(model, partialImportConfig, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ImportApi.updateImportConfig']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ImportApi - factory interface
 * @export
 */
export const ImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImportApiFp(configuration)
    return {
        /**
         * 
         * @param {ImportApiCreateImportSynchronizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createImportSynchronization(requestParameters: ImportApiCreateImportSynchronizationRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.createImportSynchronization(requestParameters.model, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ImportApiGetImportConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportConfig(requestParameters: ImportApiGetImportConfigRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOImportConfig> {
            return localVarFp.getImportConfig(requestParameters.model, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ImportApiResetImportConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetImportConfig(requestParameters: ImportApiResetImportConfigRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOContact> {
            return localVarFp.resetImportConfig(requestParameters.model, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ImportApiUpdateImportConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateImportConfig(requestParameters: ImportApiUpdateImportConfigRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOImportConfigOrNull> {
            return localVarFp.updateImportConfig(requestParameters.model, requestParameters.partialImportConfig, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createImportSynchronization operation in ImportApi.
 * @export
 * @interface ImportApiCreateImportSynchronizationRequest
 */
export interface ImportApiCreateImportSynchronizationRequest {
    /**
     * 
     * @type {ImportableModel}
     * @memberof ImportApiCreateImportSynchronization
     */
    readonly model: ImportableModel
}

/**
 * Request parameters for getImportConfig operation in ImportApi.
 * @export
 * @interface ImportApiGetImportConfigRequest
 */
export interface ImportApiGetImportConfigRequest {
    /**
     * 
     * @type {ImportableModel}
     * @memberof ImportApiGetImportConfig
     */
    readonly model: ImportableModel
}

/**
 * Request parameters for resetImportConfig operation in ImportApi.
 * @export
 * @interface ImportApiResetImportConfigRequest
 */
export interface ImportApiResetImportConfigRequest {
    /**
     * 
     * @type {ImportableModel}
     * @memberof ImportApiResetImportConfig
     */
    readonly model: ImportableModel
}

/**
 * Request parameters for updateImportConfig operation in ImportApi.
 * @export
 * @interface ImportApiUpdateImportConfigRequest
 */
export interface ImportApiUpdateImportConfigRequest {
    /**
     * 
     * @type {ImportableModel}
     * @memberof ImportApiUpdateImportConfig
     */
    readonly model: ImportableModel

    /**
     * 
     * @type {PartialImportConfig}
     * @memberof ImportApiUpdateImportConfig
     */
    readonly partialImportConfig: PartialImportConfig
}

/**
 * ImportApi - object-oriented interface
 * @export
 * @class ImportApi
 * @extends {BaseAPI}
 */
export class ImportApi extends BaseAPI {
    /**
     * 
     * @param {ImportApiCreateImportSynchronizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApi
     */
    public createImportSynchronization(requestParameters: ImportApiCreateImportSynchronizationRequest, options?: AxiosRequestConfig) {
        return ImportApiFp(this.configuration).createImportSynchronization(requestParameters.model, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ImportApiGetImportConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApi
     */
    public getImportConfig(requestParameters: ImportApiGetImportConfigRequest, options?: AxiosRequestConfig) {
        return ImportApiFp(this.configuration).getImportConfig(requestParameters.model, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ImportApiResetImportConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApi
     */
    public resetImportConfig(requestParameters: ImportApiResetImportConfigRequest, options?: AxiosRequestConfig) {
        return ImportApiFp(this.configuration).resetImportConfig(requestParameters.model, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ImportApiUpdateImportConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApi
     */
    public updateImportConfig(requestParameters: ImportApiUpdateImportConfigRequest, options?: AxiosRequestConfig) {
        return ImportApiFp(this.configuration).updateImportConfig(requestParameters.model, requestParameters.partialImportConfig, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InterfacesApi - axios parameter creator
 * @export
 */
export const InterfacesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterInterface: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/interface/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTableInterface: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/interface/table`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InterfacesApi - functional programming interface
 * @export
 */
export const InterfacesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InterfacesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilterInterface(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFilterInterface200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilterInterface(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InterfacesApi.getFilterInterface']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTableInterface(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListAny>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTableInterface(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['InterfacesApi.getTableInterface']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * InterfacesApi - factory interface
 * @export
 */
export const InterfacesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InterfacesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterInterface(options?: AxiosRequestConfig): AxiosPromise<GetFilterInterface200Response> {
            return localVarFp.getFilterInterface(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTableInterface(options?: AxiosRequestConfig): AxiosPromise<PaginatedListAny> {
            return localVarFp.getTableInterface(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InterfacesApi - object-oriented interface
 * @export
 * @class InterfacesApi
 * @extends {BaseAPI}
 */
export class InterfacesApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterfacesApi
     */
    public getFilterInterface(options?: AxiosRequestConfig) {
        return InterfacesApiFp(this.configuration).getFilterInterface(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterfacesApi
     */
    public getTableInterface(options?: AxiosRequestConfig) {
        return InterfacesApiFp(this.configuration).getTableInterface(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ItemApi - axios parameter creator
 * @export
 */
export const ItemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateItemBody} createItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createItem: async (createItemBody: CreateItemBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createItemBody' is not null or undefined
            assertParamExists('createItem', 'createItemBody', createItemBody)
            const localVarPath = `/api/item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createItemBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItem: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItem', 'id', id)
            const localVarPath = `/api/item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getItemList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getItemList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getItemList', 'limit', limit)
            const localVarPath = `/api/item/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemListQuery: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/item/list/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateItemBody} updateItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItem: async (id: string, updateItemBody: UpdateItemBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateItem', 'id', id)
            // verify required parameter 'updateItemBody' is not null or undefined
            assertParamExists('updateItem', 'updateItemBody', updateItemBody)
            const localVarPath = `/api/item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateItemBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateItemHandInBody} updateItemHandInBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItemHandIn: async (id: string, updateItemHandInBody: UpdateItemHandInBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateItemHandIn', 'id', id)
            // verify required parameter 'updateItemHandInBody' is not null or undefined
            assertParamExists('updateItemHandIn', 'updateItemHandInBody', updateItemHandInBody)
            const localVarPath = `/api/item/handin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateItemHandInBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ItemApi - functional programming interface
 * @export
 */
export const ItemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ItemApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateItemBody} createItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createItem(createItemBody: CreateItemBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createItem(createItemBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ItemApi.createItem']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItem(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItem(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ItemApi.deleteItem']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ItemApi.getItemList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemListQuery(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOQueryFilterTemplateArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemListQuery(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ItemApi.getItemListQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateItemBody} updateItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateItem(id: string, updateItemBody: UpdateItemBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateItem(id, updateItemBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ItemApi.updateItem']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateItemHandInBody} updateItemHandInBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateItemHandIn(id: string, updateItemHandInBody: UpdateItemHandInBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateItemHandIn(id, updateItemHandInBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ItemApi.updateItemHandIn']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ItemApi - factory interface
 * @export
 */
export const ItemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ItemApiFp(configuration)
    return {
        /**
         * 
         * @param {ItemApiCreateItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createItem(requestParameters: ItemApiCreateItemRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOItem> {
            return localVarFp.createItem(requestParameters.createItemBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ItemApiDeleteItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItem(requestParameters: ItemApiDeleteItemRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.deleteItem(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ItemApiGetItemListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemList(requestParameters: ItemApiGetItemListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListItem> {
            return localVarFp.getItemList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemListQuery(options?: AxiosRequestConfig): AxiosPromise<OutputDTOQueryFilterTemplateArray> {
            return localVarFp.getItemListQuery(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ItemApiUpdateItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItem(requestParameters: ItemApiUpdateItemRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOItem> {
            return localVarFp.updateItem(requestParameters.id, requestParameters.updateItemBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ItemApiUpdateItemHandInRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItemHandIn(requestParameters: ItemApiUpdateItemHandInRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOItem> {
            return localVarFp.updateItemHandIn(requestParameters.id, requestParameters.updateItemHandInBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createItem operation in ItemApi.
 * @export
 * @interface ItemApiCreateItemRequest
 */
export interface ItemApiCreateItemRequest {
    /**
     * 
     * @type {CreateItemBody}
     * @memberof ItemApiCreateItem
     */
    readonly createItemBody: CreateItemBody
}

/**
 * Request parameters for deleteItem operation in ItemApi.
 * @export
 * @interface ItemApiDeleteItemRequest
 */
export interface ItemApiDeleteItemRequest {
    /**
     * 
     * @type {string}
     * @memberof ItemApiDeleteItem
     */
    readonly id: string
}

/**
 * Request parameters for getItemList operation in ItemApi.
 * @export
 * @interface ItemApiGetItemListRequest
 */
export interface ItemApiGetItemListRequest {
    /**
     * 
     * @type {string}
     * @memberof ItemApiGetItemList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof ItemApiGetItemList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof ItemApiGetItemList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof ItemApiGetItemList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof ItemApiGetItemList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof ItemApiGetItemList
     */
    readonly filters?: string
}

/**
 * Request parameters for updateItem operation in ItemApi.
 * @export
 * @interface ItemApiUpdateItemRequest
 */
export interface ItemApiUpdateItemRequest {
    /**
     * 
     * @type {string}
     * @memberof ItemApiUpdateItem
     */
    readonly id: string

    /**
     * 
     * @type {UpdateItemBody}
     * @memberof ItemApiUpdateItem
     */
    readonly updateItemBody: UpdateItemBody
}

/**
 * Request parameters for updateItemHandIn operation in ItemApi.
 * @export
 * @interface ItemApiUpdateItemHandInRequest
 */
export interface ItemApiUpdateItemHandInRequest {
    /**
     * 
     * @type {string}
     * @memberof ItemApiUpdateItemHandIn
     */
    readonly id: string

    /**
     * 
     * @type {UpdateItemHandInBody}
     * @memberof ItemApiUpdateItemHandIn
     */
    readonly updateItemHandInBody: UpdateItemHandInBody
}

/**
 * ItemApi - object-oriented interface
 * @export
 * @class ItemApi
 * @extends {BaseAPI}
 */
export class ItemApi extends BaseAPI {
    /**
     * 
     * @param {ItemApiCreateItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemApi
     */
    public createItem(requestParameters: ItemApiCreateItemRequest, options?: AxiosRequestConfig) {
        return ItemApiFp(this.configuration).createItem(requestParameters.createItemBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ItemApiDeleteItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemApi
     */
    public deleteItem(requestParameters: ItemApiDeleteItemRequest, options?: AxiosRequestConfig) {
        return ItemApiFp(this.configuration).deleteItem(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ItemApiGetItemListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemApi
     */
    public getItemList(requestParameters: ItemApiGetItemListRequest, options?: AxiosRequestConfig) {
        return ItemApiFp(this.configuration).getItemList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemApi
     */
    public getItemListQuery(options?: AxiosRequestConfig) {
        return ItemApiFp(this.configuration).getItemListQuery(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ItemApiUpdateItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemApi
     */
    public updateItem(requestParameters: ItemApiUpdateItemRequest, options?: AxiosRequestConfig) {
        return ItemApiFp(this.configuration).updateItem(requestParameters.id, requestParameters.updateItemBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ItemApiUpdateItemHandInRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemApi
     */
    public updateItemHandIn(requestParameters: ItemApiUpdateItemHandInRequest, options?: AxiosRequestConfig) {
        return ItemApiFp(this.configuration).updateItemHandIn(requestParameters.id, requestParameters.updateItemHandInBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LogApi - axios parameter creator
 * @export
 */
export const LogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getLogList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getLogList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getLogList', 'limit', limit)
            const localVarPath = `/api/log/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogListQuery: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/log/list/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogApi - functional programming interface
 * @export
 */
export const LogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LogApi.getLogList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogListQuery(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOQueryFilterTemplateArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogListQuery(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LogApi.getLogListQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LogApi - factory interface
 * @export
 */
export const LogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogApiFp(configuration)
    return {
        /**
         * 
         * @param {LogApiGetLogListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogList(requestParameters: LogApiGetLogListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListLog> {
            return localVarFp.getLogList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogListQuery(options?: AxiosRequestConfig): AxiosPromise<OutputDTOQueryFilterTemplateArray> {
            return localVarFp.getLogListQuery(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getLogList operation in LogApi.
 * @export
 * @interface LogApiGetLogListRequest
 */
export interface LogApiGetLogListRequest {
    /**
     * 
     * @type {string}
     * @memberof LogApiGetLogList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof LogApiGetLogList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof LogApiGetLogList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof LogApiGetLogList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof LogApiGetLogList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof LogApiGetLogList
     */
    readonly filters?: string
}

/**
 * LogApi - object-oriented interface
 * @export
 * @class LogApi
 * @extends {BaseAPI}
 */
export class LogApi extends BaseAPI {
    /**
     * 
     * @param {LogApiGetLogListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogApi
     */
    public getLogList(requestParameters: LogApiGetLogListRequest, options?: AxiosRequestConfig) {
        return LogApiFp(this.configuration).getLogList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogApi
     */
    public getLogListQuery(options?: AxiosRequestConfig) {
        return LogApiFp(this.configuration).getLogListQuery(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateNotificationSubscriptionBody} createNotificationSubscriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription: async (createNotificationSubscriptionBody: CreateNotificationSubscriptionBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNotificationSubscriptionBody' is not null or undefined
            assertParamExists('createSubscription', 'createNotificationSubscriptionBody', createNotificationSubscriptionBody)
            const localVarPath = `/api/notification/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNotificationSubscriptionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyNotifications: async (limit: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getMyNotifications', 'limit', limit)
            const localVarPath = `/api/notification/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationRead: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateNotificationRead', 'id', id)
            const localVarPath = `/api/notification/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationsClear: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification/clear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionActivity: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification/subscription/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateNotificationSubscriptionBody} createNotificationSubscriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubscription(createNotificationSubscriptionBody: CreateNotificationSubscriptionBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubscription(createNotificationSubscriptionBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['NotificationsApi.createSubscription']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubscription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubscription(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['NotificationsApi.deleteSubscription']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyNotifications(limit: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListNotificationInstance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyNotifications(limit, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['NotificationsApi.getMyNotifications']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationRead(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTONotificationInstance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotificationRead(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['NotificationsApi.updateNotificationRead']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationsClear(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotificationsClear(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['NotificationsApi.updateNotificationsClear']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscriptionActivity(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscriptionActivity(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['NotificationsApi.updateSubscriptionActivity']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {NotificationsApiCreateSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription(requestParameters: NotificationsApiCreateSubscriptionRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.createSubscription(requestParameters.createNotificationSubscriptionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscription(options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.deleteSubscription(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiGetMyNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyNotifications(requestParameters: NotificationsApiGetMyNotificationsRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListNotificationInstance> {
            return localVarFp.getMyNotifications(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiUpdateNotificationReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationRead(requestParameters: NotificationsApiUpdateNotificationReadRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTONotificationInstance> {
            return localVarFp.updateNotificationRead(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationsClear(options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.updateNotificationsClear(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionActivity(options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.updateSubscriptionActivity(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createSubscription operation in NotificationsApi.
 * @export
 * @interface NotificationsApiCreateSubscriptionRequest
 */
export interface NotificationsApiCreateSubscriptionRequest {
    /**
     * 
     * @type {CreateNotificationSubscriptionBody}
     * @memberof NotificationsApiCreateSubscription
     */
    readonly createNotificationSubscriptionBody: CreateNotificationSubscriptionBody
}

/**
 * Request parameters for getMyNotifications operation in NotificationsApi.
 * @export
 * @interface NotificationsApiGetMyNotificationsRequest
 */
export interface NotificationsApiGetMyNotificationsRequest {
    /**
     * 
     * @type {number}
     * @memberof NotificationsApiGetMyNotifications
     */
    readonly limit: number
}

/**
 * Request parameters for updateNotificationRead operation in NotificationsApi.
 * @export
 * @interface NotificationsApiUpdateNotificationReadRequest
 */
export interface NotificationsApiUpdateNotificationReadRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationsApiUpdateNotificationRead
     */
    readonly id: string
}

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @param {NotificationsApiCreateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public createSubscription(requestParameters: NotificationsApiCreateSubscriptionRequest, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).createSubscription(requestParameters.createNotificationSubscriptionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public deleteSubscription(options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).deleteSubscription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiGetMyNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getMyNotifications(requestParameters: NotificationsApiGetMyNotificationsRequest, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getMyNotifications(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiUpdateNotificationReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public updateNotificationRead(requestParameters: NotificationsApiUpdateNotificationReadRequest, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateNotificationRead(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public updateNotificationsClear(options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateNotificationsClear(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public updateSubscriptionActivity(options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateSubscriptionActivity(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OpenAIApi - axios parameter creator
 * @export
 */
export const OpenAIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateAskAiBody} createAskAiBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAskPrompt: async (createAskAiBody: CreateAskAiBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAskAiBody' is not null or undefined
            assertParamExists('createAskPrompt', 'createAskAiBody', createAskAiBody)
            const localVarPath = `/api/openai/askai`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAskAiBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAssistantBody} createAssistantBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssistantPrompt: async (createAssistantBody: CreateAssistantBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAssistantBody' is not null or undefined
            assertParamExists('createAssistantPrompt', 'createAssistantBody', createAssistantBody)
            const localVarPath = `/api/openai/assistant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAssistantBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSummarizeBody} createSummarizeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummarizePrompt: async (createSummarizeBody: CreateSummarizeBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSummarizeBody' is not null or undefined
            assertParamExists('createSummarizePrompt', 'createSummarizeBody', createSummarizeBody)
            const localVarPath = `/api/openai/summarize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSummarizeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createThreadRequest: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/openai/thread`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTranslateBody} createTranslateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTranslatePrompt: async (createTranslateBody: CreateTranslateBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTranslateBody' is not null or undefined
            assertParamExists('createTranslatePrompt', 'createTranslateBody', createTranslateBody)
            const localVarPath = `/api/openai/translate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTranslateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OpenAIApi - functional programming interface
 * @export
 */
export const OpenAIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OpenAIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateAskAiBody} createAskAiBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAskPrompt(createAskAiBody: CreateAskAiBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAskPrompt(createAskAiBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OpenAIApi.createAskPrompt']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {CreateAssistantBody} createAssistantBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAssistantPrompt(createAssistantBody: CreateAssistantBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOOpenAIBetaThreadsMessagesMessageContentArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAssistantPrompt(createAssistantBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OpenAIApi.createAssistantPrompt']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {CreateSummarizeBody} createSummarizeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSummarizePrompt(createSummarizeBody: CreateSummarizeBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSummarizePrompt(createSummarizeBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OpenAIApi.createSummarizePrompt']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createThreadRequest(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createThreadRequest(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OpenAIApi.createThreadRequest']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {CreateTranslateBody} createTranslateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTranslatePrompt(createTranslateBody: CreateTranslateBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTranslatePrompt(createTranslateBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['OpenAIApi.createTranslatePrompt']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * OpenAIApi - factory interface
 * @export
 */
export const OpenAIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OpenAIApiFp(configuration)
    return {
        /**
         * 
         * @param {OpenAIApiCreateAskPromptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAskPrompt(requestParameters: OpenAIApiCreateAskPromptRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOString> {
            return localVarFp.createAskPrompt(requestParameters.createAskAiBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpenAIApiCreateAssistantPromptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssistantPrompt(requestParameters: OpenAIApiCreateAssistantPromptRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOOpenAIBetaThreadsMessagesMessageContentArray> {
            return localVarFp.createAssistantPrompt(requestParameters.createAssistantBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpenAIApiCreateSummarizePromptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummarizePrompt(requestParameters: OpenAIApiCreateSummarizePromptRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOString> {
            return localVarFp.createSummarizePrompt(requestParameters.createSummarizeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createThreadRequest(options?: AxiosRequestConfig): AxiosPromise<OutputDTOString> {
            return localVarFp.createThreadRequest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpenAIApiCreateTranslatePromptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTranslatePrompt(requestParameters: OpenAIApiCreateTranslatePromptRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOString> {
            return localVarFp.createTranslatePrompt(requestParameters.createTranslateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createAskPrompt operation in OpenAIApi.
 * @export
 * @interface OpenAIApiCreateAskPromptRequest
 */
export interface OpenAIApiCreateAskPromptRequest {
    /**
     * 
     * @type {CreateAskAiBody}
     * @memberof OpenAIApiCreateAskPrompt
     */
    readonly createAskAiBody: CreateAskAiBody
}

/**
 * Request parameters for createAssistantPrompt operation in OpenAIApi.
 * @export
 * @interface OpenAIApiCreateAssistantPromptRequest
 */
export interface OpenAIApiCreateAssistantPromptRequest {
    /**
     * 
     * @type {CreateAssistantBody}
     * @memberof OpenAIApiCreateAssistantPrompt
     */
    readonly createAssistantBody: CreateAssistantBody
}

/**
 * Request parameters for createSummarizePrompt operation in OpenAIApi.
 * @export
 * @interface OpenAIApiCreateSummarizePromptRequest
 */
export interface OpenAIApiCreateSummarizePromptRequest {
    /**
     * 
     * @type {CreateSummarizeBody}
     * @memberof OpenAIApiCreateSummarizePrompt
     */
    readonly createSummarizeBody: CreateSummarizeBody
}

/**
 * Request parameters for createTranslatePrompt operation in OpenAIApi.
 * @export
 * @interface OpenAIApiCreateTranslatePromptRequest
 */
export interface OpenAIApiCreateTranslatePromptRequest {
    /**
     * 
     * @type {CreateTranslateBody}
     * @memberof OpenAIApiCreateTranslatePrompt
     */
    readonly createTranslateBody: CreateTranslateBody
}

/**
 * OpenAIApi - object-oriented interface
 * @export
 * @class OpenAIApi
 * @extends {BaseAPI}
 */
export class OpenAIApi extends BaseAPI {
    /**
     * 
     * @param {OpenAIApiCreateAskPromptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
    public createAskPrompt(requestParameters: OpenAIApiCreateAskPromptRequest, options?: AxiosRequestConfig) {
        return OpenAIApiFp(this.configuration).createAskPrompt(requestParameters.createAskAiBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpenAIApiCreateAssistantPromptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
    public createAssistantPrompt(requestParameters: OpenAIApiCreateAssistantPromptRequest, options?: AxiosRequestConfig) {
        return OpenAIApiFp(this.configuration).createAssistantPrompt(requestParameters.createAssistantBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpenAIApiCreateSummarizePromptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
    public createSummarizePrompt(requestParameters: OpenAIApiCreateSummarizePromptRequest, options?: AxiosRequestConfig) {
        return OpenAIApiFp(this.configuration).createSummarizePrompt(requestParameters.createSummarizeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
    public createThreadRequest(options?: AxiosRequestConfig) {
        return OpenAIApiFp(this.configuration).createThreadRequest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpenAIApiCreateTranslatePromptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
    public createTranslatePrompt(requestParameters: OpenAIApiCreateTranslatePromptRequest, options?: AxiosRequestConfig) {
        return OpenAIApiFp(this.configuration).createTranslatePrompt(requestParameters.createTranslateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrintApi - axios parameter creator
 * @export
 */
export const PrintApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} ticketId 
         * @param {string} templateId 
         * @param {CreateTicketPrintBody} createTicketPrintBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketPrint: async (ticketId: string, templateId: string, createTicketPrintBody: CreateTicketPrintBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('createTicketPrint', 'ticketId', ticketId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('createTicketPrint', 'templateId', templateId)
            // verify required parameter 'createTicketPrintBody' is not null or undefined
            assertParamExists('createTicketPrint', 'createTicketPrintBody', createTicketPrintBody)
            const localVarPath = `/api/print/ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }

            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTicketPrintBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {string} templateId 
         * @param {CreateTicketPrintPreviewBody} createTicketPrintPreviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketPrintPreview: async (ticketId: string, templateId: string, createTicketPrintPreviewBody: CreateTicketPrintPreviewBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('createTicketPrintPreview', 'ticketId', ticketId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('createTicketPrintPreview', 'templateId', templateId)
            // verify required parameter 'createTicketPrintPreviewBody' is not null or undefined
            assertParamExists('createTicketPrintPreview', 'createTicketPrintPreviewBody', createTicketPrintPreviewBody)
            const localVarPath = `/api/print/ticket/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }

            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTicketPrintPreviewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TicketPrintTemplate} ticketPrintTemplate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketPrintTemplate: async (ticketPrintTemplate: TicketPrintTemplate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketPrintTemplate' is not null or undefined
            assertParamExists('createTicketPrintTemplate', 'ticketPrintTemplate', ticketPrintTemplate)
            const localVarPath = `/api/print/ticket/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ticketPrintTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {number} printLogIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketPrintLog: async (ticketId: string, printLogIndex: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('deleteTicketPrintLog', 'ticketId', ticketId)
            // verify required parameter 'printLogIndex' is not null or undefined
            assertParamExists('deleteTicketPrintLog', 'printLogIndex', printLogIndex)
            const localVarPath = `/api/print/ticket/print/log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }

            if (printLogIndex !== undefined) {
                localVarQueryParameter['printLogIndex'] = printLogIndex;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketPrintTemplate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTicketPrintTemplate', 'id', id)
            const localVarPath = `/api/print/ticket/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketPrintTemplate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTicketPrintTemplate', 'id', id)
            const localVarPath = `/api/print/ticket/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketPrintTemplateList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/print/ticket/template/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {TicketPrintTemplate} ticketPrintTemplate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketPrintTemplate: async (id: string, ticketPrintTemplate: TicketPrintTemplate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTicketPrintTemplate', 'id', id)
            // verify required parameter 'ticketPrintTemplate' is not null or undefined
            assertParamExists('updateTicketPrintTemplate', 'ticketPrintTemplate', ticketPrintTemplate)
            const localVarPath = `/api/print/ticket/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ticketPrintTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrintApi - functional programming interface
 * @export
 */
export const PrintApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrintApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} ticketId 
         * @param {string} templateId 
         * @param {CreateTicketPrintBody} createTicketPrintBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTicketPrint(ticketId: string, templateId: string, createTicketPrintBody: CreateTicketPrintBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTicketPrint(ticketId, templateId, createTicketPrintBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PrintApi.createTicketPrint']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {string} templateId 
         * @param {CreateTicketPrintPreviewBody} createTicketPrintPreviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTicketPrintPreview(ticketId: string, templateId: string, createTicketPrintPreviewBody: CreateTicketPrintPreviewBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTicketPrintPreview200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTicketPrintPreview(ticketId, templateId, createTicketPrintPreviewBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PrintApi.createTicketPrintPreview']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {TicketPrintTemplate} ticketPrintTemplate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTicketPrintTemplate(ticketPrintTemplate: TicketPrintTemplate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicketPrintTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTicketPrintTemplate(ticketPrintTemplate, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PrintApi.createTicketPrintTemplate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {number} printLogIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTicketPrintLog(ticketId: string, printLogIndex: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOCreateTicketPrintResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTicketPrintLog(ticketId, printLogIndex, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PrintApi.deleteTicketPrintLog']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTicketPrintTemplate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicketPrintTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTicketPrintTemplate(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PrintApi.deleteTicketPrintTemplate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketPrintTemplate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicketPrintTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketPrintTemplate(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PrintApi.getTicketPrintTemplate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketPrintTemplateList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicketPrintTemplateArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketPrintTemplateList(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PrintApi.getTicketPrintTemplateList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {TicketPrintTemplate} ticketPrintTemplate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTicketPrintTemplate(id: string, ticketPrintTemplate: TicketPrintTemplate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicketPrintTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTicketPrintTemplate(id, ticketPrintTemplate, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PrintApi.updateTicketPrintTemplate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PrintApi - factory interface
 * @export
 */
export const PrintApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrintApiFp(configuration)
    return {
        /**
         * 
         * @param {PrintApiCreateTicketPrintRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketPrint(requestParameters: PrintApiCreateTicketPrintRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.createTicketPrint(requestParameters.ticketId, requestParameters.templateId, requestParameters.createTicketPrintBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintApiCreateTicketPrintPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketPrintPreview(requestParameters: PrintApiCreateTicketPrintPreviewRequest, options?: AxiosRequestConfig): AxiosPromise<CreateTicketPrintPreview200Response> {
            return localVarFp.createTicketPrintPreview(requestParameters.ticketId, requestParameters.templateId, requestParameters.createTicketPrintPreviewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintApiCreateTicketPrintTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketPrintTemplate(requestParameters: PrintApiCreateTicketPrintTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicketPrintTemplate> {
            return localVarFp.createTicketPrintTemplate(requestParameters.ticketPrintTemplate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintApiDeleteTicketPrintLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketPrintLog(requestParameters: PrintApiDeleteTicketPrintLogRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOCreateTicketPrintResponse> {
            return localVarFp.deleteTicketPrintLog(requestParameters.ticketId, requestParameters.printLogIndex, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintApiDeleteTicketPrintTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketPrintTemplate(requestParameters: PrintApiDeleteTicketPrintTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicketPrintTemplate> {
            return localVarFp.deleteTicketPrintTemplate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintApiGetTicketPrintTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketPrintTemplate(requestParameters: PrintApiGetTicketPrintTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicketPrintTemplate> {
            return localVarFp.getTicketPrintTemplate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketPrintTemplateList(options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicketPrintTemplateArray> {
            return localVarFp.getTicketPrintTemplateList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintApiUpdateTicketPrintTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketPrintTemplate(requestParameters: PrintApiUpdateTicketPrintTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicketPrintTemplate> {
            return localVarFp.updateTicketPrintTemplate(requestParameters.id, requestParameters.ticketPrintTemplate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createTicketPrint operation in PrintApi.
 * @export
 * @interface PrintApiCreateTicketPrintRequest
 */
export interface PrintApiCreateTicketPrintRequest {
    /**
     * 
     * @type {string}
     * @memberof PrintApiCreateTicketPrint
     */
    readonly ticketId: string

    /**
     * 
     * @type {string}
     * @memberof PrintApiCreateTicketPrint
     */
    readonly templateId: string

    /**
     * 
     * @type {CreateTicketPrintBody}
     * @memberof PrintApiCreateTicketPrint
     */
    readonly createTicketPrintBody: CreateTicketPrintBody
}

/**
 * Request parameters for createTicketPrintPreview operation in PrintApi.
 * @export
 * @interface PrintApiCreateTicketPrintPreviewRequest
 */
export interface PrintApiCreateTicketPrintPreviewRequest {
    /**
     * 
     * @type {string}
     * @memberof PrintApiCreateTicketPrintPreview
     */
    readonly ticketId: string

    /**
     * 
     * @type {string}
     * @memberof PrintApiCreateTicketPrintPreview
     */
    readonly templateId: string

    /**
     * 
     * @type {CreateTicketPrintPreviewBody}
     * @memberof PrintApiCreateTicketPrintPreview
     */
    readonly createTicketPrintPreviewBody: CreateTicketPrintPreviewBody
}

/**
 * Request parameters for createTicketPrintTemplate operation in PrintApi.
 * @export
 * @interface PrintApiCreateTicketPrintTemplateRequest
 */
export interface PrintApiCreateTicketPrintTemplateRequest {
    /**
     * 
     * @type {TicketPrintTemplate}
     * @memberof PrintApiCreateTicketPrintTemplate
     */
    readonly ticketPrintTemplate: TicketPrintTemplate
}

/**
 * Request parameters for deleteTicketPrintLog operation in PrintApi.
 * @export
 * @interface PrintApiDeleteTicketPrintLogRequest
 */
export interface PrintApiDeleteTicketPrintLogRequest {
    /**
     * 
     * @type {string}
     * @memberof PrintApiDeleteTicketPrintLog
     */
    readonly ticketId: string

    /**
     * 
     * @type {number}
     * @memberof PrintApiDeleteTicketPrintLog
     */
    readonly printLogIndex: number
}

/**
 * Request parameters for deleteTicketPrintTemplate operation in PrintApi.
 * @export
 * @interface PrintApiDeleteTicketPrintTemplateRequest
 */
export interface PrintApiDeleteTicketPrintTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof PrintApiDeleteTicketPrintTemplate
     */
    readonly id: string
}

/**
 * Request parameters for getTicketPrintTemplate operation in PrintApi.
 * @export
 * @interface PrintApiGetTicketPrintTemplateRequest
 */
export interface PrintApiGetTicketPrintTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof PrintApiGetTicketPrintTemplate
     */
    readonly id: string
}

/**
 * Request parameters for updateTicketPrintTemplate operation in PrintApi.
 * @export
 * @interface PrintApiUpdateTicketPrintTemplateRequest
 */
export interface PrintApiUpdateTicketPrintTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof PrintApiUpdateTicketPrintTemplate
     */
    readonly id: string

    /**
     * 
     * @type {TicketPrintTemplate}
     * @memberof PrintApiUpdateTicketPrintTemplate
     */
    readonly ticketPrintTemplate: TicketPrintTemplate
}

/**
 * PrintApi - object-oriented interface
 * @export
 * @class PrintApi
 * @extends {BaseAPI}
 */
export class PrintApi extends BaseAPI {
    /**
     * 
     * @param {PrintApiCreateTicketPrintRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintApi
     */
    public createTicketPrint(requestParameters: PrintApiCreateTicketPrintRequest, options?: AxiosRequestConfig) {
        return PrintApiFp(this.configuration).createTicketPrint(requestParameters.ticketId, requestParameters.templateId, requestParameters.createTicketPrintBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintApiCreateTicketPrintPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintApi
     */
    public createTicketPrintPreview(requestParameters: PrintApiCreateTicketPrintPreviewRequest, options?: AxiosRequestConfig) {
        return PrintApiFp(this.configuration).createTicketPrintPreview(requestParameters.ticketId, requestParameters.templateId, requestParameters.createTicketPrintPreviewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintApiCreateTicketPrintTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintApi
     */
    public createTicketPrintTemplate(requestParameters: PrintApiCreateTicketPrintTemplateRequest, options?: AxiosRequestConfig) {
        return PrintApiFp(this.configuration).createTicketPrintTemplate(requestParameters.ticketPrintTemplate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintApiDeleteTicketPrintLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintApi
     */
    public deleteTicketPrintLog(requestParameters: PrintApiDeleteTicketPrintLogRequest, options?: AxiosRequestConfig) {
        return PrintApiFp(this.configuration).deleteTicketPrintLog(requestParameters.ticketId, requestParameters.printLogIndex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintApiDeleteTicketPrintTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintApi
     */
    public deleteTicketPrintTemplate(requestParameters: PrintApiDeleteTicketPrintTemplateRequest, options?: AxiosRequestConfig) {
        return PrintApiFp(this.configuration).deleteTicketPrintTemplate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintApiGetTicketPrintTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintApi
     */
    public getTicketPrintTemplate(requestParameters: PrintApiGetTicketPrintTemplateRequest, options?: AxiosRequestConfig) {
        return PrintApiFp(this.configuration).getTicketPrintTemplate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintApi
     */
    public getTicketPrintTemplateList(options?: AxiosRequestConfig) {
        return PrintApiFp(this.configuration).getTicketPrintTemplateList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintApiUpdateTicketPrintTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintApi
     */
    public updateTicketPrintTemplate(requestParameters: PrintApiUpdateTicketPrintTemplateRequest, options?: AxiosRequestConfig) {
        return PrintApiFp(this.configuration).updateTicketPrintTemplate(requestParameters.id, requestParameters.ticketPrintTemplate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateProductBody} createProductBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: async (createProductBody: CreateProductBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductBody' is not null or undefined
            assertParamExists('createProduct', 'createProductBody', createProductBody)
            const localVarPath = `/api/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProduct', 'id', id)
            const localVarPath = `/api/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProduct', 'id', id)
            const localVarPath = `/api/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getProductList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getProductList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getProductList', 'limit', limit)
            const localVarPath = `/api/product/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListQuery: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/product/list/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProductBody} updateProductBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: async (id: string, updateProductBody: UpdateProductBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProduct', 'id', id)
            // verify required parameter 'updateProductBody' is not null or undefined
            assertParamExists('updateProduct', 'updateProductBody', updateProductBody)
            const localVarPath = `/api/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateProductBody} createProductBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProduct(createProductBody: CreateProductBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProduct(createProductBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProductApi.createProduct']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProduct(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProduct(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProductApi.deleteProduct']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProduct(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProduct(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProductApi.getProduct']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProductApi.getProductList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductListQuery(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOQueryFilterTemplateArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductListQuery(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProductApi.getProductListQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProductBody} updateProductBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProduct(id: string, updateProductBody: UpdateProductBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProduct(id, updateProductBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProductApi.updateProduct']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductApiFp(configuration)
    return {
        /**
         * 
         * @param {ProductApiCreateProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct(requestParameters: ProductApiCreateProductRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOProduct> {
            return localVarFp.createProduct(requestParameters.createProductBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductApiDeleteProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct(requestParameters: ProductApiDeleteProductRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicket> {
            return localVarFp.deleteProduct(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductApiGetProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct(requestParameters: ProductApiGetProductRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOProduct> {
            return localVarFp.getProduct(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductApiGetProductListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductList(requestParameters: ProductApiGetProductListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListProduct> {
            return localVarFp.getProductList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductListQuery(options?: AxiosRequestConfig): AxiosPromise<OutputDTOQueryFilterTemplateArray> {
            return localVarFp.getProductListQuery(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductApiUpdateProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(requestParameters: ProductApiUpdateProductRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOProduct> {
            return localVarFp.updateProduct(requestParameters.id, requestParameters.updateProductBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createProduct operation in ProductApi.
 * @export
 * @interface ProductApiCreateProductRequest
 */
export interface ProductApiCreateProductRequest {
    /**
     * 
     * @type {CreateProductBody}
     * @memberof ProductApiCreateProduct
     */
    readonly createProductBody: CreateProductBody
}

/**
 * Request parameters for deleteProduct operation in ProductApi.
 * @export
 * @interface ProductApiDeleteProductRequest
 */
export interface ProductApiDeleteProductRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductApiDeleteProduct
     */
    readonly id: string
}

/**
 * Request parameters for getProduct operation in ProductApi.
 * @export
 * @interface ProductApiGetProductRequest
 */
export interface ProductApiGetProductRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductApiGetProduct
     */
    readonly id: string
}

/**
 * Request parameters for getProductList operation in ProductApi.
 * @export
 * @interface ProductApiGetProductListRequest
 */
export interface ProductApiGetProductListRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductApiGetProductList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof ProductApiGetProductList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof ProductApiGetProductList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof ProductApiGetProductList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof ProductApiGetProductList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof ProductApiGetProductList
     */
    readonly filters?: string
}

/**
 * Request parameters for updateProduct operation in ProductApi.
 * @export
 * @interface ProductApiUpdateProductRequest
 */
export interface ProductApiUpdateProductRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductApiUpdateProduct
     */
    readonly id: string

    /**
     * 
     * @type {UpdateProductBody}
     * @memberof ProductApiUpdateProduct
     */
    readonly updateProductBody: UpdateProductBody
}

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
    /**
     * 
     * @param {ProductApiCreateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public createProduct(requestParameters: ProductApiCreateProductRequest, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).createProduct(requestParameters.createProductBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductApiDeleteProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public deleteProduct(requestParameters: ProductApiDeleteProductRequest, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).deleteProduct(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductApiGetProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getProduct(requestParameters: ProductApiGetProductRequest, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).getProduct(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductApiGetProductListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getProductList(requestParameters: ProductApiGetProductListRequest, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).getProductList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getProductListQuery(options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).getProductListQuery(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductApiUpdateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public updateProduct(requestParameters: ProductApiUpdateProductRequest, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).updateProduct(requestParameters.id, requestParameters.updateProductBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SettingsApi - axios parameter creator
 * @export
 */
export const SettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateMessageTestBody} createMessageTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessageTest: async (createMessageTestBody: CreateMessageTestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMessageTestBody' is not null or undefined
            assertParamExists('createMessageTest', 'createMessageTestBody', createMessageTestBody)
            const localVarPath = `/api/settings/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMessageTestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSetupBody} createSetupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSettingsSetup: async (createSetupBody: CreateSetupBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSetupBody' is not null or undefined
            assertParamExists('createSettingsSetup', 'createSetupBody', createSetupBody)
            const localVarPath = `/api/settings/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSetupBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} testEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSmtpTest: async (testEmail: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testEmail' is not null or undefined
            assertParamExists('createSmtpTest', 'testEmail', testEmail)
            const localVarPath = `/api/settings/smtp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (testEmail !== undefined) {
                localVarQueryParameter['testEmail'] = testEmail;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCities: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/city/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetup: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/taskTypes/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AppSettings} appSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings: async (appSettings: AppSettings, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appSettings' is not null or undefined
            assertParamExists('updateSettings', 'appSettings', appSettings)
            const localVarPath = `/api/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsApi - functional programming interface
 * @export
 */
export const SettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateMessageTestBody} createMessageTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMessageTest(createMessageTestBody: CreateMessageTestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOSMTPTransportSentMessageInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMessageTest(createMessageTestBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SettingsApi.createMessageTest']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {CreateSetupBody} createSetupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSettingsSetup(createSetupBody: CreateSetupBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOSetupOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSettingsSetup(createSetupBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SettingsApi.createSettingsSetup']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} testEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSmtpTest(testEmail: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOSMTPTransportSentMessageInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSmtpTest(testEmail, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SettingsApi.createSmtpTest']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCities(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOStringArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCities(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SettingsApi.getCities']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOAppSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettings(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SettingsApi.getSettings']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSetup(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOBoolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSetup(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SettingsApi.getSetup']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOStringArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskTypes(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SettingsApi.getTaskTypes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {AppSettings} appSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSettings(appSettings: AppSettings, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOAppSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSettings(appSettings, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SettingsApi.updateSettings']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SettingsApi - factory interface
 * @export
 */
export const SettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {SettingsApiCreateMessageTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessageTest(requestParameters: SettingsApiCreateMessageTestRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOSMTPTransportSentMessageInfo> {
            return localVarFp.createMessageTest(requestParameters.createMessageTestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SettingsApiCreateSettingsSetupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSettingsSetup(requestParameters: SettingsApiCreateSettingsSetupRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOSetupOutputDTO> {
            return localVarFp.createSettingsSetup(requestParameters.createSetupBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SettingsApiCreateSmtpTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSmtpTest(requestParameters: SettingsApiCreateSmtpTestRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOSMTPTransportSentMessageInfo> {
            return localVarFp.createSmtpTest(requestParameters.testEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCities(options?: AxiosRequestConfig): AxiosPromise<OutputDTOStringArray> {
            return localVarFp.getCities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(options?: AxiosRequestConfig): AxiosPromise<OutputDTOAppSettings> {
            return localVarFp.getSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetup(options?: AxiosRequestConfig): AxiosPromise<OutputDTOBoolean> {
            return localVarFp.getSetup(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskTypes(options?: AxiosRequestConfig): AxiosPromise<OutputDTOStringArray> {
            return localVarFp.getTaskTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SettingsApiUpdateSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings(requestParameters: SettingsApiUpdateSettingsRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOAppSettings> {
            return localVarFp.updateSettings(requestParameters.appSettings, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createMessageTest operation in SettingsApi.
 * @export
 * @interface SettingsApiCreateMessageTestRequest
 */
export interface SettingsApiCreateMessageTestRequest {
    /**
     * 
     * @type {CreateMessageTestBody}
     * @memberof SettingsApiCreateMessageTest
     */
    readonly createMessageTestBody: CreateMessageTestBody
}

/**
 * Request parameters for createSettingsSetup operation in SettingsApi.
 * @export
 * @interface SettingsApiCreateSettingsSetupRequest
 */
export interface SettingsApiCreateSettingsSetupRequest {
    /**
     * 
     * @type {CreateSetupBody}
     * @memberof SettingsApiCreateSettingsSetup
     */
    readonly createSetupBody: CreateSetupBody
}

/**
 * Request parameters for createSmtpTest operation in SettingsApi.
 * @export
 * @interface SettingsApiCreateSmtpTestRequest
 */
export interface SettingsApiCreateSmtpTestRequest {
    /**
     * 
     * @type {string}
     * @memberof SettingsApiCreateSmtpTest
     */
    readonly testEmail: string
}

/**
 * Request parameters for updateSettings operation in SettingsApi.
 * @export
 * @interface SettingsApiUpdateSettingsRequest
 */
export interface SettingsApiUpdateSettingsRequest {
    /**
     * 
     * @type {AppSettings}
     * @memberof SettingsApiUpdateSettings
     */
    readonly appSettings: AppSettings
}

/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
export class SettingsApi extends BaseAPI {
    /**
     * 
     * @param {SettingsApiCreateMessageTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public createMessageTest(requestParameters: SettingsApiCreateMessageTestRequest, options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).createMessageTest(requestParameters.createMessageTestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SettingsApiCreateSettingsSetupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public createSettingsSetup(requestParameters: SettingsApiCreateSettingsSetupRequest, options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).createSettingsSetup(requestParameters.createSetupBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SettingsApiCreateSmtpTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public createSmtpTest(requestParameters: SettingsApiCreateSmtpTestRequest, options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).createSmtpTest(requestParameters.testEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getCities(options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getCities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getSettings(options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getSetup(options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getSetup(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getTaskTypes(options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getTaskTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SettingsApiUpdateSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public updateSettings(requestParameters: SettingsApiUpdateSettingsRequest, options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).updateSettings(requestParameters.appSettings, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionsApi - axios parameter creator
 * @export
 */
export const SubscriptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getSubscriptionList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getSubscriptionList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getSubscriptionList', 'limit', limit)
            const localVarPath = `/api/subscription/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionListQuery: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subscription/list/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionExecution: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSubscriptionExecution', 'id', id)
            const localVarPath = `/api/subscription/execute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionsApi - functional programming interface
 * @export
 */
export const SubscriptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListSubscription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SubscriptionsApi.getSubscriptionList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionListQuery(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOQueryFilterTemplateArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionListQuery(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SubscriptionsApi.getSubscriptionListQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscriptionExecution(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOSubscription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscriptionExecution(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SubscriptionsApi.updateSubscriptionExecution']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SubscriptionsApi - factory interface
 * @export
 */
export const SubscriptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionsApiFp(configuration)
    return {
        /**
         * 
         * @param {SubscriptionsApiGetSubscriptionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionList(requestParameters: SubscriptionsApiGetSubscriptionListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListSubscription> {
            return localVarFp.getSubscriptionList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionListQuery(options?: AxiosRequestConfig): AxiosPromise<OutputDTOQueryFilterTemplateArray> {
            return localVarFp.getSubscriptionListQuery(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionsApiUpdateSubscriptionExecutionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionExecution(requestParameters: SubscriptionsApiUpdateSubscriptionExecutionRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOSubscription> {
            return localVarFp.updateSubscriptionExecution(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getSubscriptionList operation in SubscriptionsApi.
 * @export
 * @interface SubscriptionsApiGetSubscriptionListRequest
 */
export interface SubscriptionsApiGetSubscriptionListRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionsApiGetSubscriptionList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof SubscriptionsApiGetSubscriptionList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof SubscriptionsApiGetSubscriptionList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof SubscriptionsApiGetSubscriptionList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof SubscriptionsApiGetSubscriptionList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof SubscriptionsApiGetSubscriptionList
     */
    readonly filters?: string
}

/**
 * Request parameters for updateSubscriptionExecution operation in SubscriptionsApi.
 * @export
 * @interface SubscriptionsApiUpdateSubscriptionExecutionRequest
 */
export interface SubscriptionsApiUpdateSubscriptionExecutionRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionsApiUpdateSubscriptionExecution
     */
    readonly id: string
}

/**
 * SubscriptionsApi - object-oriented interface
 * @export
 * @class SubscriptionsApi
 * @extends {BaseAPI}
 */
export class SubscriptionsApi extends BaseAPI {
    /**
     * 
     * @param {SubscriptionsApiGetSubscriptionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public getSubscriptionList(requestParameters: SubscriptionsApiGetSubscriptionListRequest, options?: AxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).getSubscriptionList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public getSubscriptionListQuery(options?: AxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).getSubscriptionListQuery(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionsApiUpdateSubscriptionExecutionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public updateSubscriptionExecution(requestParameters: SubscriptionsApiUpdateSubscriptionExecutionRequest, options?: AxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).updateSubscriptionExecution(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TasksApi - axios parameter creator
 * @export
 */
export const TasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} ticketId 
         * @param {CreateTaskBody} createTaskBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask: async (ticketId: string, createTaskBody: CreateTaskBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('createTask', 'ticketId', ticketId)
            // verify required parameter 'createTaskBody' is not null or undefined
            assertParamExists('createTask', 'createTaskBody', createTaskBody)
            const localVarPath = `/api/task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateTaskProductBody} createTaskProductBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskProduct: async (id: string, createTaskProductBody: CreateTaskProductBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createTaskProduct', 'id', id)
            // verify required parameter 'createTaskProductBody' is not null or undefined
            assertParamExists('createTaskProduct', 'createTaskProductBody', createTaskProductBody)
            const localVarPath = `/api/task/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskProductBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateTaskTimeLogBody} createTaskTimeLogBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskTimeLog: async (id: string, createTaskTimeLogBody: CreateTaskTimeLogBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createTaskTimeLog', 'id', id)
            // verify required parameter 'createTaskTimeLogBody' is not null or undefined
            assertParamExists('createTaskTimeLog', 'createTaskTimeLogBody', createTaskTimeLogBody)
            const localVarPath = `/api/task/timelog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskTimeLogBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateTaskUserBody} createTaskUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskUser: async (id: string, createTaskUserBody: CreateTaskUserBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createTaskUser', 'id', id)
            // verify required parameter 'createTaskUserBody' is not null or undefined
            assertParamExists('createTaskUser', 'createTaskUserBody', createTaskUserBody)
            const localVarPath = `/api/task/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTask: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTask', 'id', id)
            const localVarPath = `/api/task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} itemCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaskProduct: async (id: string, itemCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTaskProduct', 'id', id)
            // verify required parameter 'itemCode' is not null or undefined
            assertParamExists('deleteTaskProduct', 'itemCode', itemCode)
            const localVarPath = `/api/task/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }

            if (itemCode !== undefined) {
                localVarQueryParameter['itemCode'] = itemCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaskUser: async (id: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTaskUser', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteTaskUser', 'userId', userId)
            const localVarPath = `/api/task/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} timelogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimeLog: async (id: string, timelogId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTimeLog', 'id', id)
            // verify required parameter 'timelogId' is not null or undefined
            assertParamExists('deleteTimeLog', 'timelogId', timelogId)
            const localVarPath = `/api/task/timelog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }

            if (timelogId !== undefined) {
                localVarQueryParameter['timelogId'] = timelogId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTaskBody} updateTaskBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTask: async (id: string, updateTaskBody: UpdateTaskBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTask', 'id', id)
            // verify required parameter 'updateTaskBody' is not null or undefined
            assertParamExists('updateTask', 'updateTaskBody', updateTaskBody)
            const localVarPath = `/api/task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaskBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTaskProductSerialsBody} updateTaskProductSerialsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskProductSerials: async (id: string, updateTaskProductSerialsBody: UpdateTaskProductSerialsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTaskProductSerials', 'id', id)
            // verify required parameter 'updateTaskProductSerialsBody' is not null or undefined
            assertParamExists('updateTaskProductSerials', 'updateTaskProductSerialsBody', updateTaskProductSerialsBody)
            const localVarPath = `/api/task/product/serials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaskProductSerialsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTaskStatusBody} updateTaskStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskStatus: async (id: string, updateTaskStatusBody: UpdateTaskStatusBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTaskStatus', 'id', id)
            // verify required parameter 'updateTaskStatusBody' is not null or undefined
            assertParamExists('updateTaskStatus', 'updateTaskStatusBody', updateTaskStatusBody)
            const localVarPath = `/api/task/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaskStatusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} timelogId 
         * @param {UpdateTaskTimeLogBody} updateTaskTimeLogBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskTimeLog: async (id: string, timelogId: string, updateTaskTimeLogBody: UpdateTaskTimeLogBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTaskTimeLog', 'id', id)
            // verify required parameter 'timelogId' is not null or undefined
            assertParamExists('updateTaskTimeLog', 'timelogId', timelogId)
            // verify required parameter 'updateTaskTimeLogBody' is not null or undefined
            assertParamExists('updateTaskTimeLog', 'updateTaskTimeLogBody', updateTaskTimeLogBody)
            const localVarPath = `/api/task/timelog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }

            if (timelogId !== undefined) {
                localVarQueryParameter['timelog_id'] = timelogId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaskTimeLogBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TasksApi - functional programming interface
 * @export
 */
export const TasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TasksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} ticketId 
         * @param {CreateTaskBody} createTaskBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTask(ticketId: string, createTaskBody: CreateTaskBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTask(ticketId, createTaskBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TasksApi.createTask']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateTaskProductBody} createTaskProductBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTaskProduct(id: string, createTaskProductBody: CreateTaskProductBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTaskProduct(id, createTaskProductBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TasksApi.createTaskProduct']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateTaskTimeLogBody} createTaskTimeLogBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTaskTimeLog(id: string, createTaskTimeLogBody: CreateTaskTimeLogBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTaskTimeLog(id, createTaskTimeLogBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TasksApi.createTaskTimeLog']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateTaskUserBody} createTaskUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTaskUser(id: string, createTaskUserBody: CreateTaskUserBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTaskUser(id, createTaskUserBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TasksApi.createTaskUser']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTask(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTask(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TasksApi.deleteTask']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} itemCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTaskProduct(id: string, itemCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTaskProduct(id, itemCode, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TasksApi.deleteTaskProduct']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTaskUser(id: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTaskUser(id, userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TasksApi.deleteTaskUser']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} timelogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTimeLog(id: string, timelogId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTimeLog(id, timelogId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TasksApi.deleteTimeLog']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTaskBody} updateTaskBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTask(id: string, updateTaskBody: UpdateTaskBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTask(id, updateTaskBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TasksApi.updateTask']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTaskProductSerialsBody} updateTaskProductSerialsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTaskProductSerials(id: string, updateTaskProductSerialsBody: UpdateTaskProductSerialsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTaskProductSerials(id, updateTaskProductSerialsBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TasksApi.updateTaskProductSerials']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTaskStatusBody} updateTaskStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTaskStatus(id: string, updateTaskStatusBody: UpdateTaskStatusBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTaskStatus(id, updateTaskStatusBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TasksApi.updateTaskStatus']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} timelogId 
         * @param {UpdateTaskTimeLogBody} updateTaskTimeLogBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTaskTimeLog(id: string, timelogId: string, updateTaskTimeLogBody: UpdateTaskTimeLogBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTaskTimeLog(id, timelogId, updateTaskTimeLogBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TasksApi.updateTaskTimeLog']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * TasksApi - factory interface
 * @export
 */
export const TasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TasksApiFp(configuration)
    return {
        /**
         * 
         * @param {TasksApiCreateTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(requestParameters: TasksApiCreateTaskRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTask> {
            return localVarFp.createTask(requestParameters.ticketId, requestParameters.createTaskBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TasksApiCreateTaskProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskProduct(requestParameters: TasksApiCreateTaskProductRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTask> {
            return localVarFp.createTaskProduct(requestParameters.id, requestParameters.createTaskProductBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TasksApiCreateTaskTimeLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskTimeLog(requestParameters: TasksApiCreateTaskTimeLogRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTask> {
            return localVarFp.createTaskTimeLog(requestParameters.id, requestParameters.createTaskTimeLogBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TasksApiCreateTaskUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaskUser(requestParameters: TasksApiCreateTaskUserRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTask> {
            return localVarFp.createTaskUser(requestParameters.id, requestParameters.createTaskUserBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TasksApiDeleteTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTask(requestParameters: TasksApiDeleteTaskRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicket> {
            return localVarFp.deleteTask(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TasksApiDeleteTaskProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaskProduct(requestParameters: TasksApiDeleteTaskProductRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTask> {
            return localVarFp.deleteTaskProduct(requestParameters.id, requestParameters.itemCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TasksApiDeleteTaskUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaskUser(requestParameters: TasksApiDeleteTaskUserRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTask> {
            return localVarFp.deleteTaskUser(requestParameters.id, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TasksApiDeleteTimeLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimeLog(requestParameters: TasksApiDeleteTimeLogRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTask> {
            return localVarFp.deleteTimeLog(requestParameters.id, requestParameters.timelogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TasksApiUpdateTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTask(requestParameters: TasksApiUpdateTaskRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTask> {
            return localVarFp.updateTask(requestParameters.id, requestParameters.updateTaskBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TasksApiUpdateTaskProductSerialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskProductSerials(requestParameters: TasksApiUpdateTaskProductSerialsRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTask> {
            return localVarFp.updateTaskProductSerials(requestParameters.id, requestParameters.updateTaskProductSerialsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TasksApiUpdateTaskStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskStatus(requestParameters: TasksApiUpdateTaskStatusRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTask> {
            return localVarFp.updateTaskStatus(requestParameters.id, requestParameters.updateTaskStatusBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TasksApiUpdateTaskTimeLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaskTimeLog(requestParameters: TasksApiUpdateTaskTimeLogRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTask> {
            return localVarFp.updateTaskTimeLog(requestParameters.id, requestParameters.timelogId, requestParameters.updateTaskTimeLogBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createTask operation in TasksApi.
 * @export
 * @interface TasksApiCreateTaskRequest
 */
export interface TasksApiCreateTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiCreateTask
     */
    readonly ticketId: string

    /**
     * 
     * @type {CreateTaskBody}
     * @memberof TasksApiCreateTask
     */
    readonly createTaskBody: CreateTaskBody
}

/**
 * Request parameters for createTaskProduct operation in TasksApi.
 * @export
 * @interface TasksApiCreateTaskProductRequest
 */
export interface TasksApiCreateTaskProductRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiCreateTaskProduct
     */
    readonly id: string

    /**
     * 
     * @type {CreateTaskProductBody}
     * @memberof TasksApiCreateTaskProduct
     */
    readonly createTaskProductBody: CreateTaskProductBody
}

/**
 * Request parameters for createTaskTimeLog operation in TasksApi.
 * @export
 * @interface TasksApiCreateTaskTimeLogRequest
 */
export interface TasksApiCreateTaskTimeLogRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiCreateTaskTimeLog
     */
    readonly id: string

    /**
     * 
     * @type {CreateTaskTimeLogBody}
     * @memberof TasksApiCreateTaskTimeLog
     */
    readonly createTaskTimeLogBody: CreateTaskTimeLogBody
}

/**
 * Request parameters for createTaskUser operation in TasksApi.
 * @export
 * @interface TasksApiCreateTaskUserRequest
 */
export interface TasksApiCreateTaskUserRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiCreateTaskUser
     */
    readonly id: string

    /**
     * 
     * @type {CreateTaskUserBody}
     * @memberof TasksApiCreateTaskUser
     */
    readonly createTaskUserBody: CreateTaskUserBody
}

/**
 * Request parameters for deleteTask operation in TasksApi.
 * @export
 * @interface TasksApiDeleteTaskRequest
 */
export interface TasksApiDeleteTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiDeleteTask
     */
    readonly id: string
}

/**
 * Request parameters for deleteTaskProduct operation in TasksApi.
 * @export
 * @interface TasksApiDeleteTaskProductRequest
 */
export interface TasksApiDeleteTaskProductRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiDeleteTaskProduct
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TasksApiDeleteTaskProduct
     */
    readonly itemCode: string
}

/**
 * Request parameters for deleteTaskUser operation in TasksApi.
 * @export
 * @interface TasksApiDeleteTaskUserRequest
 */
export interface TasksApiDeleteTaskUserRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiDeleteTaskUser
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TasksApiDeleteTaskUser
     */
    readonly userId: string
}

/**
 * Request parameters for deleteTimeLog operation in TasksApi.
 * @export
 * @interface TasksApiDeleteTimeLogRequest
 */
export interface TasksApiDeleteTimeLogRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiDeleteTimeLog
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TasksApiDeleteTimeLog
     */
    readonly timelogId: string
}

/**
 * Request parameters for updateTask operation in TasksApi.
 * @export
 * @interface TasksApiUpdateTaskRequest
 */
export interface TasksApiUpdateTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiUpdateTask
     */
    readonly id: string

    /**
     * 
     * @type {UpdateTaskBody}
     * @memberof TasksApiUpdateTask
     */
    readonly updateTaskBody: UpdateTaskBody
}

/**
 * Request parameters for updateTaskProductSerials operation in TasksApi.
 * @export
 * @interface TasksApiUpdateTaskProductSerialsRequest
 */
export interface TasksApiUpdateTaskProductSerialsRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiUpdateTaskProductSerials
     */
    readonly id: string

    /**
     * 
     * @type {UpdateTaskProductSerialsBody}
     * @memberof TasksApiUpdateTaskProductSerials
     */
    readonly updateTaskProductSerialsBody: UpdateTaskProductSerialsBody
}

/**
 * Request parameters for updateTaskStatus operation in TasksApi.
 * @export
 * @interface TasksApiUpdateTaskStatusRequest
 */
export interface TasksApiUpdateTaskStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiUpdateTaskStatus
     */
    readonly id: string

    /**
     * 
     * @type {UpdateTaskStatusBody}
     * @memberof TasksApiUpdateTaskStatus
     */
    readonly updateTaskStatusBody: UpdateTaskStatusBody
}

/**
 * Request parameters for updateTaskTimeLog operation in TasksApi.
 * @export
 * @interface TasksApiUpdateTaskTimeLogRequest
 */
export interface TasksApiUpdateTaskTimeLogRequest {
    /**
     * 
     * @type {string}
     * @memberof TasksApiUpdateTaskTimeLog
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TasksApiUpdateTaskTimeLog
     */
    readonly timelogId: string

    /**
     * 
     * @type {UpdateTaskTimeLogBody}
     * @memberof TasksApiUpdateTaskTimeLog
     */
    readonly updateTaskTimeLogBody: UpdateTaskTimeLogBody
}

/**
 * TasksApi - object-oriented interface
 * @export
 * @class TasksApi
 * @extends {BaseAPI}
 */
export class TasksApi extends BaseAPI {
    /**
     * 
     * @param {TasksApiCreateTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public createTask(requestParameters: TasksApiCreateTaskRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).createTask(requestParameters.ticketId, requestParameters.createTaskBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TasksApiCreateTaskProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public createTaskProduct(requestParameters: TasksApiCreateTaskProductRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).createTaskProduct(requestParameters.id, requestParameters.createTaskProductBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TasksApiCreateTaskTimeLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public createTaskTimeLog(requestParameters: TasksApiCreateTaskTimeLogRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).createTaskTimeLog(requestParameters.id, requestParameters.createTaskTimeLogBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TasksApiCreateTaskUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public createTaskUser(requestParameters: TasksApiCreateTaskUserRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).createTaskUser(requestParameters.id, requestParameters.createTaskUserBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TasksApiDeleteTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public deleteTask(requestParameters: TasksApiDeleteTaskRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).deleteTask(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TasksApiDeleteTaskProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public deleteTaskProduct(requestParameters: TasksApiDeleteTaskProductRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).deleteTaskProduct(requestParameters.id, requestParameters.itemCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TasksApiDeleteTaskUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public deleteTaskUser(requestParameters: TasksApiDeleteTaskUserRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).deleteTaskUser(requestParameters.id, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TasksApiDeleteTimeLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public deleteTimeLog(requestParameters: TasksApiDeleteTimeLogRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).deleteTimeLog(requestParameters.id, requestParameters.timelogId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TasksApiUpdateTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public updateTask(requestParameters: TasksApiUpdateTaskRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).updateTask(requestParameters.id, requestParameters.updateTaskBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TasksApiUpdateTaskProductSerialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public updateTaskProductSerials(requestParameters: TasksApiUpdateTaskProductSerialsRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).updateTaskProductSerials(requestParameters.id, requestParameters.updateTaskProductSerialsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TasksApiUpdateTaskStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public updateTaskStatus(requestParameters: TasksApiUpdateTaskStatusRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).updateTaskStatus(requestParameters.id, requestParameters.updateTaskStatusBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TasksApiUpdateTaskTimeLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public updateTaskTimeLog(requestParameters: TasksApiUpdateTaskTimeLogRequest, options?: AxiosRequestConfig) {
        return TasksApiFp(this.configuration).updateTaskTimeLog(requestParameters.id, requestParameters.timelogId, requestParameters.updateTaskTimeLogBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TicketsApi - axios parameter creator
 * @export
 */
export const TicketsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} title 
         * @param {string} details 
         * @param {string} city 
         * @param {TicketPriorityEnum} priority 
         * @param {string} departmentId 
         * @param {string} [company] 
         * @param {string} [person] 
         * @param {string} [number] 
         * @param {string} [email] 
         * @param {string} [voucherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicket: async (title: string, details: string, city: string, priority: TicketPriorityEnum, departmentId: string, company?: string, person?: string, number?: string, email?: string, voucherId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'title' is not null or undefined
            assertParamExists('createTicket', 'title', title)
            // verify required parameter 'details' is not null or undefined
            assertParamExists('createTicket', 'details', details)
            // verify required parameter 'city' is not null or undefined
            assertParamExists('createTicket', 'city', city)
            // verify required parameter 'priority' is not null or undefined
            assertParamExists('createTicket', 'priority', priority)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('createTicket', 'departmentId', departmentId)
            const localVarPath = `/api/ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }

            if (person !== undefined) {
                localVarQueryParameter['person'] = person;
            }

            if (number !== undefined) {
                localVarQueryParameter['number'] = number;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (details !== undefined) {
                localVarQueryParameter['details'] = details;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (priority !== undefined) {
                localVarQueryParameter['priority'] = priority;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (voucherId !== undefined) {
                localVarQueryParameter['voucherId'] = voucherId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {CreateTicketAssigneeBody} createTicketAssigneeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketAssignee: async (ticketId: string, createTicketAssigneeBody: CreateTicketAssigneeBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('createTicketAssignee', 'ticketId', ticketId)
            // verify required parameter 'createTicketAssigneeBody' is not null or undefined
            assertParamExists('createTicketAssignee', 'createTicketAssigneeBody', createTicketAssigneeBody)
            const localVarPath = `/api/ticket/assignee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTicketAssigneeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {string} content 
         * @param {boolean} internalResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketResponse: async (ticketId: string, content: string, internalResponse: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('createTicketResponse', 'ticketId', ticketId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('createTicketResponse', 'content', content)
            // verify required parameter 'internalResponse' is not null or undefined
            assertParamExists('createTicketResponse', 'internalResponse', internalResponse)
            const localVarPath = `/api/ticket/response`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }

            if (content !== undefined) {
                localVarQueryParameter['content'] = content;
            }

            if (internalResponse !== undefined) {
                localVarQueryParameter['internalResponse'] = internalResponse;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicket: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTicket', 'id', id)
            const localVarPath = `/api/ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketAssignee: async (ticketId: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('deleteTicketAssignee', 'ticketId', ticketId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteTicketAssignee', 'userId', userId)
            const localVarPath = `/api/ticket/assignee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketResponse: async (ticketId: string, responseId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('deleteTicketResponse', 'ticketId', ticketId)
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('deleteTicketResponse', 'responseId', responseId)
            const localVarPath = `/api/ticket/response`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }

            if (responseId !== undefined) {
                localVarQueryParameter['responseId'] = responseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTicketList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getMyTicketList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getMyTicketList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getMyTicketList', 'limit', limit)
            const localVarPath = `/api/ticket/my-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTicketListQuery: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ticket/my-list/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [id2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicket: async (id: string, id2?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTicket', 'id', id)
            const localVarPath = `/api/ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }

            if (id2 !== undefined) {
                localVarQueryParameter['id'] = id2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getTicketList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getTicketList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getTicketList', 'limit', limit)
            const localVarPath = `/api/ticket/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketListQuery: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ticket/list/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTicketBody} updateTicketBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicket: async (id: string, updateTicketBody: UpdateTicketBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTicket', 'id', id)
            // verify required parameter 'updateTicketBody' is not null or undefined
            assertParamExists('updateTicket', 'updateTicketBody', updateTicketBody)
            const localVarPath = `/api/ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTicketBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTicketDetailsBody} updateTicketDetailsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketDetails: async (id: string, updateTicketDetailsBody: UpdateTicketDetailsBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTicketDetails', 'id', id)
            // verify required parameter 'updateTicketDetailsBody' is not null or undefined
            assertParamExists('updateTicketDetails', 'updateTicketDetailsBody', updateTicketDetailsBody)
            const localVarPath = `/api/ticket/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTicketDetailsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {string} responseId 
         * @param {UpdateTicketResponseBody} updateTicketResponseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketResponse: async (ticketId: string, responseId: string, updateTicketResponseBody: UpdateTicketResponseBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('updateTicketResponse', 'ticketId', ticketId)
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('updateTicketResponse', 'responseId', responseId)
            // verify required parameter 'updateTicketResponseBody' is not null or undefined
            assertParamExists('updateTicketResponse', 'updateTicketResponseBody', updateTicketResponseBody)
            const localVarPath = `/api/ticket/response`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }

            if (responseId !== undefined) {
                localVarQueryParameter['responseId'] = responseId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTicketResponseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TicketsApi - functional programming interface
 * @export
 */
export const TicketsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TicketsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} title 
         * @param {string} details 
         * @param {string} city 
         * @param {TicketPriorityEnum} priority 
         * @param {string} departmentId 
         * @param {string} [company] 
         * @param {string} [person] 
         * @param {string} [number] 
         * @param {string} [email] 
         * @param {string} [voucherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTicket(title: string, details: string, city: string, priority: TicketPriorityEnum, departmentId: string, company?: string, person?: string, number?: string, email?: string, voucherId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTicket(title, details, city, priority, departmentId, company, person, number, email, voucherId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.createTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {CreateTicketAssigneeBody} createTicketAssigneeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTicketAssignee(ticketId: string, createTicketAssigneeBody: CreateTicketAssigneeBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTicketAssignee(ticketId, createTicketAssigneeBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.createTicketAssignee']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {string} content 
         * @param {boolean} internalResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTicketResponse(ticketId: string, content: string, internalResponse: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTicketResponse(ticketId, content, internalResponse, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.createTicketResponse']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTicket(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTicket(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.deleteTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTicketAssignee(ticketId: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTicketAssignee(ticketId, userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.deleteTicketAssignee']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTicketResponse(ticketId: string, responseId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTicketResponse(ticketId, responseId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.deleteTicketResponse']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyTicketList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyTicketList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getMyTicketList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyTicketListQuery(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOQueryFilterTemplateArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyTicketListQuery(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getMyTicketListQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [id2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicket(id: string, id2?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicket(id, id2, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketListQuery(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOQueryFilterTemplateArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketListQuery(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.getTicketListQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTicketBody} updateTicketBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTicket(id: string, updateTicketBody: UpdateTicketBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTicket(id, updateTicketBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.updateTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTicketDetailsBody} updateTicketDetailsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTicketDetails(id: string, updateTicketDetailsBody: UpdateTicketDetailsBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTicketDetails(id, updateTicketDetailsBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.updateTicketDetails']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} ticketId 
         * @param {string} responseId 
         * @param {UpdateTicketResponseBody} updateTicketResponseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTicketResponse(ticketId: string, responseId: string, updateTicketResponseBody: UpdateTicketResponseBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTicketResponse(ticketId, responseId, updateTicketResponseBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TicketsApi.updateTicketResponse']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * TicketsApi - factory interface
 * @export
 */
export const TicketsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TicketsApiFp(configuration)
    return {
        /**
         * 
         * @param {TicketsApiCreateTicketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicket(requestParameters: TicketsApiCreateTicketRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicket> {
            return localVarFp.createTicket(requestParameters.title, requestParameters.details, requestParameters.city, requestParameters.priority, requestParameters.departmentId, requestParameters.company, requestParameters.person, requestParameters.number, requestParameters.email, requestParameters.voucherId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TicketsApiCreateTicketAssigneeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketAssignee(requestParameters: TicketsApiCreateTicketAssigneeRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicket> {
            return localVarFp.createTicketAssignee(requestParameters.ticketId, requestParameters.createTicketAssigneeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TicketsApiCreateTicketResponseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketResponse(requestParameters: TicketsApiCreateTicketResponseRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicket> {
            return localVarFp.createTicketResponse(requestParameters.ticketId, requestParameters.content, requestParameters.internalResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TicketsApiDeleteTicketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicket(requestParameters: TicketsApiDeleteTicketRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicket> {
            return localVarFp.deleteTicket(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TicketsApiDeleteTicketAssigneeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketAssignee(requestParameters: TicketsApiDeleteTicketAssigneeRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicket> {
            return localVarFp.deleteTicketAssignee(requestParameters.ticketId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TicketsApiDeleteTicketResponseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketResponse(requestParameters: TicketsApiDeleteTicketResponseRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicket> {
            return localVarFp.deleteTicketResponse(requestParameters.ticketId, requestParameters.responseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TicketsApiGetMyTicketListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTicketList(requestParameters: TicketsApiGetMyTicketListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListTicket> {
            return localVarFp.getMyTicketList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTicketListQuery(options?: AxiosRequestConfig): AxiosPromise<OutputDTOQueryFilterTemplateArray> {
            return localVarFp.getMyTicketListQuery(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TicketsApiGetTicketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicket(requestParameters: TicketsApiGetTicketRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicket> {
            return localVarFp.getTicket(requestParameters.id, requestParameters.id2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TicketsApiGetTicketListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketList(requestParameters: TicketsApiGetTicketListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListTicket> {
            return localVarFp.getTicketList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketListQuery(options?: AxiosRequestConfig): AxiosPromise<OutputDTOQueryFilterTemplateArray> {
            return localVarFp.getTicketListQuery(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TicketsApiUpdateTicketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicket(requestParameters: TicketsApiUpdateTicketRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicket> {
            return localVarFp.updateTicket(requestParameters.id, requestParameters.updateTicketBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TicketsApiUpdateTicketDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketDetails(requestParameters: TicketsApiUpdateTicketDetailsRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicket> {
            return localVarFp.updateTicketDetails(requestParameters.id, requestParameters.updateTicketDetailsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TicketsApiUpdateTicketResponseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketResponse(requestParameters: TicketsApiUpdateTicketResponseRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOTicket> {
            return localVarFp.updateTicketResponse(requestParameters.ticketId, requestParameters.responseId, requestParameters.updateTicketResponseBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createTicket operation in TicketsApi.
 * @export
 * @interface TicketsApiCreateTicketRequest
 */
export interface TicketsApiCreateTicketRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicket
     */
    readonly title: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicket
     */
    readonly details: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicket
     */
    readonly city: string

    /**
     * 
     * @type {TicketPriorityEnum}
     * @memberof TicketsApiCreateTicket
     */
    readonly priority: TicketPriorityEnum

    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicket
     */
    readonly departmentId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicket
     */
    readonly company?: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicket
     */
    readonly person?: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicket
     */
    readonly number?: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicket
     */
    readonly email?: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicket
     */
    readonly voucherId?: string
}

/**
 * Request parameters for createTicketAssignee operation in TicketsApi.
 * @export
 * @interface TicketsApiCreateTicketAssigneeRequest
 */
export interface TicketsApiCreateTicketAssigneeRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicketAssignee
     */
    readonly ticketId: string

    /**
     * 
     * @type {CreateTicketAssigneeBody}
     * @memberof TicketsApiCreateTicketAssignee
     */
    readonly createTicketAssigneeBody: CreateTicketAssigneeBody
}

/**
 * Request parameters for createTicketResponse operation in TicketsApi.
 * @export
 * @interface TicketsApiCreateTicketResponseRequest
 */
export interface TicketsApiCreateTicketResponseRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicketResponse
     */
    readonly ticketId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiCreateTicketResponse
     */
    readonly content: string

    /**
     * 
     * @type {boolean}
     * @memberof TicketsApiCreateTicketResponse
     */
    readonly internalResponse: boolean
}

/**
 * Request parameters for deleteTicket operation in TicketsApi.
 * @export
 * @interface TicketsApiDeleteTicketRequest
 */
export interface TicketsApiDeleteTicketRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiDeleteTicket
     */
    readonly id: string
}

/**
 * Request parameters for deleteTicketAssignee operation in TicketsApi.
 * @export
 * @interface TicketsApiDeleteTicketAssigneeRequest
 */
export interface TicketsApiDeleteTicketAssigneeRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiDeleteTicketAssignee
     */
    readonly ticketId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiDeleteTicketAssignee
     */
    readonly userId: string
}

/**
 * Request parameters for deleteTicketResponse operation in TicketsApi.
 * @export
 * @interface TicketsApiDeleteTicketResponseRequest
 */
export interface TicketsApiDeleteTicketResponseRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiDeleteTicketResponse
     */
    readonly ticketId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiDeleteTicketResponse
     */
    readonly responseId: string
}

/**
 * Request parameters for getMyTicketList operation in TicketsApi.
 * @export
 * @interface TicketsApiGetMyTicketListRequest
 */
export interface TicketsApiGetMyTicketListRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetMyTicketList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof TicketsApiGetMyTicketList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof TicketsApiGetMyTicketList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetMyTicketList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof TicketsApiGetMyTicketList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetMyTicketList
     */
    readonly filters?: string
}

/**
 * Request parameters for getTicket operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketRequest
 */
export interface TicketsApiGetTicketRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicket
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicket
     */
    readonly id2?: string
}

/**
 * Request parameters for getTicketList operation in TicketsApi.
 * @export
 * @interface TicketsApiGetTicketListRequest
 */
export interface TicketsApiGetTicketListRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof TicketsApiGetTicketList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof TicketsApiGetTicketList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof TicketsApiGetTicketList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof TicketsApiGetTicketList
     */
    readonly filters?: string
}

/**
 * Request parameters for updateTicket operation in TicketsApi.
 * @export
 * @interface TicketsApiUpdateTicketRequest
 */
export interface TicketsApiUpdateTicketRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiUpdateTicket
     */
    readonly id: string

    /**
     * 
     * @type {UpdateTicketBody}
     * @memberof TicketsApiUpdateTicket
     */
    readonly updateTicketBody: UpdateTicketBody
}

/**
 * Request parameters for updateTicketDetails operation in TicketsApi.
 * @export
 * @interface TicketsApiUpdateTicketDetailsRequest
 */
export interface TicketsApiUpdateTicketDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiUpdateTicketDetails
     */
    readonly id: string

    /**
     * 
     * @type {UpdateTicketDetailsBody}
     * @memberof TicketsApiUpdateTicketDetails
     */
    readonly updateTicketDetailsBody: UpdateTicketDetailsBody
}

/**
 * Request parameters for updateTicketResponse operation in TicketsApi.
 * @export
 * @interface TicketsApiUpdateTicketResponseRequest
 */
export interface TicketsApiUpdateTicketResponseRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketsApiUpdateTicketResponse
     */
    readonly ticketId: string

    /**
     * 
     * @type {string}
     * @memberof TicketsApiUpdateTicketResponse
     */
    readonly responseId: string

    /**
     * 
     * @type {UpdateTicketResponseBody}
     * @memberof TicketsApiUpdateTicketResponse
     */
    readonly updateTicketResponseBody: UpdateTicketResponseBody
}

/**
 * TicketsApi - object-oriented interface
 * @export
 * @class TicketsApi
 * @extends {BaseAPI}
 */
export class TicketsApi extends BaseAPI {
    /**
     * 
     * @param {TicketsApiCreateTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public createTicket(requestParameters: TicketsApiCreateTicketRequest, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).createTicket(requestParameters.title, requestParameters.details, requestParameters.city, requestParameters.priority, requestParameters.departmentId, requestParameters.company, requestParameters.person, requestParameters.number, requestParameters.email, requestParameters.voucherId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TicketsApiCreateTicketAssigneeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public createTicketAssignee(requestParameters: TicketsApiCreateTicketAssigneeRequest, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).createTicketAssignee(requestParameters.ticketId, requestParameters.createTicketAssigneeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TicketsApiCreateTicketResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public createTicketResponse(requestParameters: TicketsApiCreateTicketResponseRequest, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).createTicketResponse(requestParameters.ticketId, requestParameters.content, requestParameters.internalResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TicketsApiDeleteTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public deleteTicket(requestParameters: TicketsApiDeleteTicketRequest, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).deleteTicket(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TicketsApiDeleteTicketAssigneeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public deleteTicketAssignee(requestParameters: TicketsApiDeleteTicketAssigneeRequest, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).deleteTicketAssignee(requestParameters.ticketId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TicketsApiDeleteTicketResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public deleteTicketResponse(requestParameters: TicketsApiDeleteTicketResponseRequest, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).deleteTicketResponse(requestParameters.ticketId, requestParameters.responseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TicketsApiGetMyTicketListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getMyTicketList(requestParameters: TicketsApiGetMyTicketListRequest, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getMyTicketList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getMyTicketListQuery(options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getMyTicketListQuery(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TicketsApiGetTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicket(requestParameters: TicketsApiGetTicketRequest, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicket(requestParameters.id, requestParameters.id2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TicketsApiGetTicketListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketList(requestParameters: TicketsApiGetTicketListRequest, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public getTicketListQuery(options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).getTicketListQuery(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TicketsApiUpdateTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public updateTicket(requestParameters: TicketsApiUpdateTicketRequest, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).updateTicket(requestParameters.id, requestParameters.updateTicketBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TicketsApiUpdateTicketDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public updateTicketDetails(requestParameters: TicketsApiUpdateTicketDetailsRequest, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).updateTicketDetails(requestParameters.id, requestParameters.updateTicketDetailsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TicketsApiUpdateTicketResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public updateTicketResponse(requestParameters: TicketsApiUpdateTicketResponseRequest, options?: AxiosRequestConfig) {
        return TicketsApiFp(this.configuration).updateTicketResponse(requestParameters.ticketId, requestParameters.responseId, requestParameters.updateTicketResponseBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateRegisteredUserBody} createRegisteredUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegisteredUser: async (createRegisteredUserBody: CreateRegisteredUserBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRegisteredUserBody' is not null or undefined
            assertParamExists('createRegisteredUser', 'createRegisteredUserBody', createRegisteredUserBody)
            const localVarPath = `/api/user/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRegisteredUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUserBody} createUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (createUserBody: CreateUserBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserBody' is not null or undefined
            assertParamExists('createUser', 'createUserBody', createUserBody)
            const localVarPath = `/api/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserPasswordChangeConfirmation: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('createUserPasswordChangeConfirmation', 'email', email)
            const localVarPath = `/api/user/passwordConfirmation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUser', 'id', id)
            const localVarPath = `/api/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [ignoreDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersList: async (ignoreDeleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/list/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ignoreDeleted !== undefined) {
                localVarQueryParameter['ignoreDeleted'] = ignoreDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyQR: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/my-qr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [ignoreDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivilegedUserList: async (ignoreDeleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/list/allPrivileged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ignoreDeleted !== undefined) {
                localVarQueryParameter['ignoreDeleted'] = ignoreDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dataUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRMedia: async (dataUrl: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataUrl' is not null or undefined
            assertParamExists('getQRMedia', 'dataUrl', dataUrl)
            const localVarPath = `/api/user/qr-media`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dataUrl !== undefined) {
                localVarQueryParameter['dataUrl'] = dataUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getUserList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getUserList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getUserList', 'limit', limit)
            const localVarPath = `/api/user/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserListQuery: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/list/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserQR: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserQR', 'id', id)
            const localVarPath = `/api/user/qr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateMyUserBody} updateMyUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyUser: async (updateMyUserBody: UpdateMyUserBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateMyUserBody' is not null or undefined
            assertParamExists('updateMyUser', 'updateMyUserBody', updateMyUserBody)
            const localVarPath = `/api/user/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMyUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserBody} updateUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (id: string, updateUserBody: UpdateUserBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUser', 'id', id)
            // verify required parameter 'updateUserBody' is not null or undefined
            assertParamExists('updateUser', 'updateUserBody', updateUserBody)
            const localVarPath = `/api/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserActivation: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('updateUserActivation', 'code', code)
            const localVarPath = `/api/user/activate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateUserLanguageLanguageEnum} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLanguage: async (language: UpdateUserLanguageLanguageEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('updateUserLanguage', 'language', language)
            const localVarPath = `/api/user/language`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {UpdateUserPasswordBody} updateUserPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword: async (email: string, updateUserPasswordBody: UpdateUserPasswordBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('updateUserPassword', 'email', email)
            // verify required parameter 'updateUserPasswordBody' is not null or undefined
            assertParamExists('updateUserPassword', 'updateUserPasswordBody', updateUserPasswordBody)
            const localVarPath = `/api/user/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateRegisteredUserBody} createRegisteredUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRegisteredUser(createRegisteredUserBody: CreateRegisteredUserBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRegisteredUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRegisteredUser(createRegisteredUserBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.createRegisteredUser']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {CreateUserBody} createUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(createUserBody: CreateUserBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(createUserBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.createUser']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserPasswordChangeConfirmation(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserPasswordChangeConfirmation(email, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.createUserPasswordChangeConfirmation']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.deleteUser']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [ignoreDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsersList(ignoreDeleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsersList(ignoreDeleted, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.getAllUsersList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyQR(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyQR(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.getMyQR']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [ignoreDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrivilegedUserList(ignoreDeleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOUserArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrivilegedUserList(ignoreDeleted, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.getPrivilegedUserList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} dataUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQRMedia(dataUrl: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQRMedia(dataUrl, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.getQRMedia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.getUserList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserListQuery(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOQueryFilterTemplateArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserListQuery(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.getUserListQuery']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserQR(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserQR(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.getUserQR']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateMyUserBody} updateMyUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyUser(updateMyUserBody: UpdateMyUserBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyUser(updateMyUserBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.updateMyUser']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserBody} updateUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(id: string, updateUserBody: UpdateUserBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(id, updateUserBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.updateUser']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserActivation(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRegisteredUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserActivation(code, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.updateUserActivation']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateUserLanguageLanguageEnum} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserLanguage(language: UpdateUserLanguageLanguageEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserLanguage(language, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.updateUserLanguage']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {UpdateUserPasswordBody} updateUserPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPassword(email: string, updateUserPasswordBody: UpdateUserPasswordBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPassword(email, updateUserPasswordBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UsersApi.updateUserPassword']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {UsersApiCreateRegisteredUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegisteredUser(requestParameters: UsersApiCreateRegisteredUserRequest, options?: AxiosRequestConfig): AxiosPromise<CreateRegisteredUser200Response> {
            return localVarFp.createRegisteredUser(requestParameters.createRegisteredUserBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiCreateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(requestParameters: UsersApiCreateUserRequest, options?: AxiosRequestConfig): AxiosPromise<CreateUser200Response> {
            return localVarFp.createUser(requestParameters.createUserBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiCreateUserPasswordChangeConfirmationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserPasswordChangeConfirmation(requestParameters: UsersApiCreateUserPasswordChangeConfirmationRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.createUserPasswordChangeConfirmation(requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiDeleteUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(requestParameters: UsersApiDeleteUserRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOUser> {
            return localVarFp.deleteUser(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGetAllUsersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersList(requestParameters: UsersApiGetAllUsersListRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListUser> {
            return localVarFp.getAllUsersList(requestParameters.ignoreDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyQR(options?: AxiosRequestConfig): AxiosPromise<OutputDTOString> {
            return localVarFp.getMyQR(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGetPrivilegedUserListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivilegedUserList(requestParameters: UsersApiGetPrivilegedUserListRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OutputDTOUserArray> {
            return localVarFp.getPrivilegedUserList(requestParameters.ignoreDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGetQRMediaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQRMedia(requestParameters: UsersApiGetQRMediaRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getQRMedia(requestParameters.dataUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGetUserListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserList(requestParameters: UsersApiGetUserListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListUser> {
            return localVarFp.getUserList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserListQuery(options?: AxiosRequestConfig): AxiosPromise<OutputDTOQueryFilterTemplateArray> {
            return localVarFp.getUserListQuery(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGetUserQRRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserQR(requestParameters: UsersApiGetUserQRRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOString> {
            return localVarFp.getUserQR(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiUpdateMyUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyUser(requestParameters: UsersApiUpdateMyUserRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.updateMyUser(requestParameters.updateMyUserBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiUpdateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(requestParameters: UsersApiUpdateUserRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.updateUser(requestParameters.id, requestParameters.updateUserBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiUpdateUserActivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserActivation(requestParameters: UsersApiUpdateUserActivationRequest, options?: AxiosRequestConfig): AxiosPromise<CreateRegisteredUser200Response> {
            return localVarFp.updateUserActivation(requestParameters.code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiUpdateUserLanguageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLanguage(requestParameters: UsersApiUpdateUserLanguageRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOString> {
            return localVarFp.updateUserLanguage(requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiUpdateUserPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword(requestParameters: UsersApiUpdateUserPasswordRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTO> {
            return localVarFp.updateUserPassword(requestParameters.email, requestParameters.updateUserPasswordBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createRegisteredUser operation in UsersApi.
 * @export
 * @interface UsersApiCreateRegisteredUserRequest
 */
export interface UsersApiCreateRegisteredUserRequest {
    /**
     * 
     * @type {CreateRegisteredUserBody}
     * @memberof UsersApiCreateRegisteredUser
     */
    readonly createRegisteredUserBody: CreateRegisteredUserBody
}

/**
 * Request parameters for createUser operation in UsersApi.
 * @export
 * @interface UsersApiCreateUserRequest
 */
export interface UsersApiCreateUserRequest {
    /**
     * 
     * @type {CreateUserBody}
     * @memberof UsersApiCreateUser
     */
    readonly createUserBody: CreateUserBody
}

/**
 * Request parameters for createUserPasswordChangeConfirmation operation in UsersApi.
 * @export
 * @interface UsersApiCreateUserPasswordChangeConfirmationRequest
 */
export interface UsersApiCreateUserPasswordChangeConfirmationRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiCreateUserPasswordChangeConfirmation
     */
    readonly email: string
}

/**
 * Request parameters for deleteUser operation in UsersApi.
 * @export
 * @interface UsersApiDeleteUserRequest
 */
export interface UsersApiDeleteUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiDeleteUser
     */
    readonly id: string
}

/**
 * Request parameters for getAllUsersList operation in UsersApi.
 * @export
 * @interface UsersApiGetAllUsersListRequest
 */
export interface UsersApiGetAllUsersListRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UsersApiGetAllUsersList
     */
    readonly ignoreDeleted?: boolean
}

/**
 * Request parameters for getPrivilegedUserList operation in UsersApi.
 * @export
 * @interface UsersApiGetPrivilegedUserListRequest
 */
export interface UsersApiGetPrivilegedUserListRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UsersApiGetPrivilegedUserList
     */
    readonly ignoreDeleted?: boolean
}

/**
 * Request parameters for getQRMedia operation in UsersApi.
 * @export
 * @interface UsersApiGetQRMediaRequest
 */
export interface UsersApiGetQRMediaRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiGetQRMedia
     */
    readonly dataUrl: string
}

/**
 * Request parameters for getUserList operation in UsersApi.
 * @export
 * @interface UsersApiGetUserListRequest
 */
export interface UsersApiGetUserListRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiGetUserList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof UsersApiGetUserList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof UsersApiGetUserList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetUserList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof UsersApiGetUserList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetUserList
     */
    readonly filters?: string
}

/**
 * Request parameters for getUserQR operation in UsersApi.
 * @export
 * @interface UsersApiGetUserQRRequest
 */
export interface UsersApiGetUserQRRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiGetUserQR
     */
    readonly id: string
}

/**
 * Request parameters for updateMyUser operation in UsersApi.
 * @export
 * @interface UsersApiUpdateMyUserRequest
 */
export interface UsersApiUpdateMyUserRequest {
    /**
     * 
     * @type {UpdateMyUserBody}
     * @memberof UsersApiUpdateMyUser
     */
    readonly updateMyUserBody: UpdateMyUserBody
}

/**
 * Request parameters for updateUser operation in UsersApi.
 * @export
 * @interface UsersApiUpdateUserRequest
 */
export interface UsersApiUpdateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiUpdateUser
     */
    readonly id: string

    /**
     * 
     * @type {UpdateUserBody}
     * @memberof UsersApiUpdateUser
     */
    readonly updateUserBody: UpdateUserBody
}

/**
 * Request parameters for updateUserActivation operation in UsersApi.
 * @export
 * @interface UsersApiUpdateUserActivationRequest
 */
export interface UsersApiUpdateUserActivationRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiUpdateUserActivation
     */
    readonly code: string
}

/**
 * Request parameters for updateUserLanguage operation in UsersApi.
 * @export
 * @interface UsersApiUpdateUserLanguageRequest
 */
export interface UsersApiUpdateUserLanguageRequest {
    /**
     * 
     * @type {'en' | 'tr'}
     * @memberof UsersApiUpdateUserLanguage
     */
    readonly language: UpdateUserLanguageLanguageEnum
}

/**
 * Request parameters for updateUserPassword operation in UsersApi.
 * @export
 * @interface UsersApiUpdateUserPasswordRequest
 */
export interface UsersApiUpdateUserPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiUpdateUserPassword
     */
    readonly email: string

    /**
     * 
     * @type {UpdateUserPasswordBody}
     * @memberof UsersApiUpdateUserPassword
     */
    readonly updateUserPasswordBody: UpdateUserPasswordBody
}

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {UsersApiCreateRegisteredUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createRegisteredUser(requestParameters: UsersApiCreateRegisteredUserRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).createRegisteredUser(requestParameters.createRegisteredUserBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createUser(requestParameters: UsersApiCreateUserRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).createUser(requestParameters.createUserBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiCreateUserPasswordChangeConfirmationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createUserPasswordChangeConfirmation(requestParameters: UsersApiCreateUserPasswordChangeConfirmationRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).createUserPasswordChangeConfirmation(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public deleteUser(requestParameters: UsersApiDeleteUserRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUser(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetAllUsersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getAllUsersList(requestParameters: UsersApiGetAllUsersListRequest = {}, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getAllUsersList(requestParameters.ignoreDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getMyQR(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getMyQR(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetPrivilegedUserListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getPrivilegedUserList(requestParameters: UsersApiGetPrivilegedUserListRequest = {}, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getPrivilegedUserList(requestParameters.ignoreDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetQRMediaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getQRMedia(requestParameters: UsersApiGetQRMediaRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getQRMedia(requestParameters.dataUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetUserListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserList(requestParameters: UsersApiGetUserListRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserListQuery(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserListQuery(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetUserQRRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserQR(requestParameters: UsersApiGetUserQRRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserQR(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiUpdateMyUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateMyUser(requestParameters: UsersApiUpdateMyUserRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateMyUser(requestParameters.updateMyUserBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUser(requestParameters: UsersApiUpdateUserRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUser(requestParameters.id, requestParameters.updateUserBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiUpdateUserActivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserActivation(requestParameters: UsersApiUpdateUserActivationRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserActivation(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiUpdateUserLanguageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserLanguage(requestParameters: UsersApiUpdateUserLanguageRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserLanguage(requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiUpdateUserPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserPassword(requestParameters: UsersApiUpdateUserPasswordRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserPassword(requestParameters.email, requestParameters.updateUserPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const UpdateUserLanguageLanguageEnum = {
    En: 'en',
    Tr: 'tr'
} as const;
export type UpdateUserLanguageLanguageEnum = typeof UpdateUserLanguageLanguageEnum[keyof typeof UpdateUserLanguageLanguageEnum];


/**
 * VouchersApi - axios parameter creator
 * @export
 */
export const VouchersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateVoucherBody} createVoucherBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoucher: async (createVoucherBody: CreateVoucherBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createVoucherBody' is not null or undefined
            assertParamExists('createVoucher', 'createVoucherBody', createVoucherBody)
            const localVarPath = `/api/voucher`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVoucherBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoucher: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteVoucher', 'id', id)
            const localVarPath = `/api/voucher`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoucher: async (id: string, ticketId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVoucher', 'id', id)
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('getVoucher', 'ticketId', ticketId)
            const localVarPath = `/api/voucher`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoucherList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getVoucherList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getVoucherList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getVoucherList', 'limit', limit)
            const localVarPath = `/api/voucher/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateVoucherLimitBody} updateVoucherLimitBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoucherLimit: async (id: string, updateVoucherLimitBody: UpdateVoucherLimitBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateVoucherLimit', 'id', id)
            // verify required parameter 'updateVoucherLimitBody' is not null or undefined
            assertParamExists('updateVoucherLimit', 'updateVoucherLimitBody', updateVoucherLimitBody)
            const localVarPath = `/api/voucher/limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVoucherLimitBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoucherTicket: async (id: string, ticketId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateVoucherTicket', 'id', id)
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('updateVoucherTicket', 'ticketId', ticketId)
            const localVarPath = `/api/voucher/ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateVoucherUsageBody} updateVoucherUsageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoucherUsage: async (id: string, updateVoucherUsageBody: UpdateVoucherUsageBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateVoucherUsage', 'id', id)
            // verify required parameter 'updateVoucherUsageBody' is not null or undefined
            assertParamExists('updateVoucherUsage', 'updateVoucherUsageBody', updateVoucherUsageBody)
            const localVarPath = `/api/voucher/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVoucherUsageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VouchersApi - functional programming interface
 * @export
 */
export const VouchersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VouchersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateVoucherBody} createVoucherBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVoucher(createVoucherBody: CreateVoucherBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOVoucher>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVoucher(createVoucherBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VouchersApi.createVoucher']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVoucher(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOVoucher>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVoucher(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VouchersApi.deleteVoucher']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoucher(id: string, ticketId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOVoucher>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoucher(id, ticketId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VouchersApi.getVoucher']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoucherList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListVoucher>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoucherList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VouchersApi.getVoucherList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateVoucherLimitBody} updateVoucherLimitBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVoucherLimit(id: string, updateVoucherLimitBody: UpdateVoucherLimitBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOVoucher>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVoucherLimit(id, updateVoucherLimitBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VouchersApi.updateVoucherLimit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVoucherTicket(id: string, ticketId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOVoucher>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVoucherTicket(id, ticketId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VouchersApi.updateVoucherTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateVoucherUsageBody} updateVoucherUsageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVoucherUsage(id: string, updateVoucherUsageBody: UpdateVoucherUsageBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOVoucher>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVoucherUsage(id, updateVoucherUsageBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['VouchersApi.updateVoucherUsage']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * VouchersApi - factory interface
 * @export
 */
export const VouchersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VouchersApiFp(configuration)
    return {
        /**
         * 
         * @param {VouchersApiCreateVoucherRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoucher(requestParameters: VouchersApiCreateVoucherRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOVoucher> {
            return localVarFp.createVoucher(requestParameters.createVoucherBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VouchersApiDeleteVoucherRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoucher(requestParameters: VouchersApiDeleteVoucherRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOVoucher> {
            return localVarFp.deleteVoucher(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VouchersApiGetVoucherRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoucher(requestParameters: VouchersApiGetVoucherRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOVoucher> {
            return localVarFp.getVoucher(requestParameters.id, requestParameters.ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VouchersApiGetVoucherListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoucherList(requestParameters: VouchersApiGetVoucherListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListVoucher> {
            return localVarFp.getVoucherList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VouchersApiUpdateVoucherLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoucherLimit(requestParameters: VouchersApiUpdateVoucherLimitRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOVoucher> {
            return localVarFp.updateVoucherLimit(requestParameters.id, requestParameters.updateVoucherLimitBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VouchersApiUpdateVoucherTicketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoucherTicket(requestParameters: VouchersApiUpdateVoucherTicketRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOVoucher> {
            return localVarFp.updateVoucherTicket(requestParameters.id, requestParameters.ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VouchersApiUpdateVoucherUsageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoucherUsage(requestParameters: VouchersApiUpdateVoucherUsageRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOVoucher> {
            return localVarFp.updateVoucherUsage(requestParameters.id, requestParameters.updateVoucherUsageBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createVoucher operation in VouchersApi.
 * @export
 * @interface VouchersApiCreateVoucherRequest
 */
export interface VouchersApiCreateVoucherRequest {
    /**
     * 
     * @type {CreateVoucherBody}
     * @memberof VouchersApiCreateVoucher
     */
    readonly createVoucherBody: CreateVoucherBody
}

/**
 * Request parameters for deleteVoucher operation in VouchersApi.
 * @export
 * @interface VouchersApiDeleteVoucherRequest
 */
export interface VouchersApiDeleteVoucherRequest {
    /**
     * 
     * @type {string}
     * @memberof VouchersApiDeleteVoucher
     */
    readonly id: string
}

/**
 * Request parameters for getVoucher operation in VouchersApi.
 * @export
 * @interface VouchersApiGetVoucherRequest
 */
export interface VouchersApiGetVoucherRequest {
    /**
     * 
     * @type {string}
     * @memberof VouchersApiGetVoucher
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof VouchersApiGetVoucher
     */
    readonly ticketId: string
}

/**
 * Request parameters for getVoucherList operation in VouchersApi.
 * @export
 * @interface VouchersApiGetVoucherListRequest
 */
export interface VouchersApiGetVoucherListRequest {
    /**
     * 
     * @type {string}
     * @memberof VouchersApiGetVoucherList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof VouchersApiGetVoucherList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof VouchersApiGetVoucherList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof VouchersApiGetVoucherList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof VouchersApiGetVoucherList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof VouchersApiGetVoucherList
     */
    readonly filters?: string
}

/**
 * Request parameters for updateVoucherLimit operation in VouchersApi.
 * @export
 * @interface VouchersApiUpdateVoucherLimitRequest
 */
export interface VouchersApiUpdateVoucherLimitRequest {
    /**
     * 
     * @type {string}
     * @memberof VouchersApiUpdateVoucherLimit
     */
    readonly id: string

    /**
     * 
     * @type {UpdateVoucherLimitBody}
     * @memberof VouchersApiUpdateVoucherLimit
     */
    readonly updateVoucherLimitBody: UpdateVoucherLimitBody
}

/**
 * Request parameters for updateVoucherTicket operation in VouchersApi.
 * @export
 * @interface VouchersApiUpdateVoucherTicketRequest
 */
export interface VouchersApiUpdateVoucherTicketRequest {
    /**
     * 
     * @type {string}
     * @memberof VouchersApiUpdateVoucherTicket
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof VouchersApiUpdateVoucherTicket
     */
    readonly ticketId: string
}

/**
 * Request parameters for updateVoucherUsage operation in VouchersApi.
 * @export
 * @interface VouchersApiUpdateVoucherUsageRequest
 */
export interface VouchersApiUpdateVoucherUsageRequest {
    /**
     * 
     * @type {string}
     * @memberof VouchersApiUpdateVoucherUsage
     */
    readonly id: string

    /**
     * 
     * @type {UpdateVoucherUsageBody}
     * @memberof VouchersApiUpdateVoucherUsage
     */
    readonly updateVoucherUsageBody: UpdateVoucherUsageBody
}

/**
 * VouchersApi - object-oriented interface
 * @export
 * @class VouchersApi
 * @extends {BaseAPI}
 */
export class VouchersApi extends BaseAPI {
    /**
     * 
     * @param {VouchersApiCreateVoucherRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public createVoucher(requestParameters: VouchersApiCreateVoucherRequest, options?: AxiosRequestConfig) {
        return VouchersApiFp(this.configuration).createVoucher(requestParameters.createVoucherBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VouchersApiDeleteVoucherRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public deleteVoucher(requestParameters: VouchersApiDeleteVoucherRequest, options?: AxiosRequestConfig) {
        return VouchersApiFp(this.configuration).deleteVoucher(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VouchersApiGetVoucherRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public getVoucher(requestParameters: VouchersApiGetVoucherRequest, options?: AxiosRequestConfig) {
        return VouchersApiFp(this.configuration).getVoucher(requestParameters.id, requestParameters.ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VouchersApiGetVoucherListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public getVoucherList(requestParameters: VouchersApiGetVoucherListRequest, options?: AxiosRequestConfig) {
        return VouchersApiFp(this.configuration).getVoucherList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VouchersApiUpdateVoucherLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public updateVoucherLimit(requestParameters: VouchersApiUpdateVoucherLimitRequest, options?: AxiosRequestConfig) {
        return VouchersApiFp(this.configuration).updateVoucherLimit(requestParameters.id, requestParameters.updateVoucherLimitBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VouchersApiUpdateVoucherTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public updateVoucherTicket(requestParameters: VouchersApiUpdateVoucherTicketRequest, options?: AxiosRequestConfig) {
        return VouchersApiFp(this.configuration).updateVoucherTicket(requestParameters.id, requestParameters.ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VouchersApiUpdateVoucherUsageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VouchersApi
     */
    public updateVoucherUsage(requestParameters: VouchersApiUpdateVoucherUsageRequest, options?: AxiosRequestConfig) {
        return VouchersApiFp(this.configuration).updateVoucherUsage(requestParameters.id, requestParameters.updateVoucherUsageBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebhookApi - axios parameter creator
 * @export
 */
export const WebhookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateWebhookBody} createWebhookBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebhook: async (createWebhookBody: CreateWebhookBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWebhookBody' is not null or undefined
            assertParamExists('createWebhook', 'createWebhookBody', createWebhookBody)
            const localVarPath = `/api/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWebhookBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebhook: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWebhook', 'id', id)
            const localVarPath = `/api/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhook: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWebhook', 'id', id)
            const localVarPath = `/api/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getWebhookList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getWebhookList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getWebhookList', 'limit', limit)
            const localVarPath = `/api/webhook/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookLogList: async (search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getWebhookLogList', 'search', search)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getWebhookLogList', 'skip', skip)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getWebhookLogList', 'limit', limit)
            const localVarPath = `/api/webhook/log/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateWebhookBody} updateWebhookBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWebhook: async (id: string, updateWebhookBody: UpdateWebhookBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWebhook', 'id', id)
            // verify required parameter 'updateWebhookBody' is not null or undefined
            assertParamExists('updateWebhook', 'updateWebhookBody', updateWebhookBody)
            const localVarPath = `/api/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWebhookBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhookApi - functional programming interface
 * @export
 */
export const WebhookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhookApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateWebhookBody} createWebhookBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWebhook(createWebhookBody: CreateWebhookBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOWebhook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWebhook(createWebhookBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['WebhookApi.createWebhook']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWebhook(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOWebhook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWebhook(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['WebhookApi.deleteWebhook']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhook(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOWebhook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhook(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['WebhookApi.getWebhook']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhookList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListWebhook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhookList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['WebhookApi.getWebhookList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {number} skip 
         * @param {number} limit 
         * @param {string} [sortField] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [filters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhookLogList(search: string, skip: number, limit: number, sortField?: string, sortDirection?: SortDirection, filters?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOPaginatedListWebhookLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhookLogList(search, skip, limit, sortField, sortDirection, filters, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['WebhookApi.getWebhookLogList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateWebhookBody} updateWebhookBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWebhook(id: string, updateWebhookBody: UpdateWebhookBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutputDTOWebhook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWebhook(id, updateWebhookBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['WebhookApi.updateWebhook']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * WebhookApi - factory interface
 * @export
 */
export const WebhookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhookApiFp(configuration)
    return {
        /**
         * 
         * @param {WebhookApiCreateWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebhook(requestParameters: WebhookApiCreateWebhookRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOWebhook> {
            return localVarFp.createWebhook(requestParameters.createWebhookBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebhookApiDeleteWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebhook(requestParameters: WebhookApiDeleteWebhookRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOWebhook> {
            return localVarFp.deleteWebhook(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebhookApiGetWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhook(requestParameters: WebhookApiGetWebhookRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOWebhook> {
            return localVarFp.getWebhook(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebhookApiGetWebhookListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookList(requestParameters: WebhookApiGetWebhookListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListWebhook> {
            return localVarFp.getWebhookList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebhookApiGetWebhookLogListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookLogList(requestParameters: WebhookApiGetWebhookLogListRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOPaginatedListWebhookLog> {
            return localVarFp.getWebhookLogList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebhookApiUpdateWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWebhook(requestParameters: WebhookApiUpdateWebhookRequest, options?: AxiosRequestConfig): AxiosPromise<OutputDTOWebhook> {
            return localVarFp.updateWebhook(requestParameters.id, requestParameters.updateWebhookBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createWebhook operation in WebhookApi.
 * @export
 * @interface WebhookApiCreateWebhookRequest
 */
export interface WebhookApiCreateWebhookRequest {
    /**
     * 
     * @type {CreateWebhookBody}
     * @memberof WebhookApiCreateWebhook
     */
    readonly createWebhookBody: CreateWebhookBody
}

/**
 * Request parameters for deleteWebhook operation in WebhookApi.
 * @export
 * @interface WebhookApiDeleteWebhookRequest
 */
export interface WebhookApiDeleteWebhookRequest {
    /**
     * 
     * @type {string}
     * @memberof WebhookApiDeleteWebhook
     */
    readonly id: string
}

/**
 * Request parameters for getWebhook operation in WebhookApi.
 * @export
 * @interface WebhookApiGetWebhookRequest
 */
export interface WebhookApiGetWebhookRequest {
    /**
     * 
     * @type {string}
     * @memberof WebhookApiGetWebhook
     */
    readonly id: string
}

/**
 * Request parameters for getWebhookList operation in WebhookApi.
 * @export
 * @interface WebhookApiGetWebhookListRequest
 */
export interface WebhookApiGetWebhookListRequest {
    /**
     * 
     * @type {string}
     * @memberof WebhookApiGetWebhookList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof WebhookApiGetWebhookList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof WebhookApiGetWebhookList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof WebhookApiGetWebhookList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof WebhookApiGetWebhookList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof WebhookApiGetWebhookList
     */
    readonly filters?: string
}

/**
 * Request parameters for getWebhookLogList operation in WebhookApi.
 * @export
 * @interface WebhookApiGetWebhookLogListRequest
 */
export interface WebhookApiGetWebhookLogListRequest {
    /**
     * 
     * @type {string}
     * @memberof WebhookApiGetWebhookLogList
     */
    readonly search: string

    /**
     * 
     * @type {number}
     * @memberof WebhookApiGetWebhookLogList
     */
    readonly skip: number

    /**
     * 
     * @type {number}
     * @memberof WebhookApiGetWebhookLogList
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof WebhookApiGetWebhookLogList
     */
    readonly sortField?: string

    /**
     * 
     * @type {SortDirection}
     * @memberof WebhookApiGetWebhookLogList
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof WebhookApiGetWebhookLogList
     */
    readonly filters?: string
}

/**
 * Request parameters for updateWebhook operation in WebhookApi.
 * @export
 * @interface WebhookApiUpdateWebhookRequest
 */
export interface WebhookApiUpdateWebhookRequest {
    /**
     * 
     * @type {string}
     * @memberof WebhookApiUpdateWebhook
     */
    readonly id: string

    /**
     * 
     * @type {UpdateWebhookBody}
     * @memberof WebhookApiUpdateWebhook
     */
    readonly updateWebhookBody: UpdateWebhookBody
}

/**
 * WebhookApi - object-oriented interface
 * @export
 * @class WebhookApi
 * @extends {BaseAPI}
 */
export class WebhookApi extends BaseAPI {
    /**
     * 
     * @param {WebhookApiCreateWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    public createWebhook(requestParameters: WebhookApiCreateWebhookRequest, options?: AxiosRequestConfig) {
        return WebhookApiFp(this.configuration).createWebhook(requestParameters.createWebhookBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebhookApiDeleteWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    public deleteWebhook(requestParameters: WebhookApiDeleteWebhookRequest, options?: AxiosRequestConfig) {
        return WebhookApiFp(this.configuration).deleteWebhook(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebhookApiGetWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    public getWebhook(requestParameters: WebhookApiGetWebhookRequest, options?: AxiosRequestConfig) {
        return WebhookApiFp(this.configuration).getWebhook(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebhookApiGetWebhookListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    public getWebhookList(requestParameters: WebhookApiGetWebhookListRequest, options?: AxiosRequestConfig) {
        return WebhookApiFp(this.configuration).getWebhookList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebhookApiGetWebhookLogListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    public getWebhookLogList(requestParameters: WebhookApiGetWebhookLogListRequest, options?: AxiosRequestConfig) {
        return WebhookApiFp(this.configuration).getWebhookLogList(requestParameters.search, requestParameters.skip, requestParameters.limit, requestParameters.sortField, requestParameters.sortDirection, requestParameters.filters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebhookApiUpdateWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    public updateWebhook(requestParameters: WebhookApiUpdateWebhookRequest, options?: AxiosRequestConfig) {
        return WebhookApiFp(this.configuration).updateWebhook(requestParameters.id, requestParameters.updateWebhookBody, options).then((request) => request(this.axios, this.basePath));
    }
}



